var Handlebars = require('handlebars');
var template = Handlebars.template,
    templates = (Handlebars.templates = Handlebars.templates || {});
templates['about'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return 'modalLabel';
    },
    '3': function (container, depth0, helpers, partials, data) {
        return 'modalModalLabel';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div class="modal-content" name="modalContent">\n            <div class="modal-header">\n                <h1 class="modal-title" id="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'modalModal') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(3, data, 0),
                data: data,
                loc: { start: { line: 3, column: 44 }, end: { line: 3, column: 110 } }
            })) != null
                ? stack1
                : '') +
            '">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'aboutLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 3, column: 112 }, end: { line: 3, column: 133 } }
                })
            ) +
            '</h1>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'closeButton'), depth0, {
                name: 'closeButton',
                hash: { lastTab: true },
                data: data,
                indent: '                ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="modal-body">\n                    ' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'aboutHB101PlacesText', {
                name: 'l10n',
                hash: {},
                data: data,
                loc: { start: { line: 7, column: 20 }, end: { line: 7, column: 53 } }
            })) != null
                ? stack1
                : '') +
            '\n            </div>\n            <div class="sr-only">End of dialog</div>\n        </div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['addressAutocomplete'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        return '<label for="addressSearch" class="mr-2 ml-2">Search</label>\n<input name="addressSearch" id="pac-input" class="form-control col-5" type="text" placeholder="Enter a location...">\n';
    },
    useData: true
});
templates['addressLine'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'address1') || (depth0 != null ? lookupProperty(depth0, 'address1') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'address1', hash: {}, data: data, loc: { start: { line: 1, column: 16 }, end: { line: 1, column: 28 } } })
                    : helper)
            ) +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'address2') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(2, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 28 }, end: { line: 1, column: 60 } }
            })) != null
                ? stack1
                : '') +
            ' '
        );
    },
    '2': function (container, depth0, helpers, partials, data) {
        return ',';
    },
    '4': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'address2') || (depth0 != null ? lookupProperty(depth0, 'address2') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'address2',
                          hash: {},
                          data: data,
                          loc: { start: { line: 1, column: 84 }, end: { line: 1, column: 96 } }
                      })
                    : helper)
            ) + ', '
        );
    },
    '6': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'city') || (depth0 != null ? lookupProperty(depth0, 'city') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'city',
                          hash: {},
                          data: data,
                          loc: { start: { line: 1, column: 117 }, end: { line: 1, column: 125 } }
                      })
                    : helper)
            ) + ', '
        );
    },
    '8': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'state') || (depth0 != null ? lookupProperty(depth0, 'state') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'state',
                          hash: {},
                          data: data,
                          loc: { start: { line: 1, column: 147 }, end: { line: 1, column: 156 } }
                      })
                    : helper)
            ) + ', '
        );
    },
    '10': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return container.escapeExpression(
            ((helper =
                (helper = lookupProperty(helpers, 'zip') || (depth0 != null ? lookupProperty(depth0, 'zip') : depth0)) != null
                    ? helper
                    : container.hooks.helperMissing),
            typeof helper === 'function'
                ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                      name: 'zip',
                      hash: {},
                      data: data,
                      loc: { start: { line: 1, column: 176 }, end: { line: 1, column: 183 } }
                  })
                : helper)
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'address1') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 68 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'address2') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(4, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 68 }, end: { line: 1, column: 105 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'city') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(6, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 105 }, end: { line: 1, column: 134 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'state') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(8, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 134 }, end: { line: 1, column: 165 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'zip') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(10, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 165 }, end: { line: 1, column: 190 } }
            })) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    useData: true
});
templates['administrators'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        return '<div name="contactsList"></div>\n';
    },
    useData: true
});
templates['checkbox'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="custom-control custom-checkbox">\n    <input type="checkbox" class="custom-control-input" id="g' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'groupId') || (depth0 != null ? lookupProperty(depth0, 'groupId') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'groupId', hash: {}, data: data, loc: { start: { line: 3, column: 61 }, end: { line: 3, column: 72 } } })
                    : helper)
            ) +
            '_' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 3, column: 73 }, end: { line: 3, column: 81 } } })
                    : helper)
            ) +
            '_' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 3, column: 82 }, end: { line: 3, column: 88 } } })
                    : helper)
            ) +
            '" name="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 3, column: 96 }, end: { line: 3, column: 104 } } })
                    : helper)
            ) +
            '" data-id="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 3, column: 115 }, end: { line: 3, column: 121 } } })
                    : helper)
            ) +
            '" value="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 3, column: 130 }, end: { line: 3, column: 136 } } })
                    : helper)
            ) +
            '"' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'checked') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(2, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 3, column: 137 }, end: { line: 3, column: 167 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'required') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(4, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 3, column: 167 }, end: { line: 3, column: 199 } }
            })) != null
                ? stack1
                : '') +
            '>\n    <label class="custom-control-label" for="g' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'groupId') || (depth0 != null ? lookupProperty(depth0, 'groupId') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'groupId', hash: {}, data: data, loc: { start: { line: 4, column: 46 }, end: { line: 4, column: 57 } } })
                    : helper)
            ) +
            '_' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 4, column: 58 }, end: { line: 4, column: 66 } } })
                    : helper)
            ) +
            '_' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 4, column: 67 }, end: { line: 4, column: 73 } } })
                    : helper)
            ) +
            '">' +
            ((stack1 =
                ((helper =
                    (helper = lookupProperty(helpers, 'label') || (depth0 != null ? lookupProperty(depth0, 'label') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'label', hash: {}, data: data, loc: { start: { line: 4, column: 75 }, end: { line: 4, column: 86 } } })
                    : helper)) != null
                ? stack1
                : '') +
            '</label>\n</div>\n'
        );
    },
    '2': function (container, depth0, helpers, partials, data) {
        return ' checked';
    },
    '4': function (container, depth0, helpers, partials, data) {
        return ' required';
    },
    '6': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<input type="checkbox" class="hidden" name="' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'name',
                          hash: {},
                          data: data,
                          loc: { start: { line: 8, column: 44 }, end: { line: 8, column: 52 } }
                      })
                    : helper)
            ) +
            '" data-id="-1" value="-1" checked >\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'unless').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'noSelectionSentry') : depth0,
            {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(6, data, 0),
                data: data,
                loc: { start: { line: 1, column: 0 }, end: { line: 9, column: 11 } }
            }
        )) != null
            ? stack1
            : '';
    },
    useData: true
});
templates['closeButton'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return ' hidden';
    },
    '3': function (container, depth0, helpers, partials, data) {
        return 'cancel';
    },
    '5': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return container.escapeExpression(
            ((helper =
                (helper = lookupProperty(helpers, 'action') || (depth0 != null ? lookupProperty(depth0, 'action') : depth0)) != null
                    ? helper
                    : container.hooks.helperMissing),
            typeof helper === 'function'
                ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                      name: 'action',
                      hash: {},
                      data: data,
                      loc: { start: { line: 3, column: 49 }, end: { line: 3, column: 59 } }
                  })
                : helper)
        );
    },
    '7': function (container, depth0, helpers, partials, data) {
        return 'data-tab-position="last"';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<button\n    class="btn btn-close float-right' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'hidden') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 2, column: 36 }, end: { line: 2, column: 64 } }
            })) != null
                ? stack1
                : '') +
            '"\n    data-action="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'action') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.program(5, data, 0),
                data: data,
                loc: { start: { line: 3, column: 17 }, end: { line: 3, column: 70 } }
            })) != null
                ? stack1
                : '') +
            '"\n    data-dismiss="modal"\n    aria-label="Close"\n    alt="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonClose', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 6, column: 9 }, end: { line: 6, column: 31 } }
                })
            ) +
            '"\n    title="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonClose', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 7, column: 11 }, end: { line: 7, column: 33 } }
                })
            ) +
            '"\n    ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'lastTab') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(7, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 8, column: 4 }, end: { line: 8, column: 50 } }
            })) != null
                ? stack1
                : '') +
            '\n></button>\n'
        );
    },
    useData: true
});
templates['comingSoon'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return 'modalLabel';
    },
    '3': function (container, depth0, helpers, partials, data) {
        return 'modalModalLabel';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div class="modal-content" name="modalContent">\n            <div class="modal-header">\n                <h1 class="modal-title" id="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'modalModal') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(3, data, 0),
                data: data,
                loc: { start: { line: 3, column: 44 }, end: { line: 3, column: 110 } }
            })) != null
                ? stack1
                : '') +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'comingSoonLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 3, column: 112 }, end: { line: 3, column: 138 } }
                })
            ) +
            '</h1>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'closeButton'), depth0, {
                name: 'closeButton',
                hash: { lastTab: true },
                data: data,
                indent: '                ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="modal-body">\n                    ' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'comingSoonText', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 7, column: 20 }, end: { line: 7, column: 45 } }
                })
            ) +
            '\n            </div>\n            <div class="sr-only">End of dialog</div>\n        </div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['console'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        return '';
    },
    useData: true
});
templates['contactEdit'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'unless').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'administratorContact') : depth0,
            {
                name: 'unless',
                hash: {},
                fn: container.program(2, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 4, column: 0 }, end: { line: 10, column: 11 } }
            }
        )) != null
            ? stack1
            : '';
    },
    '2': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '        <div class="col-12 col-md-6 col-lg-4 mb-2">\n            <label for="contactEditExisting">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    'existingContactsLabel',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 6, column: 45 }, end: { line: 6, column: 77 } } }
                )
            ) +
            '</label>\n            <select id="contactEditExisting" name="existingContactId" class="custom-select" size="5">\n            </select>\n        </div>\n'
        );
    },
    '4': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'unless').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'administratorContact') : depth0,
            {
                name: 'unless',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.program(7, data, 0),
                data: data,
                loc: { start: { line: 13, column: 4 }, end: { line: 17, column: 15 } }
            }
        )) != null
            ? stack1
            : '';
    },
    '5': function (container, depth0, helpers, partials, data) {
        return '        <div class="col-12 col-md-6 col-lg-8">\n';
    },
    '7': function (container, depth0, helpers, partials, data) {
        return '        <div class="col-12">\n';
    },
    '9': function (container, depth0, helpers, partials, data) {
        return 'contactEmail';
    },
    '11': function (container, depth0, helpers, partials, data) {
        return 'email';
    },
    '13': function (container, depth0, helpers, partials, data) {
        return 'readonly="true"';
    },
    '15': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'unless').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'administratorContact') : depth0,
            {
                name: 'unless',
                hash: {},
                fn: container.program(16, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 30, column: 12 }, end: { line: 42, column: 23 } }
            }
        )) != null
            ? stack1
            : '';
    },
    '16': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <label>' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(alias1, 'roleLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 31, column: 27 }, end: { line: 31, column: 47 } }
                })
            ) +
            '</label>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'organizationContact') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(17, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 32, column: 16 }, end: { line: 36, column: 23 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'programContact') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(19, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 37, column: 16 }, end: { line: 41, column: 23 } }
            })) != null
                ? stack1
                : '')
        );
    },
    '17': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <div class="input-group">\n                        ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                {
                    name: 'enum_select',
                    hash: {
                        disabled: depth0 != null ? lookupProperty(depth0, 'primaryContact') : depth0,
                        selected: depth0 != null ? lookupProperty(depth0, 'organizationRoleTypeId') : depth0,
                        compact: true,
                        property: 'organizationRoleTypeId'
                    },
                    data: data,
                    loc: { start: { line: 34, column: 24 }, end: { line: 34, column: 144 } }
                }
            )) != null
                ? stack1
                : '') +
            '\n                    </div>\n'
        );
    },
    '19': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <div class="input-group">\n                        ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                {
                    name: 'enum_select',
                    hash: {
                        disabled: depth0 != null ? lookupProperty(depth0, 'primaryContact') : depth0,
                        selected: depth0 != null ? lookupProperty(depth0, 'programRoleTypeId') : depth0,
                        compact: true,
                        property: 'programRoleTypeId'
                    },
                    data: data,
                    loc: { start: { line: 39, column: 24 }, end: { line: 39, column: 134 } }
                }
            )) != null
                ? stack1
                : '') +
            '\n                    </div>\n'
        );
    },
    '21': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                <div class="col-12 col-md-4 order-1 order-md-3 mt-2 text-right">\n                    <button name="cancel" class="btn btn-edit" data-action="cancel" data-section="image">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonCancel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 47, column: 105 }, end: { line: 47, column: 128 } }
                })
            ) +
            '</button>\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(22, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 48, column: 16 }, end: { line: 50, column: 27 } }
            })) != null
                ? stack1
                : '') +
            '                    <button name="save" class="btn btn-edit btn-primary" data-action="save" data-section="image" disabled="disabled">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonSave', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 51, column: 133 }, end: { line: 51, column: 154 } }
                })
            ) +
            '</button>\n                </div>\n'
        );
    },
    '22': function (container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <button name="delete" class="btn btn-edit" data-action="delete" data-section="image" data-id="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'contactEmail') || (depth0 != null ? lookupProperty(depth0, 'contactEmail') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === 'function'
                    ? helper.call(alias1, {
                          name: 'contactEmail',
                          hash: {},
                          data: data,
                          loc: { start: { line: 49, column: 114 }, end: { line: 49, column: 130 } }
                      })
                    : helper)
            ) +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonDelete', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 49, column: 132 }, end: { line: 49, column: 155 } }
                })
            ) +
            '</button>\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            alias4 = 'function',
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<form name="contact" class="form-compact needs-validation" role="form" novalidate>\n    <div class="row">\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 3, column: 0 }, end: { line: 11, column: 7 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(4, data, 0),
                inverse: container.program(7, data, 0),
                data: data,
                loc: { start: { line: 12, column: 0 }, end: { line: 20, column: 7 } }
            })) != null
                ? stack1
                : '') +
            '            <div class="form-row align-items-center">\n                <div class="form-group col-12 col-sm-6 col-md-4 order-2 order-md-1">\n                    <label>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'emailLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 24, column: 27 }, end: { line: 24, column: 48 } }
                })
            ) +
            '</label>\n                    <input class="form-control" name="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(9, data, 0),
                inverse: container.program(11, data, 0),
                data: data,
                loc: { start: { line: 25, column: 54 }, end: { line: 25, column: 108 } }
            })) != null
                ? stack1
                : '') +
            '" pattern="[^@\\s]+@[^@\\s]+\\.[^@\\s]+" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'contactEmail') || (depth0 != null ? lookupProperty(depth0, 'contactEmail') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'contactEmail',
                          hash: {},
                          data: data,
                          loc: { start: { line: 25, column: 152 }, end: { line: 25, column: 168 } }
                      })
                    : helper)
            ) +
            '" ' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(13, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 25, column: 170 }, end: { line: 25, column: 214 } }
            })) != null
                ? stack1
                : '') +
            ' required />\n                    <div class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'emailInvalidFeedback', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 26, column: 50 }, end: { line: 26, column: 81 } }
                })
            ) +
            '</div>\n                </div>\n                <div class="form-group col-12 col-sm-6 col-md-4 order-3 order-md-2">\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(15, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 29, column: 8 }, end: { line: 43, column: 15 } }
            })) != null
                ? stack1
                : '') +
            '                </div>\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'primaryContact') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(21, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 45, column: 12 }, end: { line: 53, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '                <div class="hidden">\n                    <input type="text" name="id" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'contactEmail') || (depth0 != null ? lookupProperty(depth0, 'contactEmail') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'contactEmail',
                          hash: {},
                          data: data,
                          loc: { start: { line: 55, column: 56 }, end: { line: 55, column: 72 } }
                      })
                    : helper)
            ) +
            '" />\n                </div>\n            </div>\n            <div class="form-row align-items-center">\n                <div class="form-group col-6 col-lg-4">\n                    <label>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'firstNameLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 60, column: 27 }, end: { line: 60, column: 52 } }
                })
            ) +
            '</label>\n                    <input type="text" class="form-control" name="first" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'first') || (depth0 != null ? lookupProperty(depth0, 'first') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'first', hash: {}, data: data, loc: { start: { line: 61, column: 80 }, end: { line: 61, column: 89 } } })
                    : helper)
            ) +
            '" required />\n                    <div class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'requiredInvalidFeedback', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 62, column: 50 }, end: { line: 62, column: 84 } }
                })
            ) +
            '</div>\n                </div>\n                <div class="form-group col-6 col-lg-4">\n                    <label>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'lastNameLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 65, column: 27 }, end: { line: 65, column: 51 } }
                })
            ) +
            '</label>\n                    <input type="text" class="form-control" name="last" value="' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'last') || (depth0 != null ? lookupProperty(depth0, 'last') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'last', hash: {}, data: data, loc: { start: { line: 66, column: 79 }, end: { line: 66, column: 87 } } })
                    : helper)
            ) +
            '" required />\n                    <div class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'requiredInvalidFeedback', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 67, column: 50 }, end: { line: 67, column: 84 } }
                })
            ) +
            '</div>\n                </div>\n                <div class="form-group col-12 col-lg-4">\n                    <label>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'titleLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 70, column: 27 }, end: { line: 70, column: 48 } }
                })
            ) +
            '</label>\n                    <input type="text" class="form-control" name="title" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'title') || (depth0 != null ? lookupProperty(depth0, 'title') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'title', hash: {}, data: data, loc: { start: { line: 71, column: 80 }, end: { line: 71, column: 89 } } })
                    : helper)
            ) +
            '" />\n                </div>\n            </div>\n            <div class="form-row align-items-center">\n                <div class="form-group col-12 col-lg-4">\n                    <label>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'phoneLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 76, column: 27 }, end: { line: 76, column: 48 } }
                })
            ) +
            '</label>\n                    <input type="text" class="form-control" name="phoneNumbersOnly" value="' +
            alias3(
                (lookupProperty(helpers, 'telephone') || (depth0 && lookupProperty(depth0, 'telephone')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'phoneNumbersOnly') : depth0,
                    { name: 'telephone', hash: {}, data: data, loc: { start: { line: 77, column: 91 }, end: { line: 77, column: 121 } } }
                )
            ) +
            '" pattern="' +
            ((stack1 = (lookupProperty(helpers, 'pattern') || (depth0 && lookupProperty(depth0, 'pattern')) || alias2).call(alias1, 'phone', {
                name: 'pattern',
                hash: {},
                data: data,
                loc: { start: { line: 77, column: 132 }, end: { line: 77, column: 153 } }
            })) != null
                ? stack1
                : '') +
            '" required />\n                    <div class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'phoneInvalidFeedback', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 78, column: 50 }, end: { line: 78, column: 81 } }
                })
            ) +
            '</div>\n                </div>\n            </div>\n\n        </div>\n    </div>\n</form>\n'
        );
    },
    useData: true
});
templates['contactsList'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<!-- <div name="contacts"></div> -->\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: {
                    addable: true,
                    editable: false,
                    name: 'contactsList',
                    display: depth0 != null ? lookupProperty(depth0, 'display') : depth0,
                    title: depth0 != null ? lookupProperty(depth0, 'title') : depth0
                },
                data: data,
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '<div name="table"></div>\n\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['container'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div name="screen-reader-links">\n    <a class="sr-only" href="#filters" tabindex="0">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'jumpToFilters', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 2, column: 52 }, end: { line: 2, column: 76 } }
                })
            ) +
            '</a>\n    <a class="sr-only" href="#results" tabindex="0">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'jumpToResults', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 3, column: 52 }, end: { line: 3, column: 76 } }
                })
            ) +
            '</a>\n</div>\n<div name="contexts"></div>\n<div name="header"></div>\n<div name="programs"></div>\n<div name="dashboard"></div>\n<div name="programDetailsPopout"></div>\n<!-- <div name="footer"></div> -->\n<div name="bottom" class="iframe-marker" data-iframe-height="1"></div>\n'
        );
    },
    useData: true
});
templates['contentNotFound'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            'Content not found... (' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'missingTemplate') || (depth0 != null ? lookupProperty(depth0, 'missingTemplate') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'missingTemplate',
                          hash: {},
                          data: data,
                          loc: { start: { line: 1, column: 22 }, end: { line: 1, column: 41 } }
                      })
                    : helper)
            ) +
            ')'
        );
    },
    useData: true
});
templates['contexts'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return '			<button class="btn btn-sm btn-link pr-0" data-action="signIn" >Sign in</button>\n';
    },
    '3': function (container, depth0, helpers, partials, data) {
        return '			<button class="btn btn-sm btn-link" data-action="signOut" >Sign out</button>\n';
    },
    '5': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '			<div class="user-name">' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'userNameRoles') || (depth0 != null ? lookupProperty(depth0, 'userNameRoles') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'userNameRoles',
                          hash: {},
                          data: data,
                          loc: { start: { line: 22, column: 26 }, end: { line: 22, column: 43 } }
                      })
                    : helper)
            ) +
            '</div>\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<form class="col form-compact">\n	<div class="form-row justify-content-end align-items-center mb-2">\n		<div class="col-auto">\n			<label class="sr-only" >Name</label>\n			<input type="text" class="form-control mb-0" name="userName" placeholder="username" value="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'userName') || (depth0 != null ? lookupProperty(depth0, 'userName') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'userName', hash: {}, data: data, loc: { start: { line: 5, column: 94 }, end: { line: 5, column: 106 } } })
                    : helper)
            ) +
            '">\n			</div>\n		<div class="col-auto">\n			<label class="sr-only">Password</label>\n			<div class="input-group">\n				<input type="password" class="form-control mb-0" name="password" placeholder="password" value="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'password') || (depth0 != null ? lookupProperty(depth0, 'password') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'password', hash: {}, data: data, loc: { start: { line: 10, column: 99 }, end: { line: 10, column: 111 } } })
                    : helper)
            ) +
            '">\n				</div>\n			</div>\n		<div class="col-auto">\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'signedIn') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(3, data, 0),
                data: data,
                loc: { start: { line: 14, column: 3 }, end: { line: 18, column: 14 } }
            })) != null
                ? stack1
                : '') +
            '			</div>\n		<div class="col-auto">\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'signedIn') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 21, column: 3 }, end: { line: 23, column: 10 } }
            })) != null
                ? stack1
                : '') +
            '			</div>\n		</div>\n</form>\n'
        );
    },
    useData: true
});
templates['dashboard'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        return '<aside class="col-12 col-md-2 pr-sm-0">\n    <div name="dashboardSidebarMenu"></div>\n</aside>\n<main class="col-12 col-md-10">\n    <div name="administrators"></div>\n    <div name="organizations"></div>\n    <div name="reports"></div>\n</main>\n';
    },
    useData: true
});
templates['dashboardSidebarMenu'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <a class="nav-link" href="#organizations" data-action="route" >' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'organizationsTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 3, column: 71 }, end: { line: 3, column: 100 } }
                })
            ) +
            '</a>\n        <a class="nav-link" href="#reports" data-action="route" >' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'reportsTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 4, column: 65 }, end: { line: 4, column: 88 } }
                })
            ) +
            '</a>\n'
        );
    },
    '3': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <a class="nav-link ' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(4, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 7, column: 27 }, end: { line: 7, column: 73 } }
            })) != null
                ? stack1
                : '') +
            '" href="#administrators" data-action="administrators" >' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    alias1,
                    'administratorsTitle',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 7, column: 128 }, end: { line: 7, column: 158 } } }
                )
            ) +
            '</a>\n'
        );
    },
    '4': function (container, depth0, helpers, partials, data) {
        return ' disabled';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<nav class="nav flex-column">\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'hasOrganizationAccess') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 2, column: 4 }, end: { line: 5, column: 11 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 6, column: 4 }, end: { line: 8, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '    <a class="btn btn-primary mt-2" href="https://mn.hb101.org/providers.htm" target="_blank">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    alias1,
                    'promptInfoForProviders',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 9, column: 94 }, end: { line: 9, column: 127 } } }
                )
            ) +
            '</a>\n</nav>\n'
        );
    },
    useData: true
});
templates['delete'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return 'modalLabel';
    },
    '3': function (container, depth0, helpers, partials, data) {
        return 'modalModalLabel';
    },
    '5': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            "'" +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'name',
                          hash: {},
                          data: data,
                          loc: { start: { line: 7, column: 73 }, end: { line: 7, column: 81 } }
                      })
                    : helper)
            ) +
            "' "
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div class="modal-content" name="modalContent">\n            <div class="modal-header">\n                <h1 class="modal-title" id="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'modalModal') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(3, data, 0),
                data: data,
                loc: { start: { line: 3, column: 44 }, end: { line: 3, column: 110 } }
            })) != null
                ? stack1
                : '') +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'deleteLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 3, column: 112 }, end: { line: 3, column: 134 } }
                })
            ) +
            ' ' +
            alias3(
                (lookupProperty(helpers, 'l10n_lc') || (depth0 && lookupProperty(depth0, 'l10n_lc')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'type') : depth0,
                    { name: 'l10n_lc', hash: {}, data: data, loc: { start: { line: 3, column: 135 }, end: { line: 3, column: 151 } } }
                )
            ) +
            '</h1>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'closeButton'), depth0, {
                name: 'closeButton',
                data: data,
                indent: '                ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="modal-body">\n                    ' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'deleteLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 7, column: 20 }, end: { line: 7, column: 42 } }
                })
            ) +
            ' ' +
            alias3(
                (lookupProperty(helpers, 'l10n_lc') || (depth0 && lookupProperty(depth0, 'l10n_lc')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'type') : depth0,
                    { name: 'l10n_lc', hash: {}, data: data, loc: { start: { line: 7, column: 43 }, end: { line: 7, column: 59 } } }
                )
            ) +
            ' ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'name') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 7, column: 60 }, end: { line: 7, column: 90 } }
            })) != null
                ? stack1
                : '') +
            '?\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" data-action="delete">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonDelete', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 10, column: 111 }, end: { line: 10, column: 134 } }
                })
            ) +
            '</button>\n                <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" data-action="cancel">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonCancel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 11, column: 113 }, end: { line: 11, column: 136 } }
                })
            ) +
            '</button>\n            </div>\n            <div class="sr-only">End of dialog</div>\n        </div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['detailsSectionHeader'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return container.escapeExpression(
            ((helper =
                (helper = lookupProperty(helpers, 'nonTipTitle') || (depth0 != null ? lookupProperty(depth0, 'nonTipTitle') : depth0)) != null
                    ? helper
                    : container.hooks.helperMissing),
            typeof helper === 'function'
                ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                      name: 'nonTipTitle',
                      hash: {},
                      data: data,
                      loc: { start: { line: 2, column: 35 }, end: { line: 2, column: 50 } }
                  })
                : helper)
        );
    },
    '3': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                depth0 != null ? lookupProperty(depth0, 'title') : depth0,
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 2, column: 58 }, end: { line: 2, column: 72 } } }
            )
        );
    },
    '5': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'editable') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(6, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 5, column: 4 }, end: { line: 12, column: 11 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'addable') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(13, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 13, column: 4 }, end: { line: 15, column: 11 } }
            })) != null
                ? stack1
                : '')
        );
    },
    '6': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                <button name="edit" class="btn btn-edit" data-action="edit" data-section="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 6, column: 90 }, end: { line: 6, column: 98 } } })
                    : helper)
            ) +
            '">' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'buttonEdit') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(7, data, 0),
                inverse: container.program(9, data, 0),
                data: data,
                loc: { start: { line: 6, column: 100 }, end: { line: 6, column: 181 } }
            })) != null
                ? stack1
                : '') +
            '</button>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'deleteable') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(11, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 7, column: 8 }, end: { line: 9, column: 15 } }
            })) != null
                ? stack1
                : '') +
            '                <button name="cancel" class="btn btn-edit hidden" data-action="cancel" data-section="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 10, column: 101 }, end: { line: 10, column: 109 } } })
                    : helper)
            ) +
            '">' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonCancel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 10, column: 111 }, end: { line: 10, column: 134 } }
                })
            ) +
            '</button>\n                <button name="save" class="btn btn-edit btn-primary hidden" data-action="save" data-section="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 11, column: 109 }, end: { line: 11, column: 117 } } })
                    : helper)
            ) +
            '" disabled="disabled">' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonSave', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 11, column: 139 }, end: { line: 11, column: 160 } }
                })
            ) +
            '</button>\n'
        );
    },
    '7': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'buttonEdit',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 6, column: 122 }, end: { line: 6, column: 143 } } }
            )
        );
    },
    '9': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                depth0 != null ? lookupProperty(depth0, 'buttonEdit') : depth0,
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 6, column: 151 }, end: { line: 6, column: 170 } } }
            )
        );
    },
    '11': function (container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                <button name="delete" class="btn btn-edit hidden" data-action="delete" data-section="' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 8, column: 101 }, end: { line: 8, column: 109 } } })
                    : helper)
            ) +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonDelete', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 8, column: 111 }, end: { line: 8, column: 134 } }
                })
            ) +
            '</button>\n'
        );
    },
    '13': function (container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                <button name="add" class="btn btn-primary btn-sm" data-action="add" data-section="' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 14, column: 98 }, end: { line: 14, column: 106 } } })
                    : helper)
            ) +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonAdd', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 14, column: 108 }, end: { line: 14, column: 128 } }
                })
            ) +
            ' ' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'display') : depth0,
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 14, column: 129 }, end: { line: 14, column: 145 } } }
                )
            ) +
            '</button>\n'
        );
    },
    '15': function (container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                <button name="cancel" class="btn btn-edit" data-action="cancel" data-section="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 17, column: 94 }, end: { line: 17, column: 102 } } })
                    : helper)
            ) +
            '">' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonCancel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 17, column: 104 }, end: { line: 17, column: 127 } }
                })
            ) +
            '</button>\n				<button name="save" class="btn btn-edit btn-primary" data-action="save" data-section="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 18, column: 90 }, end: { line: 18, column: 98 } } })
                    : helper)
            ) +
            '" disabled="disabled">' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonSave', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 18, column: 120 }, end: { line: 18, column: 141 } }
                })
            ) +
            '</button>\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div class="section-header d-flex justify-content-between">\n            <h2>' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'nonTipTitle') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(3, data, 0),
                data: data,
                loc: { start: { line: 2, column: 16 }, end: { line: 2, column: 79 } }
            })) != null
                ? stack1
                : '') +
            '</h2>\n            <div class="text-nowrap">\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.program(15, data, 0),
                data: data,
                loc: { start: { line: 4, column: 0 }, end: { line: 19, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '            </div>\n        </div>\n'
        );
    },
    useData: true
});
templates['editInProgress'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return 'modalLabel';
    },
    '3': function (container, depth0, helpers, partials, data) {
        return 'modalModalLabel';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div class="modal-content" name="modalContent">\n            <div class="modal-header">\n                <h1 class="modal-title" id="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'modalModal') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(3, data, 0),
                data: data,
                loc: { start: { line: 3, column: 44 }, end: { line: 3, column: 110 } }
            })) != null
                ? stack1
                : '') +
            '">' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'editInProgressLabel', {
                name: 'l10n',
                hash: {},
                data: data,
                loc: { start: { line: 3, column: 112 }, end: { line: 3, column: 144 } }
            })) != null
                ? stack1
                : '') +
            '</h1>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'closeButton'), depth0, {
                name: 'closeButton',
                hash: { hidden: true },
                data: data,
                indent: '                ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="modal-body">\n                    ' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'editInProgressText', {
                name: 'l10n',
                hash: {},
                data: data,
                loc: { start: { line: 7, column: 20 }, end: { line: 7, column: 51 } }
            })) != null
                ? stack1
                : '') +
            '\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal" data-action="resume">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonResumeEdit', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 10, column: 111 }, end: { line: 10, column: 138 } }
                })
            ) +
            '</button>\n                <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal" data-action="cancel">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonCancelEdit', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 11, column: 113 }, end: { line: 11, column: 140 } }
                })
            ) +
            '</button>\n            </div>\n            <div class="sr-only">End of dialog</div>\n        </div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['filterSet'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div name="filtersList"></div>\n<div class="filters-list row justify-content-between">\n	<div class="col-auto">\n		<button class="btn btn-edit" name="clearFilterSet"  data-action="clearFilterSet" >' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonClear', {
                name: 'l10n',
                hash: {},
                data: data,
                loc: { start: { line: 4, column: 84 }, end: { line: 4, column: 108 } }
            })) != null
                ? stack1
                : '') +
            '</button>\n		<button class="btn btn-edit" name="deleteFilterSet" data-action="deleteFilterSet">' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonDelete', {
                name: 'l10n',
                hash: {},
                data: data,
                loc: { start: { line: 5, column: 84 }, end: { line: 5, column: 109 } }
            })) != null
                ? stack1
                : '') +
            '</button>\n\n	</div>\n	<div class="col-auto">\n		<button class="btn btn-edit btn-primary" name="updateFilterSet" data-action="updateFilterSet">' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonSave', {
                name: 'l10n',
                hash: {},
                data: data,
                loc: { start: { line: 9, column: 96 }, end: { line: 9, column: 119 } }
            })) != null
                ? stack1
                : '') +
            '</button>\n		<button class="btn btn-edit btn-primary" name="saveFilterSetAs" data-action="saveFilterSetAs">' +
            ((stack1 = (lookupProperty(helpers, 'l10n_nb') || (depth0 && lookupProperty(depth0, 'l10n_nb')) || alias2).call(alias1, 'buttonSaveAs', {
                name: 'l10n_nb',
                hash: {},
                data: data,
                loc: { start: { line: 10, column: 96 }, end: { line: 10, column: 124 } }
            })) != null
                ? stack1
                : '') +
            '</button>\n		<button class="btn btn-edit btn-primary" name="saveFilterSet"   data-action="saveFilterSet" disabled="disabled">' +
            ((stack1 = (lookupProperty(helpers, 'l10n_nb') || (depth0 && lookupProperty(depth0, 'l10n_nb')) || alias2).call(alias1, 'buttonSaveAs', {
                name: 'l10n_nb',
                hash: {},
                data: data,
                loc: { start: { line: 11, column: 114 }, end: { line: 11, column: 142 } }
            })) != null
                ? stack1
                : '') +
            '</button>\n	</div>\n</div>\n<div name="filterSetsList"></div>\n'
        );
    },
    useData: true
});
templates['filterSetSave'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return 'modalLabel';
    },
    '3': function (container, depth0, helpers, partials, data) {
        return 'modalModalLabel';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div class="modal-content" name="modalContent">\n            <div class="modal-header">\n                <h1 class="modal-title" id="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'modalModal') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(3, data, 0),
                data: data,
                loc: { start: { line: 3, column: 44 }, end: { line: 3, column: 110 } }
            })) != null
                ? stack1
                : '') +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'saveFilterSetLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 3, column: 112 }, end: { line: 3, column: 141 } }
                })
            ) +
            '</h1>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'closeButton'), depth0, {
                name: 'closeButton',
                data: data,
                indent: '                ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="modal-body">\n                <form name="filterSave">\n                    <div class="form-group">\n                        <input data-prologue="disable" type="text" name="filterSetName" class="form-control" required placeholder="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'placeholderFilterSetName', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 9, column: 131 }, end: { line: 9, column: 166 } }
                })
            ) +
            '">\n                        <div class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'requiredInvalidFeedback', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 10, column: 54 }, end: { line: 10, column: 88 } }
                })
            ) +
            '</div>\n                    </div>\n                </form>\n                <div data-prologue="show" class="alert alert-primary d-none">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'notifyFilterSetSaved', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 13, column: 77 }, end: { line: 13, column: 108 } }
                })
            ) +
            '</div>\n            </div>\n            <div class="modal-footer">\n                <button type="button" class="btn btn-sm btn-secondary" data-prologue="hide" data-dismiss="modal" data-action="cancel">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonCancel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 16, column: 134 }, end: { line: 16, column: 157 } }
                })
            ) +
            '</button>\n                <button type="button" class="btn btn-sm btn-primary" data-prologue="hide" data-next="prologue" data-action="save">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonSave', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 17, column: 130 }, end: { line: 17, column: 151 } }
                })
            ) +
            '</button>\n				<button type="button" class="btn btn-sm btn-primary d-none" data-prologue="show" data-dismiss="true" data-action="okay">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonClose', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 18, column: 124 }, end: { line: 18, column: 146 } }
                })
            ) +
            '</button>\n            </div>\n            <div class="sr-only">End of dialog</div>\n        </div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['filterSetsList'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '<div class="d-flex">\n	<!--The rest of HB101 is not using Bootstrap dropdowns. We can add if we follow their styling method-->\n	<select class="form-control custom-select" name="filterSetsListItems" aria-label="Filter set list">\n        <option class="font-italic" selected value="launchSignIn">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    'placeholderChooseFilterSet',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 4, column: 66 }, end: { line: 4, column: 103 } } }
                )
            ) +
            '</option>\n    </select>\n</div>\n'
        );
    },
    useData: true
});
templates['filterSetsListItem'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'name',
                          hash: {},
                          data: data,
                          loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 8 } }
                      })
                    : helper)
            ) + '\n'
        );
    },
    useData: true
});
templates['filtersList'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        return '<div name="filtersListItems"></div>\n';
    },
    useData: true
});
templates['filtersListEmpty'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    'promptNoFiltersSelected',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 34 } } }
                )
            ) + '\n'
        );
    },
    useData: true
});
templates['filtersListItem'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'unless').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'report') : depth0,
            {
                name: 'unless',
                hash: {},
                fn: container.program(2, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 103 }, end: { line: 1, column: 224 } }
            }
        )) != null
            ? stack1
            : '';
    },
    '2': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = container.invokePartial(lookupProperty(partials, 'iconButton'), depth0, {
            name: 'iconButton',
            hash: { tip: 'buttonFilterRemove', btnClass: 'filter-clear', group: depth0 != null ? lookupProperty(depth0, 'group') : depth0, action: 'clear' },
            data: data,
            helpers: helpers,
            partials: partials,
            decorators: container.decorators
        })) != null
            ? stack1
            : '';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="filters-list-item truncate" title="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'description') || (depth0 != null ? lookupProperty(depth0, 'description') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'description', hash: {}, data: data, loc: { start: { line: 1, column: 47 }, end: { line: 1, column: 62 } } })
                    : helper)
            ) +
            '">' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'description') || (depth0 != null ? lookupProperty(depth0, 'description') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'description', hash: {}, data: data, loc: { start: { line: 1, column: 64 }, end: { line: 1, column: 79 } } })
                    : helper)
            ) +
            '</div>' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'wizard') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 85 }, end: { line: 1, column: 235 } }
            })) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['footer'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<span class="copyright">© ' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'year') || (depth0 != null ? lookupProperty(depth0, 'year') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'year',
                          hash: {},
                          data: data,
                          loc: { start: { line: 1, column: 26 }, end: { line: 1, column: 34 } }
                      })
                    : helper)
            ) +
            ' Housing Benefits 101, All rights reserved</span>\n'
        );
    },
    useData: true
});
templates['header'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <h1>' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programsHeaderTitle', {
                name: 'l10n',
                hash: {},
                data: data,
                loc: { start: { line: 4, column: 12 }, end: { line: 4, column: 44 } }
            })) != null
                ? stack1
                : '') +
            '</h1>\n        <p>' +
            ((stack1 = (lookupProperty(helpers, 'l10n_nb') || (depth0 && lookupProperty(depth0, 'l10n_nb')) || alias2).call(alias1, 'publicAdminHeaderBlurb', {
                name: 'l10n_nb',
                hash: {},
                data: data,
                loc: { start: { line: 5, column: 11 }, end: { line: 5, column: 49 } }
            })) != null
                ? stack1
                : '') +
            '</p>\n'
        );
    },
    '3': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <h1>' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'dashboardHeaderTitle',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 8, column: 12 }, end: { line: 8, column: 45 } } }
            )) != null
                ? stack1
                : '') +
            '</h1>\n        <p>&nbsp;</p>\n'
        );
    },
    '5': function (container, depth0, helpers, partials, data) {
        return ' hidden';
    },
    '7': function (container, depth0, helpers, partials, data) {
        return ' aria-disabled="true"';
    },
    '9': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <a class="btn btn-rts-header btn-lg btn-block d-flex justify-content-center align-items-center ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'dashboard') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 15, column: 103 }, end: { line: 15, column: 134 } }
            })) != null
                ? stack1
                : '') +
            '" role="button" href="#dashboard"' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'dashboard') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(7, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 15, column: 167 }, end: { line: 15, column: 212 } }
            })) != null
                ? stack1
                : '') +
            '>\n' +
            ((stack1 = (
                lookupProperty(helpers, 'ifArrayIncludes') ||
                (depth0 && lookupProperty(depth0, 'ifArrayIncludes')) ||
                container.hooks.helperMissing
            ).call(alias1, 'rts-admin', depth0 != null ? lookupProperty(depth0, 'roles') : depth0, {
                name: 'ifArrayIncludes',
                hash: {},
                fn: container.program(10, data, 0),
                inverse: container.program(12, data, 0),
                data: data,
                loc: { start: { line: 16, column: 12 }, end: { line: 20, column: 32 } }
            })) != null
                ? stack1
                : '') +
            '        </a>\n'
        );
    },
    '10': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '            ' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    'buttonDashboardAdmin',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 17, column: 12 }, end: { line: 17, column: 43 } } }
                )
            ) +
            '\n'
        );
    },
    '12': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '            ' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    'buttonDashboardProvider',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 19, column: 12 }, end: { line: 19, column: 46 } } }
                )
            ) +
            '\n'
        );
    },
    '14': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = (
            lookupProperty(helpers, 'unlessArrayIncludes') ||
            (depth0 && lookupProperty(depth0, 'unlessArrayIncludes')) ||
            container.hooks.helperMissing
        ).call(depth0 != null ? depth0 : container.nullContext || {}, 'rts-org', 'rts-admin', depth0 != null ? lookupProperty(depth0, 'roles') : depth0, {
            name: 'unlessArrayIncludes',
            hash: {},
            fn: container.program(15, data, 0),
            inverse: container.noop,
            data: data,
            loc: { start: { line: 24, column: 8 }, end: { line: 29, column: 32 } }
        })) != null
            ? stack1
            : '';
    },
    '15': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <span class="span-rts-header no-p blurb d-flex desktop">' +
            ((stack1 = (lookupProperty(helpers, 'l10n_raw') || (depth0 && lookupProperty(depth0, 'l10n_raw')) || alias2).call(alias1, 'placesMissionBlurb', {
                name: 'l10n_raw',
                hash: {},
                data: data,
                loc: { start: { line: 25, column: 64 }, end: { line: 25, column: 99 } }
            })) != null
                ? stack1
                : '') +
            '</span>\n        <span class="span-rts-header no-p blurb d-flex mobile">' +
            ((stack1 = (lookupProperty(helpers, 'l10n_raw') || (depth0 && lookupProperty(depth0, 'l10n_raw')) || alias2).call(
                alias1,
                'placesMissionBlurbShort',
                { name: 'l10n_raw', hash: {}, data: data, loc: { start: { line: 26, column: 63 }, end: { line: 26, column: 103 } } }
            )) != null
                ? stack1
                : '') +
            '</span>\n        <a class="btn btn-rts-header btn-block btn-popout-text d-flex justify-content-center align-items-center blurb desktop" role="button" target="_blank" href="https://housinglink.org">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'doNotNeedServicesBlurb', {
                    name: 'l10n',
                    hash: { stripAll: 'true' },
                    data: data,
                    loc: { start: { line: 27, column: 188 }, end: { line: 27, column: 237 } }
                })
            ) +
            '</a>\n        <a class="btn btn-rts-header btn-block btn-popout-text d-flex justify-content-center align-items-center blurb mobile"  role="button" target="_blank" href="https://housinglink.org" title="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'doNotNeedServicesBlurb', {
                    name: 'l10n',
                    hash: { stripAll: 'true' },
                    data: data,
                    loc: { start: { line: 28, column: 195 }, end: { line: 28, column: 245 } }
                })
            ) +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'doNotNeedServicesBlurbShort', {
                    name: 'l10n',
                    hash: { stripAll: 'true' },
                    data: data,
                    loc: { start: { line: 28, column: 247 }, end: { line: 28, column: 301 } }
                })
            ) +
            '</a>\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="rts-header-with-pin row no-gutters m-0">\n    <div class="rts-header-title col-12 col-md-6">\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'programs') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 3, column: 4 }, end: { line: 6, column: 11 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'dashboard') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 7, column: 4 }, end: { line: 10, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '    </div>\n    <div class="rts-header-buttons col-12 col-md-6 d-flex flex-md-column align-items-end">\n        <a class="btn btn-rts-header btn-lg btn-block d-flex justify-content-center align-items-center ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'programs') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 13, column: 103 }, end: { line: 13, column: 133 } }
            })) != null
                ? stack1
                : '') +
            '" role="button" href="#programs"' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'programs') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(7, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 13, column: 165 }, end: { line: 13, column: 209 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonPrograms', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 13, column: 210 }, end: { line: 13, column: 235 } }
                })
            ) +
            '</a>\n' +
            ((stack1 = (lookupProperty(helpers, 'ifArrayIncludes') || (depth0 && lookupProperty(depth0, 'ifArrayIncludes')) || alias2).call(
                alias1,
                'rts-org',
                'rts-admin',
                depth0 != null ? lookupProperty(depth0, 'roles') : depth0,
                {
                    name: 'ifArrayIncludes',
                    hash: {},
                    fn: container.program(9, data, 0),
                    inverse: container.noop,
                    data: data,
                    loc: { start: { line: 14, column: 8 }, end: { line: 22, column: 28 } }
                }
            )) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'programs') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(14, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 23, column: 8 }, end: { line: 30, column: 15 } }
            })) != null
                ? stack1
                : '') +
            '    </div>\n</div>\n'
        );
    },
    useData: true
});
templates['helpVideo'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return 'modalLabel';
    },
    '3': function (container, depth0, helpers, partials, data) {
        return 'modalModalLabel';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div class="modal-content" name="modalContent">\n            <div class="modal-header">\n                <h1 class="modal-title" id="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'modalModal') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(3, data, 0),
                data: data,
                loc: { start: { line: 3, column: 44 }, end: { line: 3, column: 110 } }
            })) != null
                ? stack1
                : '') +
            '">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    alias1,
                    'titleHowToPlacesVideo',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 3, column: 112 }, end: { line: 3, column: 144 } } }
                )
            ) +
            '</h1>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'closeButton'), depth0, {
                name: 'closeButton',
                hash: { lastTab: true },
                data: data,
                indent: '                ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="modal-body">\n                <div class="embed-responsive embed-responsive-16by9">\n                    <iframe class="embed-responsive-item video-size js-video-embed" src="https://www.youtube.com/embed/LxlN-1KVoQ8?enablejsapi=1" allowfullscreen></iframe>\n                </div>\n            </div>\n            <div class="sr-only">End of dialog</div>\n        </div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['iconButton'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return container.escapeExpression(
            ((helper =
                (helper = lookupProperty(helpers, 'btnClass') || (depth0 != null ? lookupProperty(depth0, 'btnClass') : depth0)) != null
                    ? helper
                    : container.hooks.helperMissing),
            typeof helper === 'function'
                ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                      name: 'btnClass',
                      hash: {},
                      data: data,
                      loc: { start: { line: 2, column: 40 }, end: { line: 2, column: 52 } }
                  })
                : helper)
        );
    },
    '3': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return container.escapeExpression(
            ((helper =
                (helper = lookupProperty(helpers, 'action') || (depth0 != null ? lookupProperty(depth0, 'action') : depth0)) != null
                    ? helper
                    : container.hooks.helperMissing),
            typeof helper === 'function'
                ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                      name: 'action',
                      hash: {},
                      data: data,
                      loc: { start: { line: 2, column: 60 }, end: { line: 2, column: 70 } }
                  })
                : helper)
        );
    },
    '5': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ' float-' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'float') || (depth0 != null ? lookupProperty(depth0, 'float') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'float',
                          hash: {},
                          data: data,
                          loc: { start: { line: 2, column: 97 }, end: { line: 2, column: 106 } }
                      })
                    : helper)
            )
        );
    },
    '7': function (container, depth0, helpers, partials, data) {
        return ' disabled';
    },
    '9': function (container, depth0, helpers, partials, data) {
        return 'disabled';
    },
    '11': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            'data-group="' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'group') || (depth0 != null ? lookupProperty(depth0, 'group') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'group',
                          hash: {},
                          data: data,
                          loc: { start: { line: 8, column: 29 }, end: { line: 8, column: 38 } }
                      })
                    : helper)
            ) +
            '"'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<button\n    class="btn-icon btn-' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'btnClass') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(3, data, 0),
                data: data,
                loc: { start: { line: 2, column: 24 }, end: { line: 2, column: 77 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'float') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 2, column: 77 }, end: { line: 2, column: 113 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'disabled') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(7, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 2, column: 113 }, end: { line: 2, column: 145 } }
            })) != null
                ? stack1
                : '') +
            '"\n    data-action="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'action') || (depth0 != null ? lookupProperty(depth0, 'action') : depth0)) != null ? helper : alias2),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'action', hash: {}, data: data, loc: { start: { line: 3, column: 17 }, end: { line: 3, column: 27 } } })
                    : helper)
            ) +
            '"\n    aria-label="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'tip') : depth0,
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 4, column: 16 }, end: { line: 4, column: 28 } } }
                )
            ) +
            '"\n    alt="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'tip') : depth0,
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 5, column: 9 }, end: { line: 5, column: 21 } } }
                )
            ) +
            '"\n    title="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'tip') : depth0,
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 6, column: 11 }, end: { line: 6, column: 23 } } }
                )
            ) +
            '"\n    ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'disabled') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(9, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 7, column: 4 }, end: { line: 7, column: 35 } }
            })) != null
                ? stack1
                : '') +
            '\n    ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'group') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(11, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 8, column: 4 }, end: { line: 8, column: 46 } }
            })) != null
                ? stack1
                : '') +
            '\n></button>\n'
        );
    },
    useData: true
});
templates['imageEdit'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<form class="form-compact">\n    <div class="form-row align-items-center">\n        <div class="col-6 col-md-4 order-2 order-md-1">\n            <label>Caption</label>\n            <input type="text" class="form-control" name="caption" placeholder="Caption" value="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'caption') || (depth0 != null ? lookupProperty(depth0, 'caption') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'caption', hash: {}, data: data, loc: { start: { line: 5, column: 96 }, end: { line: 5, column: 107 } } })
                    : helper)
            ) +
            '">\n        </div>\n        <div class="col-6 col-md-4 order-3 order-md-2">\n            <label>Filname</label>\n            <input type="text" class="form-control" name="originalFileName" placeholder="Filename" value="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'originalFileName') || (depth0 != null ? lookupProperty(depth0, 'originalFileName') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, {
                          name: 'originalFileName',
                          hash: {},
                          data: data,
                          loc: { start: { line: 9, column: 106 }, end: { line: 9, column: 126 } }
                      })
                    : helper)
            ) +
            '" disabled>\n        </div>\n        <div class="col-12 col-md-4 order-1 order-md-3 mt-2 text-right">\n            <button name="cancel" class="btn btn-edit" data-action="cancel" data-section="image">' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonCancel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 12, column: 97 }, end: { line: 12, column: 120 } }
                })
            ) +
            '</button>\n            <button name="delete" class="btn btn-edit" data-action="delete" data-section="image" data-id="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 13, column: 106 }, end: { line: 13, column: 112 } } })
                    : helper)
            ) +
            '">' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonDelete', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 13, column: 114 }, end: { line: 13, column: 137 } }
                })
            ) +
            '</button>\n            <button name="save" class="btn btn-edit btn-primary" data-action="save" data-section="image" disabled="disabled">' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonSave', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 14, column: 125 }, end: { line: 14, column: 146 } }
                })
            ) +
            '</button>\n        </div>\n        <div class="hidden">\n            <input type="text" name="id" value="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 17, column: 48 }, end: { line: 17, column: 54 } } })
                    : helper)
            ) +
            '">\n        </div>\n    </div>\n</form>\n'
        );
    },
    useData: true
});
templates['imagesCarousel'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '    <!-- <span class="empty-list-message">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    depth0 != null ? lookupProperty(depth0, 'emptyMessage') : depth0,
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 3, column: 42 }, end: { line: 3, column: 63 } } }
                )
            ) +
            '</span> -->\n'
        );
    },
    '3': function (container, depth0, helpers, partials, data) {
        return '    <a class="carousel-control-prev" href="" role="button" data-slide="prev">\n        <span class="carousel-control-prev-icon" aria-hidden="true"></span>\n        <span class="sr-only">Previous</span>\n    </a>\n    <a class="carousel-control-next" href="" role="button" data-slide="next">\n        <span class="carousel-control-next-icon" aria-hidden="true"></span>\n        <span class="sr-only">Next</span>\n    </a>\n';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="carousel slide" data-ride="carousel">\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'empty') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 2, column: 0 }, end: { line: 4, column: 7 } }
            })) != null
                ? stack1
                : '') +
            '    <!--\n        <ol class="carousel-indicators">\n            <li data-target="#carouselExampleCaptions" data-slide-to="0" class="active"></li>\n            <li data-target="#carouselExampleCaptions" data-slide-to="1"></li>\n            <li data-target="#carouselExampleCaptions" data-slide-to="2"></li>\n        </ol>\n    -->\n    <div name="carouselImages" class="carousel-inner"></div>\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, '_empty') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 13, column: 0 }, end: { line: 22, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '</div>\n\n'
        );
    },
    useData: true
});
templates['imagesCarouselItem'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return 'No caption available';
    },
    '3': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ' &ndash; ' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'caption') || (depth0 != null ? lookupProperty(depth0, 'caption') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'caption',
                          hash: {},
                          data: data,
                          loc: { start: { line: 2, column: 62 }, end: { line: 2, column: 73 } }
                      })
                    : helper)
            )
        );
    },
    '5': function (container, depth0, helpers, partials, data) {
        return '&nbsp;';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<img src="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'url') || (depth0 != null ? lookupProperty(depth0, 'url') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'url', hash: {}, data: data, loc: { start: { line: 1, column: 10 }, end: { line: 1, column: 17 } } })
                    : helper)
            ) +
            '" class="d-block mx-auto fragile" alt="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'caption') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 56 }, end: { line: 1, column: 106 } }
            })) != null
                ? stack1
                : '') +
            '">\n<span><span>' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'index') || (depth0 != null ? lookupProperty(depth0, 'index') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'index', hash: {}, data: data, loc: { start: { line: 2, column: 12 }, end: { line: 2, column: 21 } } })
                    : helper)
            ) +
            '/' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'count') || (depth0 != null ? lookupProperty(depth0, 'count') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'count', hash: {}, data: data, loc: { start: { line: 2, column: 22 }, end: { line: 2, column: 31 } } })
                    : helper)
            ) +
            '</span>' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'caption') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.program(5, data, 0),
                data: data,
                loc: { start: { line: 2, column: 38 }, end: { line: 2, column: 94 } }
            })) != null
                ? stack1
                : '') +
            '</span>\n'
        );
    },
    useData: true
});
templates['imagesEditor'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        return '<div name="table"></div>\n<div name="imagesUpload"></div>\n';
    },
    useData: true
});
templates['imagesSection'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: { editable: false, name: 'images', title: 'picturesTitle' },
                data: data,
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') + '<div name="imagesEditor"></div>\n<div name="imagesCarousel"></div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['imagesUpload'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        return '<div id="uppy" class="mt-3"></div>\n';
    },
    useData: true
});
templates['map'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        return '<div name="mapCanvas" class="map-canvas"></div>\n';
    },
    useData: true
});
templates['organizationDetails'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return ' hidden';
    },
    '3': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            'value="' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'name',
                          hash: {},
                          data: data,
                          loc: { start: { line: 13, column: 97 }, end: { line: 13, column: 105 } }
                      })
                    : helper)
            ) +
            '"'
        );
    },
    '5': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <hr>\n        <h2 class="mb-1">Primary Contact</h2>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'contactEdit'), depth0, {
                name: 'contactEdit',
                hash: { primaryContact: true, organizationContact: true },
                data: data,
                indent: '        ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '    ' +
            ((stack1 = lookupProperty(helpers, 'if').call(
                depth0 != null ? depth0 : container.nullContext || {},
                depth0 != null ? lookupProperty(depth0, 'create') : depth0,
                {
                    name: 'if',
                    hash: {},
                    fn: container.program(6, data, 0),
                    inverse: container.noop,
                    data: data,
                    loc: { start: { line: 76, column: 4 }, end: { line: 81, column: 11 } }
                }
            )) != null
                ? stack1
                : '')
        );
    },
    '6': function (container, depth0, helpers, partials, data) {
        var alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ' <!-- eh? nested if create? -->\n        <div class="clearfix pr-1 mb-3">\n            <button name="save" class="btn btn-edit btn-primary float-right" data-action="save" data-section="summary" disabled="disabled">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonSave', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 78, column: 139 }, end: { line: 78, column: 160 } }
                })
            ) +
            '</button>\n            <button name="cancel" class="btn btn-edit float-right mr-1" data-action="cancel" data-section="summary">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonCancel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 79, column: 116 }, end: { line: 79, column: 139 } }
                })
            ) +
            '</button>\n        </div>\n'
        );
    },
    '8': function (container, depth0, helpers, partials, data) {
        return '<hr>\n';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            alias4 = 'function',
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div name="summary" class="summary display-edit">\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: {
                    create: depth0 != null ? lookupProperty(depth0, 'create') : depth0,
                    deleteable: depth0 != null ? lookupProperty(depth0, 'deleteable') : depth0,
                    editable: true,
                    name: 'summary',
                    buttonEdit: depth0 != null ? lookupProperty(depth0, 'buttonEdit') : depth0,
                    nonTipTitle: depth0 != null ? lookupProperty(depth0, 'name') : depth0
                },
                data: data,
                indent: '    ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '    <div name="display" class="display' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 3, column: 38 }, end: { line: 3, column: 66 } }
            })) != null
                ? stack1
                : '') +
            '">\n        <p><span>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'descriptionLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 4, column: 17 }, end: { line: 4, column: 53 } }
                })
            ) +
            '</span> ' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'description') || (depth0 != null ? lookupProperty(depth0, 'description') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'description', hash: {}, data: data, loc: { start: { line: 4, column: 61 }, end: { line: 4, column: 76 } } })
                    : helper)
            ) +
            '</p>\n        <p><span>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'addressLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 5, column: 17 }, end: { line: 5, column: 49 } }
                })
            ) +
            '</span> ' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'addressLine'), depth0, {
                name: 'addressLine',
                data: data,
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '\n        <p><span>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'phoneLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 6, column: 17 }, end: { line: 6, column: 47 } }
                })
            ) +
            '</span> ' +
            alias3(
                (lookupProperty(helpers, 'telephone') || (depth0 && lookupProperty(depth0, 'telephone')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'phone') : depth0,
                    { name: 'telephone', hash: {}, data: data, loc: { start: { line: 6, column: 55 }, end: { line: 6, column: 74 } } }
                )
            ) +
            '</p>\n    </div>\n    <div name="edit" class="edit' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 8, column: 32 }, end: { line: 8, column: 68 } }
            })) != null
                ? stack1
                : '') +
            '">\n        <form name="summary" class="form-compact needs-validation" role="form" novalidate>\n            <div class="row">\n                <div class="form-group col-12 col-md-6">\n                    <label for="name" class="col-form-label">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'organizationNameLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 12, column: 61 }, end: { line: 12, column: 93 } }
                })
            ) +
            ':</label>\n                    <input name="name" class="form-control" type="text" ' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 13, column: 72 }, end: { line: 13, column: 117 } }
            })) != null
                ? stack1
                : '') +
            ' required />\n                    <div class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'requiredInvalidFeedback', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 14, column: 50 }, end: { line: 14, column: 84 } }
                })
            ) +
            '</div>\n                </div>\n                <div class="form-group col-0 col-md-2">\n                </div>\n                <div class="form-group col-12 col-sm-8 col-md-4">\n                    <label class="col-form-label">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'organizationStatusTypeTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 19, column: 50 }, end: { line: 19, column: 88 } }
                })
            ) +
            '</label>\n                    ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: { selected: depth0 != null ? lookupProperty(depth0, 'organizationStatusTypeId') : depth0, property: 'organizationStatusTypeId' },
                data: data,
                loc: { start: { line: 20, column: 20 }, end: { line: 20, column: 107 } }
            })) != null
                ? stack1
                : '') +
            '\n                </div>\n            </div>\n            <div class="row">\n                <div class="form-group col-12">\n                    <label for="description">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'descriptionLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 25, column: 45 }, end: { line: 25, column: 72 } }
                })
            ) +
            ':</label>\n                    <input name="description" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'description') || (depth0 != null ? lookupProperty(depth0, 'description') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'description',
                          hash: {},
                          data: data,
                          loc: { start: { line: 26, column: 86 }, end: { line: 26, column: 101 } }
                      })
                    : helper)
            ) +
            '" />\n                </div>\n            </div>\n            <div class="row">\n                <div class="form-group col-12">\n                    <label class="title" for="location">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'addressLookupLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 31, column: 56 }, end: { line: 31, column: 85 } }
                })
            ) +
            ':</label>\n                    <input name="location" class="form-control" type="text" value="" placeholder="Enter an address..." />\n                    <small name="locationComment" class="form-text text-muted truncate ml-1"></small>\n                </div>\n            </div>\n            <div class="row">\n                <div class="form-group col-12 col-md-6">\n                    <label for="address1">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'address1Label', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 38, column: 42 }, end: { line: 38, column: 66 } }
                })
            ) +
            ':</label>\n                    <input name="address1" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'address1') || (depth0 != null ? lookupProperty(depth0, 'address1') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'address1', hash: {}, data: data, loc: { start: { line: 39, column: 83 }, end: { line: 39, column: 95 } } })
                    : helper)
            ) +
            '" />\n                </div>\n                <div class="form-group col-12 col-md-6">\n                    <label for="address2">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'address2Label', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 42, column: 42 }, end: { line: 42, column: 66 } }
                })
            ) +
            ':</label>\n                    <input name="address2" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'address2') || (depth0 != null ? lookupProperty(depth0, 'address2') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'address2', hash: {}, data: data, loc: { start: { line: 43, column: 83 }, end: { line: 43, column: 95 } } })
                    : helper)
            ) +
            '" />\n                </div>\n            </div>\n            <div class="row">\n                <div class="form-group col-6">\n                    <label for="city">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'cityLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 48, column: 38 }, end: { line: 48, column: 58 } }
                })
            ) +
            ':</label>\n                    <input name="city" class="form-control" type="text" value="' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'city') || (depth0 != null ? lookupProperty(depth0, 'city') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'city', hash: {}, data: data, loc: { start: { line: 49, column: 79 }, end: { line: 49, column: 87 } } })
                    : helper)
            ) +
            '" />\n                </div>\n                <div class="form-group col-2">\n                    <label for="state">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'stateLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 52, column: 39 }, end: { line: 52, column: 60 } }
                })
            ) +
            ':</label>\n                    <input name="state" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'state') || (depth0 != null ? lookupProperty(depth0, 'state') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'state', hash: {}, data: data, loc: { start: { line: 53, column: 80 }, end: { line: 53, column: 89 } } })
                    : helper)
            ) +
            '" />\n                </div>\n                <div class="form-group col-4">\n                    <label for="zip">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'zipCodeLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 56, column: 37 }, end: { line: 56, column: 60 } }
                })
            ) +
            ':</label>\n                    <input name="zip" class="form-control" type="zip" value="' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'zip') || (depth0 != null ? lookupProperty(depth0, 'zip') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'zip', hash: {}, data: data, loc: { start: { line: 57, column: 77 }, end: { line: 57, column: 84 } } })
                    : helper)
            ) +
            '" required pattern="' +
            ((stack1 = (lookupProperty(helpers, 'pattern') || (depth0 && lookupProperty(depth0, 'pattern')) || alias2).call(alias1, 'zip', {
                name: 'pattern',
                hash: {},
                data: data,
                loc: { start: { line: 57, column: 104 }, end: { line: 57, column: 123 } }
            })) != null
                ? stack1
                : '') +
            '" />\n                    <div class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'requiredInvalidFeedback', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 58, column: 50 }, end: { line: 58, column: 84 } }
                })
            ) +
            '</div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="form-group col-6">\n                    <label for="phone">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'phoneLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 63, column: 39 }, end: { line: 63, column: 60 } }
                })
            ) +
            ':</label>\n                    <input name="phone" class="form-control" type="phone" value="' +
            alias3(
                (lookupProperty(helpers, 'telephone') || (depth0 && lookupProperty(depth0, 'telephone')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'phone') : depth0,
                    { name: 'telephone', hash: {}, data: data, loc: { start: { line: 64, column: 81 }, end: { line: 64, column: 100 } } }
                )
            ) +
            '" pattern="' +
            ((stack1 = (lookupProperty(helpers, 'pattern') || (depth0 && lookupProperty(depth0, 'pattern')) || alias2).call(alias1, 'phone', {
                name: 'pattern',
                hash: {},
                data: data,
                loc: { start: { line: 64, column: 111 }, end: { line: 64, column: 132 } }
            })) != null
                ? stack1
                : '') +
            '" />\n                    <div class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'phoneInvalidFeedback', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 65, column: 50 }, end: { line: 65, column: 81 } }
                })
            ) +
            '</div>\n                </div>\n            </div>\n            <div class="hidden">\n                <input name="countyId" class="hidden" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'countyId') || (depth0 != null ? lookupProperty(depth0, 'countyId') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'countyId', hash: {}, data: data, loc: { start: { line: 69, column: 73 }, end: { line: 69, column: 85 } } })
                    : helper)
            ) +
            '" />\n            </div>\n        </form>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 72, column: 0 }, end: { line: 82, column: 7 } }
            })) != null
                ? stack1
                : '') +
            '    </div> <!-- /edit -->\n</div> <!-- summary -->\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(8, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 85, column: 0 }, end: { line: 87, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '<div name="contactsList"></div>\n\n\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['organizations'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: {
                    addable: depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0,
                    editable: false,
                    name: 'organizations',
                    display: 'organizationTitle',
                    title: 'organizationsTitle'
                },
                data: data,
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '<div name="table"></div>\n<div name="organizationDetails"></div>\n<div name="programsSummaries"></div>\n<div name="programDetails"></div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['pleaseSignIn'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return 'modalLabel';
    },
    '3': function (container, depth0, helpers, partials, data) {
        return 'modalModalLabel';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div class="modal-content" name="modalContent">\n            <div class="modal-header mb-0 pb-0 pt-1">\n                <h1 class="modal-title" id="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'modalModal') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(3, data, 0),
                data: data,
                loc: { start: { line: 3, column: 44 }, end: { line: 3, column: 110 } }
            })) != null
                ? stack1
                : '') +
            '">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    alias1,
                    'pleaseSignInLabel',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 3, column: 112 }, end: { line: 3, column: 140 } } }
                )
            ) +
            '</h1>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'closeButton'), depth0, {
                name: 'closeButton',
                data: data,
                indent: '                ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="sr-only">End of dialog</div>\n        </div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['programDetails'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '    <div class="header">\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(
                depth0 != null ? depth0 : container.nullContext || {},
                depth0 != null ? lookupProperty(depth0, 'create') : depth0,
                {
                    name: 'unless',
                    hash: {},
                    fn: container.program(2, data, 0),
                    inverse: container.noop,
                    data: data,
                    loc: { start: { line: 4, column: 4 }, end: { line: 13, column: 15 } }
                }
            )) != null
                ? stack1
                : '') +
            '        <div class="btn-right">\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'closeButton'), depth0, {
                name: 'closeButton',
                hash: { action: 'close' },
                data: data,
                indent: '            ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '        </div>\n    </div>\n'
        );
    },
    '2': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div class="listings-nav">\n			<div class="buttons">\n				<button class="btn btn-primary" data-action="previous"' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'isFirst') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 7, column: 58 }, end: { line: 7, column: 89 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'isFirst') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 7, column: 89 }, end: { line: 7, column: 145 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonPrevious', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 7, column: 146 }, end: { line: 7, column: 171 } }
                })
            ) +
            '</button>\n				<button class="btn btn-primary" data-action="next" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'isLast') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 8, column: 55 }, end: { line: 8, column: 85 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'isFirst') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 8, column: 85 }, end: { line: 8, column: 133 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonNext', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 8, column: 134 }, end: { line: 8, column: 155 } }
                })
            ) +
            '</button>\n			</div>\n			<h1>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'listingLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 10, column: 7 }, end: { line: 10, column: 30 } }
                })
            ) +
            ' <span name="offset">...</span> of <span name="count">...</span></h1>\n			<!-- <div></div> -->\n       </div>\n'
        );
    },
    '3': function (container, depth0, helpers, partials, data) {
        return ' disabled';
    },
    '5': function (container, depth0, helpers, partials, data) {
        return ' data-tab-position="first"';
    },
    '7': function (container, depth0, helpers, partials, data) {
        return ' id="modalLabel"';
    },
    '9': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return container.escapeExpression(
            ((helper =
                (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null
                    ? helper
                    : container.hooks.helperMissing),
            typeof helper === 'function'
                ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                      name: 'name',
                      hash: {},
                      data: data,
                      loc: { start: { line: 26, column: 88 }, end: { line: 26, column: 96 } }
                  })
                : helper)
        );
    },
    '11': function (container, depth0, helpers, partials, data) {
        return 'New Program';
    },
    '13': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '            <button class="btn btn-favorite' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'isFavorite') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(14, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 28, column: 43 }, end: { line: 28, column: 72 } }
            })) != null
                ? stack1
                : '') +
            '" title="' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'isFavorite') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(16, data, 0),
                inverse: container.program(18, data, 0),
                data: data,
                loc: { start: { line: 28, column: 81 }, end: { line: 28, column: 173 } }
            })) != null
                ? stack1
                : '') +
            '" data-action="favorite"></button>\n            <a href="rts_share:" data-label="shareProgramDetailsLabel" data-body="shareProgramDetailsBody" data-mode="share" data-url="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'popoutUrl') || (depth0 != null ? lookupProperty(depth0, 'popoutUrl') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, {
                          name: 'popoutUrl',
                          hash: {},
                          data: data,
                          loc: { start: { line: 29, column: 135 }, end: { line: 29, column: 148 } }
                      })
                    : helper)
            ) +
            '#popout/' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 29, column: 156 }, end: { line: 29, column: 162 } } })
                    : helper)
            ) +
            '" data-href="mailto:?subject=' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(
                    alias1,
                    'placesShareProgramDetailsEmailSubject',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 29, column: 191 }, end: { line: 29, column: 239 } } }
                )
            ) +
            '&body=' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'placesShareProgramDetailsEmailBody', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 29, column: 245 }, end: { line: 29, column: 290 } }
                })
            ) +
            " '" +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 29, column: 292 }, end: { line: 29, column: 300 } } })
                    : helper)
            ) +
            "' %0a%0a" +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'popoutUrl') || (depth0 != null ? lookupProperty(depth0, 'popoutUrl') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, {
                          name: 'popoutUrl',
                          hash: {},
                          data: data,
                          loc: { start: { line: 29, column: 308 }, end: { line: 29, column: 321 } }
                      })
                    : helper)
            ) +
            '#popout/' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 29, column: 329 }, end: { line: 29, column: 335 } } })
                    : helper)
            ) +
            '" data-modal-modal="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(20, data, 0),
                inverse: container.program(22, data, 0),
                data: data,
                loc: { start: { line: 29, column: 355 }, end: { line: 29, column: 401 } }
            })) != null
                ? stack1
                : '') +
            '" data-focus="rtsShare_B">\n                <img class="details-action" data-action="email" src="' +
            alias4(
                (lookupProperty(helpers, 'configuration') || (depth0 && lookupProperty(depth0, 'configuration')) || alias2).call(alias1, 'assetBase', {
                    name: 'configuration',
                    hash: {},
                    data: data,
                    loc: { start: { line: 30, column: 69 }, end: { line: 30, column: 98 } }
                })
            ) +
            'images/programDetailsShare.svg" aria-role="button" title="' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonShareProgram', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 30, column: 156 }, end: { line: 30, column: 185 } }
                })
            ) +
            '" alt="' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonShareProgram', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 30, column: 192 }, end: { line: 30, column: 221 } }
                })
            ) +
            '" />\n            </a>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(24, data, 0),
                inverse: container.program(26, data, 0),
                data: data,
                loc: { start: { line: 32, column: 8 }, end: { line: 38, column: 15 } }
            })) != null
                ? stack1
                : '')
        );
    },
    '14': function (container, depth0, helpers, partials, data) {
        return ' yes';
    },
    '16': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'buttonFavoriteTrue',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 28, column: 99 }, end: { line: 28, column: 128 } } }
            )
        );
    },
    '18': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'buttonFavoriteFalse',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 28, column: 136 }, end: { line: 28, column: 166 } } }
            )
        );
    },
    '20': function (container, depth0, helpers, partials, data) {
        return 'true';
    },
    '22': function (container, depth0, helpers, partials, data) {
        return 'false';
    },
    '24': function (container, depth0, helpers, partials, data) {
        var alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '            <button class="btn btn-primary btn-click-to-print mobile d-block d-sm-none d-print-none" data-action="print" alt="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonClickToPrint', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 33, column: 126 }, end: { line: 33, column: 155 } }
                })
            ) +
            '", title="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonClickToPrint', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 33, column: 165 }, end: { line: 33, column: 194 } }
                })
            ) +
            '"></button>\n            <button class="btn btn-primary btn-click-to-print d-none d-sm-block d-print-none" data-action="print">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonClickToPrint', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 34, column: 114 }, end: { line: 34, column: 143 } }
                })
            ) +
            '</button>\n'
        );
    },
    '26': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = container.invokePartial(lookupProperty(partials, 'iconButton'), depth0, {
                name: 'iconButton',
                hash: { tip: 'buttonPopoutPrograms', btnClass: 'detailsPopout', action: 'popout' },
                data: data,
                indent: '            ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'iconButton'), depth0, {
                name: 'iconButton',
                hash: { tip: 'buttonPrinterFriendly', btnClass: 'detailsPopoutPrint', action: 'popoutPrint' },
                data: data,
                indent: '            ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '')
        );
    },
    '28': function (container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '			<div><a href="#units" class="scroll-to"> ' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'vacanciesLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 43, column: 44 }, end: { line: 43, column: 69 } }
                })
            ) +
            ': <span>' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'vacancies') || (depth0 != null ? lookupProperty(depth0, 'vacancies') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'vacancies', hash: {}, data: data, loc: { start: { line: 43, column: 77 }, end: { line: 43, column: 90 } } })
                    : helper)
            ) +
            '</span></a></div>\n'
        );
    },
    '30': function (container, depth0, helpers, partials, data) {
        return ' d-none';
    },
    '32': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div name="display" class="display">\n            <div class="row">\n                <div class="col-md-7">\n                    <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'addressLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 59, column: 71 }, end: { line: 59, column: 103 } }
                })
            ) +
            '</span> <a href="https://www.google.com/maps/search/?api=1&query=' +
            alias3(
                (lookupProperty(helpers, 'urlEncode') || (depth0 && lookupProperty(depth0, 'urlEncode')) || alias2).call(
                    alias1,
                    (lookupProperty(helpers, 'addressLine') || (depth0 && lookupProperty(depth0, 'addressLine')) || alias2).call(alias1, {
                        name: 'addressLine',
                        hash: {},
                        data: data,
                        loc: { start: { line: 59, column: 180 }, end: { line: 59, column: 193 } }
                    }),
                    { name: 'urlEncode', hash: {}, data: data, loc: { start: { line: 59, column: 168 }, end: { line: 59, column: 195 } } }
                )
            ) +
            '" target="_blank" ' +
            ((stack1 = (lookupProperty(helpers, 'analytics') || (depth0 && lookupProperty(depth0, 'analytics')) || alias2).call(alias1, {
                name: 'analytics',
                hash: { action: 'click.address', category: 'places.program' },
                data: data,
                loc: { start: { line: 59, column: 213 }, end: { line: 59, column: 277 } }
            })) != null
                ? stack1
                : '') +
            ' >' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'addressLine'), depth0, {
                name: 'addressLine',
                data: data,
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '</a></p>\n                    <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 60, column: 71 }, end: { line: 60, column: 107 } }
                })
            ) +
            '</span> ' +
            alias3(
                (lookupProperty(helpers, 'enum_l10n') || (depth0 && lookupProperty(depth0, 'enum_l10n')) || alias2).call(alias1, {
                    name: 'enum_l10n',
                    hash: { id: depth0 != null ? lookupProperty(depth0, 'programTypeId') : depth0, property: 'programTypeId' },
                    data: data,
                    loc: { start: { line: 60, column: 115 }, end: { line: 60, column: 170 } }
                })
            ) +
            '</p>\n                    <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'householdTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 61, column: 71 }, end: { line: 61, column: 109 } }
                })
            ) +
            '</span></p>\n                    ' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'householdTypeIds') : depth0, property: 'householdTypeIds' },
                data: data,
                loc: { start: { line: 62, column: 20 }, end: { line: 62, column: 82 } }
            })) != null
                ? stack1
                : '') +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(
                alias1,
                (stack1 = depth0 != null ? lookupProperty(depth0, 'serviceForDiagnosisTypeIds') : depth0) != null ? lookupProperty(stack1, 'length') : stack1,
                {
                    name: 'if',
                    hash: {},
                    fn: container.program(33, data, 0),
                    inverse: container.noop,
                    data: data,
                    loc: { start: { line: 63, column: 16 }, end: { line: 66, column: 23 } }
                }
            )) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(
                alias1,
                (stack1 = depth0 != null ? lookupProperty(depth0, 'canServeMAWaiversTypeIds') : depth0) != null ? lookupProperty(stack1, 'length') : stack1,
                {
                    name: 'if',
                    hash: {},
                    fn: container.program(35, data, 0),
                    inverse: container.noop,
                    data: data,
                    loc: { start: { line: 67, column: 16 }, end: { line: 70, column: 23 } }
                }
            )) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'payForGroup') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(37, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 71, column: 16 }, end: { line: 77, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '                    <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'descriptionLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 78, column: 71 }, end: { line: 78, column: 107 } }
                })
            ) +
            '</span> ' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'description') || (depth0 != null ? lookupProperty(depth0, 'description') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === 'function'
                    ? helper.call(alias1, {
                          name: 'description',
                          hash: {},
                          data: data,
                          loc: { start: { line: 78, column: 115 }, end: { line: 78, column: 130 } }
                      })
                    : helper)
            ) +
            '</p>\n                </div>\n                <div class="col-md-5">\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(42, data, 0),
                inverse: container.program(49, data, 0),
                data: data,
                loc: { start: { line: 81, column: 16 }, end: { line: 99, column: 27 } }
            })) != null
                ? stack1
                : '') +
            '                </div>\n            </div>\n        </div>\n'
        );
    },
    '33': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <p class="program-detail-item"><span class="title">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'serviceForDiagnosisTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 64, column: 71 }, end: { line: 64, column: 119 } }
                })
            ) +
            '</span></p>\n                    ' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'serviceForDiagnosisTypeIds') : depth0, property: 'serviceForDiagnosisTypeIds' },
                data: data,
                loc: { start: { line: 65, column: 20 }, end: { line: 65, column: 102 } }
            })) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    '35': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <p class="program-detail-item"><span class="title">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'canServeMAWaiversTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 68, column: 71 }, end: { line: 68, column: 117 } }
                })
            ) +
            '</span></p>\n                    ' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'canServeMAWaiversTypeIds') : depth0, property: 'canServeMAWaiversTypeIds' },
                data: data,
                loc: { start: { line: 69, column: 20 }, end: { line: 69, column: 98 } }
            })) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    '37': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <p class="program-detail-item"><span class="title">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    alias1,
                    'payForGroupLabel',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 72, column: 71 }, end: { line: 72, column: 98 } } }
                )
            ) +
            '</span></p>\n                    <ul>\n                        ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'canPayForWithHousingSupport') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(38, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 74, column: 24 }, end: { line: 74, column: 118 } }
            })) != null
                ? stack1
                : '') +
            '\n                        ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'canPayPrivate') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(40, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 75, column: 24 }, end: { line: 75, column: 90 } }
            })) != null
                ? stack1
                : '') +
            '\n                    </ul>\n'
        );
    },
    '38': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '<li>' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    'canPayForWithHousingSupportLabel',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 74, column: 63 }, end: { line: 74, column: 106 } } }
                )
            ) +
            '</li>'
        );
    },
    '40': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '<li>' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    'canPayPrivateLabel',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 75, column: 49 }, end: { line: 75, column: 78 } } }
                )
            ) +
            '</li>'
        );
    },
    '42': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <div class="card program-details-contacts mt-4 mt-md-0" name="programDetailsContacts">\n                        <div class="card-header">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    alias1,
                    'contactForDetailsBlurb',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 83, column: 49 }, end: { line: 83, column: 82 } } }
                )
            ) +
            '</div>\n						<div class="card-body">\n							' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'website') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(43, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 85, column: 7 }, end: { line: 85, column: 162 } }
            })) != null
                ? stack1
                : '') +
            '\n							' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'phone') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(45, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 86, column: 7 }, end: { line: 86, column: 180 } }
            })) != null
                ? stack1
                : '') +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'email') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(47, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 87, column: 7 }, end: { line: 92, column: 35 } }
            })) != null
                ? stack1
                : '') +
            '						</div>\n                    </div>\n'
        );
    },
    '43': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<p><a href="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'website') || (depth0 != null ? lookupProperty(depth0, 'website') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'website', hash: {}, data: data, loc: { start: { line: 85, column: 34 }, end: { line: 85, column: 45 } } })
                    : helper)
            ) +
            '" target="_blank" ' +
            ((stack1 = (lookupProperty(helpers, 'analytics') || (depth0 && lookupProperty(depth0, 'analytics')) || alias2).call(alias1, {
                name: 'analytics',
                hash: { action: 'click.website', category: 'places.program' },
                data: data,
                loc: { start: { line: 85, column: 63 }, end: { line: 85, column: 127 } }
            })) != null
                ? stack1
                : '') +
            ' >' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'websiteDisplay') || (depth0 != null ? lookupProperty(depth0, 'websiteDisplay') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, {
                          name: 'websiteDisplay',
                          hash: {},
                          data: data,
                          loc: { start: { line: 85, column: 129 }, end: { line: 85, column: 147 } }
                      })
                    : helper)
            ) +
            '</a></p>'
        );
    },
    '45': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<p>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programCallLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 86, column: 23 }, end: { line: 86, column: 50 } }
                })
            ) +
            ': <a href="' +
            alias3(
                (lookupProperty(helpers, 'telScheme') || (depth0 && lookupProperty(depth0, 'telScheme')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'phone') : depth0,
                    { name: 'telScheme', hash: {}, data: data, loc: { start: { line: 86, column: 61 }, end: { line: 86, column: 80 } } }
                )
            ) +
            '" ' +
            ((stack1 = (lookupProperty(helpers, 'analytics') || (depth0 && lookupProperty(depth0, 'analytics')) || alias2).call(alias1, {
                name: 'analytics',
                hash: { action: 'click.phone', category: 'places.program' },
                data: data,
                loc: { start: { line: 86, column: 82 }, end: { line: 86, column: 144 } }
            })) != null
                ? stack1
                : '') +
            ' >' +
            alias3(
                (lookupProperty(helpers, 'telephone') || (depth0 && lookupProperty(depth0, 'telephone')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'phone') : depth0,
                    { name: 'telephone', hash: {}, data: data, loc: { start: { line: 86, column: 146 }, end: { line: 86, column: 165 } } }
                )
            ) +
            '</a></p>'
        );
    },
    '47': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                                <p class="d-print-none">\n                                    <a href="rts_share:" data-label="emailProgramContactLabel" data-body="emailProgramContactBody" data-mode="email" data-url="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'email') || (depth0 != null ? lookupProperty(depth0, 'email') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'email', hash: {}, data: data, loc: { start: { line: 89, column: 159 }, end: { line: 89, column: 168 } } })
                    : helper)
            ) +
            '" data-href="mailto:' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'email') || (depth0 != null ? lookupProperty(depth0, 'email') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'email', hash: {}, data: data, loc: { start: { line: 89, column: 188 }, end: { line: 89, column: 197 } } })
                    : helper)
            ) +
            '" data-focus="rtsShare_A" data-modal-modal="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(20, data, 0),
                inverse: container.program(22, data, 0),
                data: data,
                loc: { start: { line: 89, column: 241 }, end: { line: 89, column: 287 } }
            })) != null
                ? stack1
                : '') +
            '" class="btn btn-primary w-100" ' +
            ((stack1 = (lookupProperty(helpers, 'analytics') || (depth0 && lookupProperty(depth0, 'analytics')) || alias2).call(alias1, {
                name: 'analytics',
                hash: { action: 'click.email', category: 'places.program' },
                data: data,
                loc: { start: { line: 89, column: 319 }, end: { line: 89, column: 381 } }
            })) != null
                ? stack1
                : '') +
            ' >' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonSendEmail', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 89, column: 383 }, end: { line: 89, column: 409 } }
                })
            ) +
            '</a>\n                                </p>\n                                <p class="d-none d-print-inline">' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programEmailLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 91, column: 65 }, end: { line: 91, column: 102 } }
                })
            ) +
            ' ' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'email') || (depth0 != null ? lookupProperty(depth0, 'email') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'email', hash: {}, data: data, loc: { start: { line: 91, column: 103 }, end: { line: 91, column: 112 } } })
                    : helper)
            ) +
            '</p>\n'
        );
    },
    '49': function (container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            alias4 = 'function',
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programWebsiteLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 96, column: 71 }, end: { line: 96, column: 110 } }
                })
            ) +
            '</span> ' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'website') || (depth0 != null ? lookupProperty(depth0, 'website') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'website', hash: {}, data: data, loc: { start: { line: 96, column: 118 }, end: { line: 96, column: 129 } } })
                    : helper)
            ) +
            '</p>\n                    <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programPhoneLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 97, column: 71 }, end: { line: 97, column: 108 } }
                })
            ) +
            '</span> ' +
            alias3(
                (lookupProperty(helpers, 'telephone') || (depth0 && lookupProperty(depth0, 'telephone')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'phone') : depth0,
                    { name: 'telephone', hash: {}, data: data, loc: { start: { line: 97, column: 116 }, end: { line: 97, column: 135 } } }
                )
            ) +
            '</p>\n                    <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programEmailLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 98, column: 71 }, end: { line: 98, column: 108 } }
                })
            ) +
            '</span> ' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'email') || (depth0 != null ? lookupProperty(depth0, 'email') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'email', hash: {}, data: data, loc: { start: { line: 98, column: 116 }, end: { line: 98, column: 125 } } })
                    : helper)
            ) +
            '</p>\n'
        );
    },
    '51': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            alias4 = 'function',
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div name="edit" class="edit ' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(52, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 105, column: 37 }, end: { line: 105, column: 72 } }
            })) != null
                ? stack1
                : '') +
            '">\n            <form name="summary" class="form-compact needs-validation" role="form" novalidate>\n                <div class="row">\n                    <div class="form-group col-12 col-md-6">\n                        <label class="title" for="name">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programNameLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 109, column: 56 }, end: { line: 109, column: 83 } }
                })
            ) +
            ':</label>\n                        <input name="name" class="form-control" type="text" value="' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 110, column: 83 }, end: { line: 110, column: 91 } } })
                    : helper)
            ) +
            '" required/>\n                        <div class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'requiredInvalidFeedback', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 111, column: 54 }, end: { line: 111, column: 88 } }
                })
            ) +
            '</div>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="form-group col-12">\n                        <label class="title" for="description">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'descriptionLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 116, column: 63 }, end: { line: 116, column: 99 } }
                })
            ) +
            '</label>\n                        <input name="description" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'description') || (depth0 != null ? lookupProperty(depth0, 'description') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'description',
                          hash: {},
                          data: data,
                          loc: { start: { line: 117, column: 90 }, end: { line: 117, column: 105 } }
                      })
                    : helper)
            ) +
            '" />\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="form-group col-12 col-sm-4">\n                        <label class="title" for="description">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programWebsiteLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 122, column: 63 }, end: { line: 122, column: 102 } }
                })
            ) +
            '</label>\n                        <input name="website" class="form-control" type="website" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'website') || (depth0 != null ? lookupProperty(depth0, 'website') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'website', hash: {}, data: data, loc: { start: { line: 123, column: 89 }, end: { line: 123, column: 100 } } })
                    : helper)
            ) +
            '" pattern="' +
            ((stack1 = (lookupProperty(helpers, 'pattern') || (depth0 && lookupProperty(depth0, 'pattern')) || alias2).call(alias1, 'website', {
                name: 'pattern',
                hash: {},
                data: data,
                loc: { start: { line: 123, column: 111 }, end: { line: 123, column: 134 } }
            })) != null
                ? stack1
                : '') +
            '" />\n                        <div name="websiteInvalidFeedback" class="invalid-feedback">' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(
                alias1,
                'phoneWebsiteEmptyInvalidFeedback',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 124, column: 84 }, end: { line: 124, column: 129 } } }
            )) != null
                ? stack1
                : '') +
            '</div>\n                    </div>\n                    <div class="form-group col-12 col-sm-4">\n                        <label class="title" for="description">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programPhoneLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 127, column: 63 }, end: { line: 127, column: 100 } }
                })
            ) +
            '</label>\n                        <input name="phone" class="form-control" type="phone" value="' +
            alias3(
                (lookupProperty(helpers, 'telephone') || (depth0 && lookupProperty(depth0, 'telephone')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'phone') : depth0,
                    { name: 'telephone', hash: {}, data: data, loc: { start: { line: 128, column: 85 }, end: { line: 128, column: 104 } } }
                )
            ) +
            '" pattern="' +
            ((stack1 = (lookupProperty(helpers, 'pattern') || (depth0 && lookupProperty(depth0, 'pattern')) || alias2).call(alias1, 'phone', {
                name: 'pattern',
                hash: {},
                data: data,
                loc: { start: { line: 128, column: 115 }, end: { line: 128, column: 136 } }
            })) != null
                ? stack1
                : '') +
            '" />\n                        <div name="phoneInvalidFeedback" class="invalid-feedback">' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(
                alias1,
                'phoneWebsiteEmptyInvalidFeedback',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 129, column: 82 }, end: { line: 129, column: 127 } } }
            )) != null
                ? stack1
                : '') +
            '</div>\n                    </div>\n                    <div class="form-group col-12 col-sm-4">\n                        <label class="title" for="description">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programEmailLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 132, column: 63 }, end: { line: 132, column: 100 } }
                })
            ) +
            '</label>\n                        <input name="email" class="form-control" pattern="[^@\\s]+@[^@\\s]+\\.[^@\\s]+" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'email') || (depth0 != null ? lookupProperty(depth0, 'email') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'email', hash: {}, data: data, loc: { start: { line: 133, column: 107 }, end: { line: 133, column: 116 } } })
                    : helper)
            ) +
            '" />\n                        <div name="emailInvalidFeedback" class="invalid-feedback">' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'emailInvalidFeedback', {
                name: 'l10n',
                hash: {},
                data: data,
                loc: { start: { line: 134, column: 82 }, end: { line: 134, column: 115 } }
            })) != null
                ? stack1
                : '') +
            '</div>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="form-group col-12">\n                        <label class="title" for="location">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'addressLookupLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 139, column: 60 }, end: { line: 139, column: 89 } }
                })
            ) +
            '</label>\n                        <input name="location" class="form-control" type="text" value="" placeholder="Enter an address..." />\n                        <small name="locationComment" class="form-text text-muted truncate ml-1"></small>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="form-group col-12 col-sm-6">\n                        <label class="title" for="address1">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'address1Label', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 146, column: 60 }, end: { line: 146, column: 84 } }
                })
            ) +
            ':</label>\n                        <input name="address1" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'address1') || (depth0 != null ? lookupProperty(depth0, 'address1') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'address1', hash: {}, data: data, loc: { start: { line: 147, column: 87 }, end: { line: 147, column: 99 } } })
                    : helper)
            ) +
            '" />\n                    </div>\n                    <div class="form-group col-12 col-sm-6">\n                        <label class="title" for="address2">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'address2Label', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 150, column: 60 }, end: { line: 150, column: 84 } }
                })
            ) +
            ':</label>\n                        <input name="address2" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'address2') || (depth0 != null ? lookupProperty(depth0, 'address2') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'address2', hash: {}, data: data, loc: { start: { line: 151, column: 87 }, end: { line: 151, column: 99 } } })
                    : helper)
            ) +
            '" />\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="form-group col-12 col-sm-6">\n                        <label class="title" for="city">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'cityLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 156, column: 56 }, end: { line: 156, column: 76 } }
                })
            ) +
            ':</label>\n                        <input name="city" class="form-control" type="text" value="' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'city') || (depth0 != null ? lookupProperty(depth0, 'city') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'city', hash: {}, data: data, loc: { start: { line: 157, column: 83 }, end: { line: 157, column: 91 } } })
                    : helper)
            ) +
            '" />\n                    </div>\n                    <div class="form-group col-4 col-sm-2">\n                        <label class="title" for="state">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'stateLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 160, column: 57 }, end: { line: 160, column: 78 } }
                })
            ) +
            ':</label>\n                        <input name="state" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'state') || (depth0 != null ? lookupProperty(depth0, 'state') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'state', hash: {}, data: data, loc: { start: { line: 161, column: 84 }, end: { line: 161, column: 93 } } })
                    : helper)
            ) +
            '" />\n                    </div>\n                    <div class="form-group col-8 col-sm-4">\n                        <label class="title" for="zip">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'zipCodeLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 164, column: 55 }, end: { line: 164, column: 78 } }
                })
            ) +
            ':</label>\n                        <input name="zip" class="form-control" type="text" value="' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'zip') || (depth0 != null ? lookupProperty(depth0, 'zip') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'zip', hash: {}, data: data, loc: { start: { line: 165, column: 82 }, end: { line: 165, column: 89 } } })
                    : helper)
            ) +
            '" required pattern="' +
            ((stack1 = (lookupProperty(helpers, 'pattern') || (depth0 && lookupProperty(depth0, 'pattern')) || alias2).call(alias1, 'zip', {
                name: 'pattern',
                hash: {},
                data: data,
                loc: { start: { line: 165, column: 109 }, end: { line: 165, column: 128 } }
            })) != null
                ? stack1
                : '') +
            '" />\n                        <div class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'requiredInvalidFeedback', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 166, column: 54 }, end: { line: 166, column: 88 } }
                })
            ) +
            '</div>\n                    </div>\n                </div>\n                <div class="row' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(54, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 169, column: 31 }, end: { line: 169, column: 59 } }
            })) != null
                ? stack1
                : '') +
            '">\n                    <div class="form-group col-12 col-sm-4">\n                        ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: { selected: depth0 != null ? lookupProperty(depth0, 'programTypeId') : depth0, property: 'programTypeId', label: 'programTypeTitle' },
                data: data,
                loc: { start: { line: 171, column: 24 }, end: { line: 171, column: 114 } }
            })) != null
                ? stack1
                : '') +
            '\n                    </div>\n                    <div class="form-group col-12 col-sm-4">\n                        ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: {
                    selected: depth0 != null ? lookupProperty(depth0, 'programStatusTypeId') : depth0,
                    property: 'programStatusTypeId',
                    label: 'programStatusTypeTitle'
                },
                data: data,
                loc: { start: { line: 174, column: 24 }, end: { line: 174, column: 132 } }
            })) != null
                ? stack1
                : '') +
            '\n                    </div>\n                    <div class="form-group col-12 col-sm-4">\n                        ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: { selected: depth0 != null ? lookupProperty(depth0, 'siteTypeId') : depth0, property: 'siteTypeId', label: 'siteTypeTitle' },
                data: data,
                loc: { start: { line: 177, column: 24 }, end: { line: 177, column: 105 } }
            })) != null
                ? stack1
                : '') +
            '\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="form-group col-12 col-sm-4">\n                        ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    disabled: depth0 != null ? lookupProperty(depth0, 'create') : depth0,
                    includeNoSelectionSentry: true,
                    groupId: depth0 != null ? lookupProperty(depth0, 'id') : depth0,
                    values: depth0 != null ? lookupProperty(depth0, 'householdTypeIds') : depth0,
                    property: 'householdTypeIds',
                    label: 'householdTypeTitle'
                },
                data: data,
                loc: { start: { line: 182, column: 24 }, end: { line: 182, column: 181 } }
            })) != null
                ? stack1
                : '') +
            '\n                        <div name="householdTypeIdsFeedback" class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'selectOneOrMorePrompt', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 183, column: 86 }, end: { line: 183, column: 118 } }
                })
            ) +
            '</div>\n                        <label class="edit-item-title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'payForGroupLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 185, column: 55 }, end: { line: 185, column: 82 } }
                })
            ) +
            '</label>\n                        <div class="custom-control custom-checkbox">\n                            <input type="checkbox" class="custom-control-input" id="canPayForWithHousingSupport" name="canPayForWithHousingSupport" data-id="1" value="true"' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'canPayForWithHousingSupport') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(56, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 187, column: 172 }, end: { line: 187, column: 222 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(56, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 187, column: 222 }, end: { line: 187, column: 251 } }
            })) != null
                ? stack1
                : '') +
            '>\n                            <label class="custom-control-label" for="canPayForWithHousingSupport">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'canPayForWithHousingSupportLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 188, column: 98 }, end: { line: 188, column: 141 } }
                })
            ) +
            '</label>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'canPayForWithHousingSupport') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(58, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 189, column: 24 }, end: { line: 191, column: 31 } }
            })) != null
                ? stack1
                : '') +
            '                        </div>\n                        <div class="custom-control custom-checkbox">\n                            <input type="checkbox" class="custom-control-input" id="canPayPrivate" name="canPayPrivate" data-id="1" value="true"' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'canPayPrivate') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(56, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 194, column: 144 }, end: { line: 194, column: 180 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(56, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 194, column: 180 }, end: { line: 194, column: 209 } }
            })) != null
                ? stack1
                : '') +
            '>\n                            <label class="custom-control-label" for="canPayPrivate">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'canPayPrivateLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 195, column: 84 }, end: { line: 195, column: 113 } }
                })
            ) +
            '</label>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'canPayPrivate') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(60, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 196, column: 24 }, end: { line: 198, column: 31 } }
            })) != null
                ? stack1
                : '') +
            '                        </div>\n                    </div>\n                    <div class="form-group col-12 col-sm-4' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(54, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 201, column: 58 }, end: { line: 201, column: 86 } }
            })) != null
                ? stack1
                : '') +
            '">\n                        ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    disabled: depth0 != null ? lookupProperty(depth0, 'create') : depth0,
                    includeNoSelectionSentry: true,
                    groupId: depth0 != null ? lookupProperty(depth0, 'id') : depth0,
                    values: depth0 != null ? lookupProperty(depth0, 'serviceForDiagnosisTypeIds') : depth0,
                    property: 'serviceForDiagnosisTypeIds',
                    label: 'serviceForDiagnosisTypeTitle'
                },
                data: data,
                loc: { start: { line: 202, column: 24 }, end: { line: 202, column: 211 } }
            })) != null
                ? stack1
                : '') +
            '\n                    </div>\n                    <div class="form-group col-12 col-sm-4' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(54, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 204, column: 58 }, end: { line: 204, column: 86 } }
            })) != null
                ? stack1
                : '') +
            '">\n                        ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    disabled: depth0 != null ? lookupProperty(depth0, 'create') : depth0,
                    includeNoSelectionSentry: true,
                    groupId: depth0 != null ? lookupProperty(depth0, 'id') : depth0,
                    values: depth0 != null ? lookupProperty(depth0, 'canServeMAWaiversTypeIds') : depth0,
                    property: 'canServeMAWaiversTypeIds',
                    label: 'canServeMAWaiversTypeTitle'
                },
                data: data,
                loc: { start: { line: 205, column: 24 }, end: { line: 205, column: 205 } }
            })) != null
                ? stack1
                : '') +
            '\n                    </div>\n                </div>\n                <input name="county" class="hidden" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'county') || (depth0 != null ? lookupProperty(depth0, 'county') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'county', hash: {}, data: data, loc: { start: { line: 208, column: 71 }, end: { line: 208, column: 81 } } })
                    : helper)
            ) +
            '" />\n                <input name="countyId" class="hidden" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'countyId') || (depth0 != null ? lookupProperty(depth0, 'countyId') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'countyId', hash: {}, data: data, loc: { start: { line: 209, column: 73 }, end: { line: 209, column: 85 } } })
                    : helper)
            ) +
            '" />\n                <input name="latitude" class="hidden" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'latitudeCache') || (depth0 != null ? lookupProperty(depth0, 'latitudeCache') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'latitudeCache',
                          hash: {},
                          data: data,
                          loc: { start: { line: 210, column: 73 }, end: { line: 210, column: 90 } }
                      })
                    : helper)
            ) +
            '" />\n                <input name="longitude" class="hidden" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'longitudeCache') || (depth0 != null ? lookupProperty(depth0, 'longitudeCache') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'longitudeCache',
                          hash: {},
                          data: data,
                          loc: { start: { line: 211, column: 74 }, end: { line: 211, column: 92 } }
                      })
                    : helper)
            ) +
            '" />\n            </form>\n            <hr>\n        </div> <!-- /edit -->\n'
        );
    },
    '52': function (container, depth0, helpers, partials, data) {
        return 'hidden';
    },
    '54': function (container, depth0, helpers, partials, data) {
        return ' hidden';
    },
    '56': function (container, depth0, helpers, partials, data) {
        return ' checked';
    },
    '58': function (container, depth0, helpers, partials, data) {
        return '                            <input type="checkbox" class="hidden" name="canPayForWithHousingSupport" data-id="-1" value="-1" checked>\n';
    },
    '60': function (container, depth0, helpers, partials, data) {
        return '                            <input type="checkbox" class="hidden" name="canPayPrivate" data-id="-1" value="-1" checked>\n';
    },
    '62': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '    <div name="contacts" class="contacts display-edit section">\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(63, data, 0),
                inverse: container.program(65, data, 0),
                data: data,
                loc: { start: { line: 227, column: 4 }, end: { line: 232, column: 15 } }
            })) != null
                ? stack1
                : '') +
            '    </div>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(67, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 234, column: 4 }, end: { line: 239, column: 11 } }
            })) != null
                ? stack1
                : '')
        );
    },
    '63': function (container, depth0, helpers, partials, data) {
        return '        <div name="contactsList"></div>\n';
    },
    '65': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <h2>Primary Contact</h2>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'contactEdit'), depth0, {
                name: 'contactEdit',
                hash: { primaryContact: true, programContact: true },
                data: data,
                indent: '        ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '')
        );
    },
    '67': function (container, depth0, helpers, partials, data) {
        var alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '    <div class="clearfix pr-3">\n        <button name="save" class="btn btn-edit btn-primary float-right" data-action="save" data-section="summary" disabled="disabled">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonSave', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 236, column: 135 }, end: { line: 236, column: 156 } }
                })
            ) +
            '</button>\n        <button name="cancel" class="btn btn-edit float-right mr-1" data-action="cancel" data-section="summary">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonCancel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 237, column: 112 }, end: { line: 237, column: 135 } }
                })
            ) +
            '</button>\n    </div>\n'
        );
    },
    '69': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            alias4 = 'function',
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '    <ul class="nav d-print-none">\n        <li class="nav-item">\n            <a href="#units" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonUnitTypes', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 244, column: 60 }, end: { line: 244, column: 86 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#pictures" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonPictures', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 247, column: 63 }, end: { line: 247, column: 88 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#services" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonServices', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 250, column: 63 }, end: { line: 250, column: 88 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#rules" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonRules', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 253, column: 60 }, end: { line: 253, column: 82 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#dailyLife" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonDailyLife', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 256, column: 64 }, end: { line: 256, column: 90 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#location" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonLocation', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 259, column: 63 }, end: { line: 259, column: 88 } }
                })
            ) +
            '</a>\n        </li>\n    </ul>\n    <div name="unitsSection" id="units"></div>\n    <ul class="nav d-print-none">\n        <li class="nav-item">\n            <a href="#units" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonUnitTypes', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 265, column: 60 }, end: { line: 265, column: 86 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#pictures" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonPictures', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 268, column: 63 }, end: { line: 268, column: 88 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#services" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonServices', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 271, column: 63 }, end: { line: 271, column: 88 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#rules" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonRules', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 274, column: 60 }, end: { line: 274, column: 82 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#dailyLife" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonDailyLife', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 277, column: 64 }, end: { line: 277, column: 90 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#location" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonLocation', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 280, column: 63 }, end: { line: 280, column: 88 } }
                })
            ) +
            '</a>\n        </li>\n    </ul>\n    <div name="imagesSection" id="pictures"></div>\n    <div name="services" id="services" class="services section">\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: { editable: depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, name: 'services', title: 'servicesTitle' },
                data: data,
                indent: '        ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '        <div name="display" class="display row">\n            <div class="col-12 col-sm-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buildingAccessTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 288, column: 67 }, end: { line: 288, column: 110 } }
                })
            ) +
            '</span></p>\n                ' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'buildingAccessTypeIds') : depth0, property: 'buildingAccessTypeIds' },
                data: data,
                loc: { start: { line: 289, column: 16 }, end: { line: 289, column: 88 } }
            })) != null
                ? stack1
                : '') +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'buildingAccessComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(70, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 290, column: 16 }, end: { line: 292, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'serviceOnSiteTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 293, column: 67 }, end: { line: 293, column: 109 } }
                })
            ) +
            '</span></p>\n                ' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'serviceOnSiteTypeIds') : depth0, property: 'serviceOnSiteTypeIds' },
                data: data,
                loc: { start: { line: 294, column: 16 }, end: { line: 294, column: 86 } }
            })) != null
                ? stack1
                : '') +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'serviceOnSiteComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(72, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 295, column: 16 }, end: { line: 297, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="col-12 col-sm-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'medicationServicesTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 300, column: 67 }, end: { line: 300, column: 114 } }
                })
            ) +
            '</span></p>\n                ' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'medicationServicesTypeIds') : depth0, property: 'medicationServicesTypeIds' },
                data: data,
                loc: { start: { line: 301, column: 16 }, end: { line: 301, column: 96 } }
            })) != null
                ? stack1
                : '') +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'medicationPolicyComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(74, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 302, column: 16 }, end: { line: 304, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="col-12 col-sm-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'serviceParticipationTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 307, column: 67 }, end: { line: 307, column: 116 } }
                })
            ) +
            '</span></p>\n                ' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'serviceParticipationTypeIds') : depth0, property: 'serviceParticipationTypeIds' },
                data: data,
                loc: { start: { line: 308, column: 16 }, end: { line: 308, column: 100 } }
            })) != null
                ? stack1
                : '') +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'serviceParticipationComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(76, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 309, column: 16 }, end: { line: 311, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '            </div>\n        </div>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(78, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 314, column: 0 }, end: { line: 347, column: 7 } }
            })) != null
                ? stack1
                : '') +
            '    </div>\n    <div name="rules" class="rules section" id="rules">\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: { editable: depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, name: 'rules', title: 'rulesTitle' },
                data: data,
                indent: '        ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '        <div name="display" class="display row">\n            <div class="col-12 col-sm-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'criminalBackgroundTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 353, column: 67 }, end: { line: 353, column: 114 } }
                })
            ) +
            '</span></p>\n                ' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'criminalBackgroundTypeIds') : depth0, property: 'criminalBackgroundTypeIds' },
                data: data,
                loc: { start: { line: 354, column: 16 }, end: { line: 354, column: 96 } }
            })) != null
                ? stack1
                : '') +
            '\n            </div>\n            <div class="col-12 col-sm-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'sobrietyPolicyTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 357, column: 67 }, end: { line: 357, column: 110 } }
                })
            ) +
            '</span> ' +
            alias3(
                (lookupProperty(helpers, 'enum_l10n') || (depth0 && lookupProperty(depth0, 'enum_l10n')) || alias2).call(alias1, {
                    name: 'enum_l10n',
                    hash: { id: depth0 != null ? lookupProperty(depth0, 'sobrietyPolicyTypeId') : depth0, property: 'sobrietyPolicyTypeId' },
                    data: data,
                    loc: { start: { line: 357, column: 118 }, end: { line: 357, column: 187 } }
                })
            ) +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'sobrietyPolicyComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(80, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 358, column: 16 }, end: { line: 360, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '                </p>\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'sobrietyPeriodTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 362, column: 67 }, end: { line: 362, column: 110 } }
                })
            ) +
            '</span> ' +
            alias3(
                (lookupProperty(helpers, 'enum_l10n') || (depth0 && lookupProperty(depth0, 'enum_l10n')) || alias2).call(alias1, {
                    name: 'enum_l10n',
                    hash: { id: depth0 != null ? lookupProperty(depth0, 'sobrietyPeriodTypeId') : depth0, property: 'sobrietyPeriodTypeId' },
                    data: data,
                    loc: { start: { line: 362, column: 118 }, end: { line: 362, column: 187 } }
                })
            ) +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'sobrietyPeriodComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(82, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 363, column: 16 }, end: { line: 365, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '                </p>\n            </div>\n            <div class="col-12 col-sm-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'smokingPolicyTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 369, column: 67 }, end: { line: 369, column: 109 } }
                })
            ) +
            '</span> ' +
            alias3(
                (lookupProperty(helpers, 'enum_l10n') || (depth0 && lookupProperty(depth0, 'enum_l10n')) || alias2).call(alias1, {
                    name: 'enum_l10n',
                    hash: { id: depth0 != null ? lookupProperty(depth0, 'smokingPolicyTypeId') : depth0, property: 'smokingPolicyTypeId' },
                    data: data,
                    loc: { start: { line: 369, column: 117 }, end: { line: 369, column: 184 } }
                })
            ) +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'smokingPolicyComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(84, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 370, column: 16 }, end: { line: 372, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '                </p>\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'petPolicyTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 374, column: 67 }, end: { line: 374, column: 105 } }
                })
            ) +
            '</span></p>\n                ' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'petPolicyTypeIds') : depth0, property: 'petPolicyTypeIds' },
                data: data,
                loc: { start: { line: 375, column: 16 }, end: { line: 375, column: 78 } }
            })) != null
                ? stack1
                : '') +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'petPolicyComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(86, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 376, column: 16 }, end: { line: 378, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'curfewPolicyTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 379, column: 67 }, end: { line: 379, column: 108 } }
                })
            ) +
            '</span> ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'curfewPolicy') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(88, data, 0),
                inverse: container.program(90, data, 0),
                data: data,
                loc: { start: { line: 379, column: 116 }, end: { line: 379, column: 156 } }
            })) != null
                ? stack1
                : '') +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'curfewPolicyComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(92, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 380, column: 16 }, end: { line: 382, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '                </p>\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'visitorPolicyTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 384, column: 67 }, end: { line: 384, column: 109 } }
                })
            ) +
            '</span> ' +
            alias3(
                (lookupProperty(helpers, 'enum_l10n') || (depth0 && lookupProperty(depth0, 'enum_l10n')) || alias2).call(alias1, {
                    name: 'enum_l10n',
                    hash: { id: depth0 != null ? lookupProperty(depth0, 'visitorPolicyTypeId') : depth0, property: 'visitorPolicyTypeId' },
                    data: data,
                    loc: { start: { line: 384, column: 117 }, end: { line: 384, column: 184 } }
                })
            ) +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'visitorPolicyComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(94, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 385, column: 16 }, end: { line: 387, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '                </p>\n            </div>\n        </div>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(96, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 391, column: 0 }, end: { line: 439, column: 7 } }
            })) != null
                ? stack1
                : '') +
            '    </div>\n    <div name="dailyLife" class="daily-life section" id="dailyLife">\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: { editable: depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, name: 'dailyLife', title: 'dailyLifeTitle' },
                data: data,
                indent: '        ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '        <div name="display" class="display row">\n            <div class="col-12 col-sm-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'culturalConsiderationsTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 445, column: 67 }, end: { line: 445, column: 114 } }
                })
            ) +
            '</span> ' +
            ((stack1 =
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'culturalConsiderationComment') ||
                        (depth0 != null ? lookupProperty(depth0, 'culturalConsiderationComment') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'culturalConsiderationComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 445, column: 122 }, end: { line: 445, column: 156 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '</p>\n            </div>\n            <div class="col-12 col-sm-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'mealsServedTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 448, column: 67 }, end: { line: 448, column: 107 } }
                })
            ) +
            '</span> ' +
            alias3(
                (lookupProperty(helpers, 'enum_l10n') || (depth0 && lookupProperty(depth0, 'enum_l10n')) || alias2).call(alias1, {
                    name: 'enum_l10n',
                    hash: { id: depth0 != null ? lookupProperty(depth0, 'mealsServedTypeId') : depth0, property: 'mealsServedTypeId' },
                    data: data,
                    loc: { start: { line: 448, column: 115 }, end: { line: 448, column: 178 } }
                })
            ) +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'mealsServedComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(99, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 449, column: 16 }, end: { line: 451, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '                </p>\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'kitchenTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 453, column: 67 }, end: { line: 453, column: 103 } }
                })
            ) +
            '</span> ' +
            alias3(
                (lookupProperty(helpers, 'enum_l10n') || (depth0 && lookupProperty(depth0, 'enum_l10n')) || alias2).call(alias1, {
                    name: 'enum_l10n',
                    hash: { id: depth0 != null ? lookupProperty(depth0, 'kitchenTypeId') : depth0, property: 'kitchenTypeId' },
                    data: data,
                    loc: { start: { line: 453, column: 111 }, end: { line: 453, column: 166 } }
                })
            ) +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'kitchenComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(101, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 454, column: 16 }, end: { line: 456, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '                </p>\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'religionActivityTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 458, column: 67 }, end: { line: 458, column: 112 } }
                })
            ) +
            '</span></p>\n                ' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'religionActivityTypeIds') : depth0, property: 'religionActivityTypeIds' },
                data: data,
                loc: { start: { line: 459, column: 16 }, end: { line: 459, column: 92 } }
            })) != null
                ? stack1
                : '') +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'religionActivityComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(103, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 460, column: 16 }, end: { line: 462, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="col-12 col-sm-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'languagesSpokenTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 465, column: 67 }, end: { line: 465, column: 111 } }
                })
            ) +
            '</span></p>\n                ' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'languagesSpokenTypeIds') : depth0, property: 'languagesSpokenTypeIds' },
                data: data,
                loc: { start: { line: 466, column: 16 }, end: { line: 466, column: 90 } }
            })) != null
                ? stack1
                : '') +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'languagesSpokenComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(105, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 467, column: 16 }, end: { line: 469, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '                </p>\n            </div>\n        </div>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(107, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 473, column: 0 }, end: { line: 510, column: 7 } }
            })) != null
                ? stack1
                : '') +
            '    </div>\n    <div name="xlocation" class="location section" id="location">\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: { editable: depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, name: 'xlocation', title: 'locationTitle' },
                data: data,
                indent: '        ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '        <div name="display" class="display row">\n            <div class="col-12 col-sm-4">\n                <p class="program-detail-item">' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'address1') || (depth0 != null ? lookupProperty(depth0, 'address1') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'address1', hash: {}, data: data, loc: { start: { line: 516, column: 47 }, end: { line: 516, column: 59 } } })
                    : helper)
            ) +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'address2') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(109, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 516, column: 59 }, end: { line: 516, column: 100 } }
            })) != null
                ? stack1
                : '') +
            '<br />' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'city') || (depth0 != null ? lookupProperty(depth0, 'city') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'city', hash: {}, data: data, loc: { start: { line: 516, column: 106 }, end: { line: 516, column: 114 } } })
                    : helper)
            ) +
            ', ' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'state') || (depth0 != null ? lookupProperty(depth0, 'state') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'state', hash: {}, data: data, loc: { start: { line: 516, column: 116 }, end: { line: 516, column: 125 } } })
                    : helper)
            ) +
            ' ' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'zip') || (depth0 != null ? lookupProperty(depth0, 'zip') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'zip', hash: {}, data: data, loc: { start: { line: 516, column: 126 }, end: { line: 516, column: 133 } } })
                    : helper)
            ) +
            '</p>\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'parkingTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 517, column: 67 }, end: { line: 517, column: 103 } }
                })
            ) +
            '</span> ' +
            alias3(
                (lookupProperty(helpers, 'enum_l10n') || (depth0 && lookupProperty(depth0, 'enum_l10n')) || alias2).call(alias1, {
                    name: 'enum_l10n',
                    hash: { id: depth0 != null ? lookupProperty(depth0, 'parkingTypeId') : depth0, property: 'parkingTypeId' },
                    data: data,
                    loc: { start: { line: 517, column: 111 }, end: { line: 517, column: 166 } }
                })
            ) +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'parkingComment') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(111, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 518, column: 16 }, end: { line: 520, column: 23 } }
            })) != null
                ? stack1
                : '') +
            '                </p>\n            </div>\n            <div class="col-12 col-sm-4">\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'mapDisabled') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(113, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 524, column: 8 }, end: { line: 528, column: 19 } }
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="col-12 col-sm-4 walkscore" name="walkscore">\n            </div>\n        </div>\n        <div name="display" class="display row">\n            <div class="col-12">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'additionalInformationTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 535, column: 67 }, end: { line: 535, column: 113 } }
                })
            ) +
            '</span> ' +
            alias3(
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'additionalInformation') || (depth0 != null ? lookupProperty(depth0, 'additionalInformation') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'additionalInformation',
                          hash: {},
                          data: data,
                          loc: { start: { line: 535, column: 121 }, end: { line: 535, column: 146 } }
                      })
                    : helper)
            ) +
            '</p>\n            </div>\n        </div>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(116, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 538, column: 0 }, end: { line: 563, column: 7 } }
            })) != null
                ? stack1
                : '') +
            '    </div>\n    <ul class="nav d-print-none">\n        <li class="nav-item">\n            <a href="#units" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonUnitTypes', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 567, column: 60 }, end: { line: 567, column: 86 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#pictures" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonPictures', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 570, column: 63 }, end: { line: 570, column: 88 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#services" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonServices', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 573, column: 63 }, end: { line: 573, column: 88 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#rules" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonRules', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 576, column: 60 }, end: { line: 576, column: 82 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#dailyLife" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonDailyLife', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 579, column: 64 }, end: { line: 579, column: 90 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a href="#location" class="btn btn-link scroll-to">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonLocation', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 582, column: 63 }, end: { line: 582, column: 88 } }
                })
            ) +
            '</a>\n        </li>\n    </ul>\n    ' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(118, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 585, column: 4 }, end: { line: 599, column: 26 } }
            })) != null
                ? stack1
                : '') +
            ' <!-- create, popout -->\n'
        );
    },
    '70': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <p>' +
            ((stack1 =
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'buildingAccessComment') || (depth0 != null ? lookupProperty(depth0, 'buildingAccessComment') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'buildingAccessComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 291, column: 23 }, end: { line: 291, column: 50 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '</p>\n'
        );
    },
    '72': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <p>' +
            ((stack1 =
                ((helper =
                    (helper = lookupProperty(helpers, 'serviceOnSiteComment') || (depth0 != null ? lookupProperty(depth0, 'serviceOnSiteComment') : depth0)) !=
                    null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'serviceOnSiteComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 296, column: 23 }, end: { line: 296, column: 49 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '</p>\n'
        );
    },
    '74': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <p>' +
            ((stack1 =
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'medicationPolicyComment') || (depth0 != null ? lookupProperty(depth0, 'medicationPolicyComment') : depth0)) !=
                    null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'medicationPolicyComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 303, column: 23 }, end: { line: 303, column: 52 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '</p>\n'
        );
    },
    '76': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <p>' +
            ((stack1 =
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'serviceParticipationComment') ||
                        (depth0 != null ? lookupProperty(depth0, 'serviceParticipationComment') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'serviceParticipationComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 310, column: 23 }, end: { line: 310, column: 56 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '</p>\n'
        );
    },
    '78': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            alias4 = 'function',
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div name="edit" class="edit hidden">\n            <form name="services" class="form-compact needs-validation" role="form" novalidate>\n                <div class="row">\n                    <div class="col-12 col-sm-4">\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    includeNoSelectionSentry: true,
                    groupId: depth0 != null ? lookupProperty(depth0, 'id') : depth0,
                    values: depth0 != null ? lookupProperty(depth0, 'buildingAccessTypeIds') : depth0,
                    property: 'buildingAccessTypeIds',
                    label: 'buildingAccessTypeTitle'
                },
                data: data,
                loc: { start: { line: 320, column: 28 }, end: { line: 320, column: 184 } }
            })) != null
                ? stack1
                : '') +
            '\n                            <label for="buildingAccessComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 321, column: 63 }, end: { line: 321, column: 95 } }
                })
            ) +
            '</label>\n                            <input name="buildingAccessComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'buildingAccessComment') || (depth0 != null ? lookupProperty(depth0, 'buildingAccessComment') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'buildingAccessComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 322, column: 104 }, end: { line: 322, column: 129 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    includeNoSelectionSentry: true,
                    groupId: depth0 != null ? lookupProperty(depth0, 'id') : depth0,
                    values: depth0 != null ? lookupProperty(depth0, 'serviceOnSiteTypeIds') : depth0,
                    property: 'serviceOnSiteTypeIds',
                    label: 'serviceOnSiteTypeTitle'
                },
                data: data,
                loc: { start: { line: 325, column: 28 }, end: { line: 325, column: 181 } }
            })) != null
                ? stack1
                : '') +
            '\n                            <label for="serviceOnSiteComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 326, column: 62 }, end: { line: 326, column: 94 } }
                })
            ) +
            '</label>\n                            <input name="serviceOnSiteComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'serviceOnSiteComment') || (depth0 != null ? lookupProperty(depth0, 'serviceOnSiteComment') : depth0)) !=
                    null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'serviceOnSiteComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 327, column: 103 }, end: { line: 327, column: 127 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                    </div>\n                    <div class="col-12 col-sm-4">\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    includeNoSelectionSentry: true,
                    groupId: depth0 != null ? lookupProperty(depth0, 'id') : depth0,
                    values: depth0 != null ? lookupProperty(depth0, 'medicationServicesTypeIds') : depth0,
                    property: 'medicationServicesTypeIds',
                    label: 'medicationServicesTypeTitle'
                },
                data: data,
                loc: { start: { line: 332, column: 28 }, end: { line: 332, column: 196 } }
            })) != null
                ? stack1
                : '') +
            '\n                            <label for="medicationPolicyComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 333, column: 65 }, end: { line: 333, column: 97 } }
                })
            ) +
            '</label>\n                            <input name="medicationPolicyComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'medicationPolicyComment') || (depth0 != null ? lookupProperty(depth0, 'medicationPolicyComment') : depth0)) !=
                    null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'medicationPolicyComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 334, column: 106 }, end: { line: 334, column: 133 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                    </div>\n                    <div class="col-12 col-sm-4">\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    includeNoSelectionSentry: true,
                    groupId: depth0 != null ? lookupProperty(depth0, 'id') : depth0,
                    values: depth0 != null ? lookupProperty(depth0, 'serviceParticipationTypeIds') : depth0,
                    property: 'serviceParticipationTypeIds',
                    label: 'serviceParticipationTypeTitle'
                },
                data: data,
                loc: { start: { line: 339, column: 28 }, end: { line: 339, column: 202 } }
            })) != null
                ? stack1
                : '') +
            '\n                            <label for="serviceParticipationComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 340, column: 69 }, end: { line: 340, column: 101 } }
                })
            ) +
            '</label>\n                            <input name="serviceParticipationComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'serviceParticipationComment') ||
                        (depth0 != null ? lookupProperty(depth0, 'serviceParticipationComment') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'serviceParticipationComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 341, column: 110 }, end: { line: 341, column: 141 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n'
        );
    },
    '80': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <br />' +
            ((stack1 =
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'sobrietyPolicyComment') || (depth0 != null ? lookupProperty(depth0, 'sobrietyPolicyComment') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'sobrietyPolicyComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 359, column: 26 }, end: { line: 359, column: 53 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    '82': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <br />' +
            ((stack1 =
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'sobrietyPeriodComment') || (depth0 != null ? lookupProperty(depth0, 'sobrietyPeriodComment') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'sobrietyPeriodComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 364, column: 26 }, end: { line: 364, column: 53 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    '84': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <br />' +
            ((stack1 =
                ((helper =
                    (helper = lookupProperty(helpers, 'smokingPolicyComment') || (depth0 != null ? lookupProperty(depth0, 'smokingPolicyComment') : depth0)) !=
                    null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'smokingPolicyComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 371, column: 26 }, end: { line: 371, column: 52 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    '86': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <p>' +
            ((stack1 =
                ((helper =
                    (helper = lookupProperty(helpers, 'petPolicyComment') || (depth0 != null ? lookupProperty(depth0, 'petPolicyComment') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'petPolicyComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 377, column: 23 }, end: { line: 377, column: 45 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '</p>\n'
        );
    },
    '88': function (container, depth0, helpers, partials, data) {
        return 'Yes';
    },
    '90': function (container, depth0, helpers, partials, data) {
        return 'No';
    },
    '92': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <br />' +
            ((stack1 =
                ((helper =
                    (helper = lookupProperty(helpers, 'curfewPolicyComment') || (depth0 != null ? lookupProperty(depth0, 'curfewPolicyComment') : depth0)) !=
                    null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'curfewPolicyComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 381, column: 26 }, end: { line: 381, column: 51 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    '94': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <br /><span class="max-three-lines" title="' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'visitorPolicyComment') || (depth0 != null ? lookupProperty(depth0, 'visitorPolicyComment') : depth0)) !=
                    null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, {
                          name: 'visitorPolicyComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 386, column: 63 }, end: { line: 386, column: 87 } }
                      })
                    : helper)
            ) +
            '">' +
            ((stack1 =
                ((helper =
                    (helper = lookupProperty(helpers, 'visitorPolicyComment') || (depth0 != null ? lookupProperty(depth0, 'visitorPolicyComment') : depth0)) !=
                    null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, {
                          name: 'visitorPolicyComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 386, column: 89 }, end: { line: 386, column: 115 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '</span>\n'
        );
    },
    '96': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            alias4 = 'function',
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div name="edit" class="edit hidden">\n            <form name="rules" class="form-compact needs-validation" role="form" novalidate>\n                <div class="row">\n                    <div class="col-12 col-sm-4">\n                        ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    includeNoSelectionSentry: true,
                    groupId: depth0 != null ? lookupProperty(depth0, 'id') : depth0,
                    values: depth0 != null ? lookupProperty(depth0, 'criminalBackgroundTypeIds') : depth0,
                    property: 'criminalBackgroundTypeIds',
                    label: 'criminalBackgroundTypeTitle'
                },
                data: data,
                loc: { start: { line: 396, column: 24 }, end: { line: 396, column: 192 } }
            })) != null
                ? stack1
                : '') +
            '\n                    </div>\n                    <div class="col-12 col-sm-4">\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: {
                    selected: depth0 != null ? lookupProperty(depth0, 'sobrietyPolicyTypeId') : depth0,
                    property: 'sobrietyPolicyTypeId',
                    label: 'sobrietyPolicyTypeTitle'
                },
                data: data,
                loc: { start: { line: 400, column: 28 }, end: { line: 400, column: 139 } }
            })) != null
                ? stack1
                : '') +
            '\n                            <label for="sobrietyPolicyComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 401, column: 63 }, end: { line: 401, column: 95 } }
                })
            ) +
            '</label>\n                            <input name="sobrietyPolicyComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'sobrietyPolicyComment') || (depth0 != null ? lookupProperty(depth0, 'sobrietyPolicyComment') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'sobrietyPolicyComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 402, column: 104 }, end: { line: 402, column: 129 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: {
                    selected: depth0 != null ? lookupProperty(depth0, 'sobrietyPeriodTypeId') : depth0,
                    property: 'sobrietyPeriodTypeId',
                    label: 'sobrietyPeriodTypeTitle'
                },
                data: data,
                loc: { start: { line: 405, column: 28 }, end: { line: 405, column: 139 } }
            })) != null
                ? stack1
                : '') +
            '\n                            <label for="sobrietyPeriodComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 406, column: 63 }, end: { line: 406, column: 95 } }
                })
            ) +
            '</label>\n                            <input name="sobrietyPeriodComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'sobrietyPeriodComment') || (depth0 != null ? lookupProperty(depth0, 'sobrietyPeriodComment') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'sobrietyPeriodComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 407, column: 104 }, end: { line: 407, column: 129 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                    </div>\n                    <div class="col-12 col-sm-4">\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: {
                    selected: depth0 != null ? lookupProperty(depth0, 'smokingPolicyTypeId') : depth0,
                    property: 'smokingPolicyTypeId',
                    label: 'smokingPolicyTypeTitle'
                },
                data: data,
                loc: { start: { line: 412, column: 28 }, end: { line: 412, column: 136 } }
            })) != null
                ? stack1
                : '') +
            '\n                            <label for="smokingPolicyComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 413, column: 62 }, end: { line: 413, column: 94 } }
                })
            ) +
            '</label>\n                            <input name="smokingPolicyComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'smokingPolicyComment') || (depth0 != null ? lookupProperty(depth0, 'smokingPolicyComment') : depth0)) !=
                    null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'smokingPolicyComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 414, column: 103 }, end: { line: 414, column: 127 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    includeNoSelectionSentry: true,
                    groupId: depth0 != null ? lookupProperty(depth0, 'id') : depth0,
                    values: depth0 != null ? lookupProperty(depth0, 'petPolicyTypeIds') : depth0,
                    property: 'petPolicyTypeIds',
                    label: 'petPolicyTypeTitle'
                },
                data: data,
                loc: { start: { line: 417, column: 28 }, end: { line: 417, column: 169 } }
            })) != null
                ? stack1
                : '') +
            '\n                            <label for="petPolicyComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 418, column: 58 }, end: { line: 418, column: 90 } }
                })
            ) +
            '</label>\n                            <input name="petPolicyComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'petPolicyComment') || (depth0 != null ? lookupProperty(depth0, 'petPolicyComment') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'petPolicyComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 419, column: 99 }, end: { line: 419, column: 119 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                        <div class="form-group">\n                            <label class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'curfewPolicyTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 422, column: 49 }, end: { line: 422, column: 90 } }
                })
            ) +
            '</label>\n                            <div class="custom-control custom-checkbox">\n                                <input type="checkbox" class="custom-control-input" id="curfewPolicy" name="curfewPolicy" value="true" data-unchecked-value="false" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'curfewPolicy') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(97, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 424, column: 164 }, end: { line: 424, column: 198 } }
            })) != null
                ? stack1
                : '') +
            ' >\n                                <label class="custom-control-label" for="curfewPolicy">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'curfewPolicyTypeTitle', {
                    name: 'l10n',
                    hash: { term: '?' },
                    data: data,
                    loc: { start: { line: 425, column: 87 }, end: { line: 425, column: 128 } }
                })
            ) +
            '</label>\n                            </div>\n                            <label for="curfewPolicyComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 427, column: 61 }, end: { line: 427, column: 93 } }
                })
            ) +
            '</label>\n                            <input name="curfewPolicyComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'curfewPolicyComment') || (depth0 != null ? lookupProperty(depth0, 'curfewPolicyComment') : depth0)) !=
                    null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'curfewPolicyComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 428, column: 102 }, end: { line: 428, column: 125 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: {
                    selected: depth0 != null ? lookupProperty(depth0, 'visitorPolicyTypeId') : depth0,
                    property: 'visitorPolicyTypeId',
                    label: 'visitorPolicyTypeTitle'
                },
                data: data,
                loc: { start: { line: 431, column: 28 }, end: { line: 431, column: 136 } }
            })) != null
                ? stack1
                : '') +
            '\n                            <label for="visitorPolicyComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 432, column: 62 }, end: { line: 432, column: 94 } }
                })
            ) +
            '</label>\n                            <input name="visitorPolicyComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'visitorPolicyComment') || (depth0 != null ? lookupProperty(depth0, 'visitorPolicyComment') : depth0)) !=
                    null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'visitorPolicyComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 433, column: 103 }, end: { line: 433, column: 127 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n'
        );
    },
    '97': function (container, depth0, helpers, partials, data) {
        return 'checked';
    },
    '99': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <br />' +
            ((stack1 =
                ((helper =
                    (helper = lookupProperty(helpers, 'mealsServedComment') || (depth0 != null ? lookupProperty(depth0, 'mealsServedComment') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'mealsServedComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 450, column: 26 }, end: { line: 450, column: 50 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    '101': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <br />' +
            ((stack1 =
                ((helper =
                    (helper = lookupProperty(helpers, 'kitchenComment') || (depth0 != null ? lookupProperty(depth0, 'kitchenComment') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'kitchenComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 455, column: 26 }, end: { line: 455, column: 46 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    '103': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <p>' +
            ((stack1 =
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'religionActivityComment') || (depth0 != null ? lookupProperty(depth0, 'religionActivityComment') : depth0)) !=
                    null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'religionActivityComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 461, column: 23 }, end: { line: 461, column: 52 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '</p>\n'
        );
    },
    '105': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <p>' +
            ((stack1 =
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'languagesSpokenComment') || (depth0 != null ? lookupProperty(depth0, 'languagesSpokenComment') : depth0)) !=
                    null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'languagesSpokenComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 468, column: 23 }, end: { line: 468, column: 51 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '</p>\n'
        );
    },
    '107': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            alias4 = 'function',
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div name="edit" class="edit hidden">\n            <form name="dailyLife" class="form-compact needs-validation" role="form" novalidate>\n                <div class="row">\n                    <div class="col-12 col-sm-4">\n                        <div class="form-group">\n                            <label class="title" for="description">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'culturalConsiderationsTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 479, column: 67 }, end: { line: 479, column: 114 } }
                })
            ) +
            '</label>\n                            <textarea name="culturalConsiderationComment" class="form-control" rows="3">' +
            ((stack1 =
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'culturalConsiderationComment') ||
                        (depth0 != null ? lookupProperty(depth0, 'culturalConsiderationComment') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'culturalConsiderationComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 480, column: 104 }, end: { line: 480, column: 138 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '</textarea>\n                        </div>\n                    </div>\n                    <div class="col-12 col-sm-4">\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: {
                    selected: depth0 != null ? lookupProperty(depth0, 'mealsServedTypeId') : depth0,
                    property: 'mealsServedTypeId',
                    label: 'mealsServedTypeTitle'
                },
                data: data,
                loc: { start: { line: 485, column: 28 }, end: { line: 485, column: 130 } }
            })) != null
                ? stack1
                : '') +
            '\n                            <label for="mealsServedComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 486, column: 60 }, end: { line: 486, column: 92 } }
                })
            ) +
            '</label>\n                            <input name="mealsServedComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'mealsServedComment') || (depth0 != null ? lookupProperty(depth0, 'mealsServedComment') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'mealsServedComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 487, column: 101 }, end: { line: 487, column: 123 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: { selected: depth0 != null ? lookupProperty(depth0, 'kitchenTypeId') : depth0, property: 'kitchenTypeId', label: 'kitchenTypeTitle' },
                data: data,
                loc: { start: { line: 490, column: 28 }, end: { line: 490, column: 118 } }
            })) != null
                ? stack1
                : '') +
            '\n                            <label for="kitchenComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 491, column: 56 }, end: { line: 491, column: 88 } }
                })
            ) +
            '</label>\n                            <input name="kitchenComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'kitchenComment') || (depth0 != null ? lookupProperty(depth0, 'kitchenComment') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'kitchenComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 492, column: 97 }, end: { line: 492, column: 115 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    includeNoSelectionSentry: true,
                    groupId: depth0 != null ? lookupProperty(depth0, 'id') : depth0,
                    values: depth0 != null ? lookupProperty(depth0, 'religionActivityTypeIds') : depth0,
                    property: 'religionActivityTypeIds',
                    label: 'religionActivityTypeTitle'
                },
                data: data,
                loc: { start: { line: 495, column: 28 }, end: { line: 495, column: 190 } }
            })) != null
                ? stack1
                : '') +
            '\n                            <label for="religionActivityComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 496, column: 65 }, end: { line: 496, column: 97 } }
                })
            ) +
            '</label>\n                            <input name="religionActivityComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'religionActivityComment') || (depth0 != null ? lookupProperty(depth0, 'religionActivityComment') : depth0)) !=
                    null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'religionActivityComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 497, column: 106 }, end: { line: 497, column: 133 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                    </div>\n                    <div class="col-12 col-sm-4">\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    includeNoSelectionSentry: true,
                    groupId: depth0 != null ? lookupProperty(depth0, 'id') : depth0,
                    values: depth0 != null ? lookupProperty(depth0, 'languagesSpokenTypeIds') : depth0,
                    property: 'languagesSpokenTypeIds',
                    label: 'languagesSpokenTypeTitle'
                },
                data: data,
                loc: { start: { line: 502, column: 28 }, end: { line: 502, column: 187 } }
            })) != null
                ? stack1
                : '') +
            '\n                            <label for="languagesSpokenComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 503, column: 64 }, end: { line: 503, column: 96 } }
                })
            ) +
            '</label>\n                            <input name="languagesSpokenComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'languagesSpokenComment') || (depth0 != null ? lookupProperty(depth0, 'languagesSpokenComment') : depth0)) !=
                    null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'languagesSpokenComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 504, column: 105 }, end: { line: 504, column: 131 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n'
        );
    },
    '109': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<br />' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'address2') || (depth0 != null ? lookupProperty(depth0, 'address2') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'address2',
                          hash: {},
                          data: data,
                          loc: { start: { line: 516, column: 81 }, end: { line: 516, column: 93 } }
                      })
                    : helper)
            )
        );
    },
    '111': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <br />' +
            ((stack1 =
                ((helper =
                    (helper = lookupProperty(helpers, 'parkingComment') || (depth0 != null ? lookupProperty(depth0, 'parkingComment') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'parkingComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 519, column: 26 }, end: { line: 519, column: 46 } }
                      })
                    : helper)) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    '113': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'if').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'latitudeCache') : depth0,
            {
                name: 'if',
                hash: {},
                fn: container.program(114, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 525, column: 12 }, end: { line: 527, column: 19 } }
            }
        )) != null
            ? stack1
            : '';
    },
    '114': function (container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                <iframe width="100%" height="300" frameborder="0" style="border:0" src="https://www.google.com/maps/embed/v1/view?zoom=17&center=' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'latitudeCache') || (depth0 != null ? lookupProperty(depth0, 'latitudeCache') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, {
                          name: 'latitudeCache',
                          hash: {},
                          data: data,
                          loc: { start: { line: 526, column: 145 }, end: { line: 526, column: 162 } }
                      })
                    : helper)
            ) +
            ',' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'longitudeCache') || (depth0 != null ? lookupProperty(depth0, 'longitudeCache') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, {
                          name: 'longitudeCache',
                          hash: {},
                          data: data,
                          loc: { start: { line: 526, column: 163 }, end: { line: 526, column: 181 } }
                      })
                    : helper)
            ) +
            '&key=' +
            alias4(
                (lookupProperty(helpers, 'configuration') || (depth0 && lookupProperty(depth0, 'configuration')) || alias2).call(alias1, 'googleApiKey', {
                    name: 'configuration',
                    hash: {},
                    data: data,
                    loc: { start: { line: 526, column: 186 }, end: { line: 526, column: 218 } }
                })
            ) +
            '" allowfullscreen></iframe>\n'
        );
    },
    '116': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            alias4 = 'function',
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div name="edit" class="edit hidden">\n            <form name="xlocation" class="form-compact needs-validation" role="form" novalidate>\n                <div class="row">\n                    <div class="col-12 col-sm-4">\n                        <div class="form-group">\n                            ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: { selected: depth0 != null ? lookupProperty(depth0, 'parkingTypeId') : depth0, property: 'parkingTypeId', label: 'parkingTypeTitle' },
                data: data,
                loc: { start: { line: 545, column: 28 }, end: { line: 545, column: 118 } }
            })) != null
                ? stack1
                : '') +
            '\n                        </div>\n					</div>\n					<div class="col-12 col-sm-4">\n                        <div class="form-group">\n                            <label for="parkingComment">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'commentTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 550, column: 56 }, end: { line: 550, column: 88 } }
                })
            ) +
            '</label>\n                            <input name="parkingComment" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'parkingComment') || (depth0 != null ? lookupProperty(depth0, 'parkingComment') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'parkingComment',
                          hash: {},
                          data: data,
                          loc: { start: { line: 551, column: 97 }, end: { line: 551, column: 115 } }
                      })
                    : helper)
            ) +
            '" />\n                        </div>\n					</div>\n					<div class="col-12 col-sm-4">\n                        <div class="form-group">\n                            <label for="additionalInformation">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'additionalInformationTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 556, column: 63 }, end: { line: 556, column: 109 } }
                })
            ) +
            '</label>\n                            <textarea name="additionalInformation" class="form-control" rows="3">' +
            alias3(
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'additionalInformation') || (depth0 != null ? lookupProperty(depth0, 'additionalInformation') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'additionalInformation',
                          hash: {},
                          data: data,
                          loc: { start: { line: 557, column: 97 }, end: { line: 557, column: 122 } }
                      })
                    : helper)
            ) +
            '</textarea>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n'
        );
    },
    '118': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'unless').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'create') : depth0,
            {
                name: 'unless',
                hash: {},
                fn: container.program(119, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 585, column: 22 }, end: { line: 599, column: 15 } }
            }
        )) != null
            ? stack1
            : '';
    },
    '119': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '\n    <div class="header d-print-none">\n        <div class="listings-nav">\n            <div class="buttons">\n                <button class="btn btn-primary" data-action="previous" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'isFirst') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(120, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 589, column: 71 }, end: { line: 589, column: 101 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonPrevious', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 589, column: 102 }, end: { line: 589, column: 127 } }
                })
            ) +
            '</button>\n                <button class="btn btn-primary" data-action="next" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'isLast') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(120, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 590, column: 67 }, end: { line: 590, column: 96 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonNext', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 590, column: 97 }, end: { line: 590, column: 118 } }
                })
            ) +
            '</button>\n            </div>\n            <h1>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'listingLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 592, column: 16 }, end: { line: 592, column: 39 } }
                })
            ) +
            ' <span name="offset">...</span> of <span name="count">...</span></h1>\n            <!-- <div></div> -->\n       </div>\n        <div class="btn-right">\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'closeButton'), depth0, {
                name: 'closeButton',
                hash: { lastTab: true, action: 'close' },
                data: data,
                indent: '            ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '        </div>\n    </div>\n    '
        );
    },
    '120': function (container, depth0, helpers, partials, data) {
        return 'disabled';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="content">\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 2, column: 0 }, end: { line: 18, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '	<div class="program-details-header">\n		<div class="program-title">\n			<h1 class="pl-3 ml-3"' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(7, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 26, column: 24 }, end: { line: 26, column: 69 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(9, data, 0),
                inverse: container.program(11, data, 0),
                data: data,
                loc: { start: { line: 26, column: 70 }, end: { line: 26, column: 126 } }
            })) != null
                ? stack1
                : '') +
            '</h1>\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(13, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 27, column: 4 }, end: { line: 39, column: 15 } }
            })) != null
                ? stack1
                : '') +
            '		</div>\n		<div class="program-vacancies">\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(28, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 42, column: 3 }, end: { line: 44, column: 14 } }
            })) != null
                ? stack1
                : '') +
            '		</div>\n   	</div>\n    <!-- <div name="imagesSection" id="images"></div> -->\n<div >\n</div>\n    <div name="freshlyMinted" class="freshly-minted alert alert-primary ' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'freshlyMinted') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(30, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 50, column: 72 }, end: { line: 50, column: 115 } }
            })) != null
                ? stack1
                : '') +
            '" role="alert">\n        ' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                alias1,
                'explainProgramCreated',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 51, column: 8 }, end: { line: 51, column: 42 } } }
            )) != null
                ? stack1
                : '') +
            '\n    </div>\n    <div name="summary" class="summary display-edit section">\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: {
                    deleteable: true,
                    editable: depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0,
                    name: 'summary',
                    title: 'summaryTitle'
                },
                data: data,
                indent: '        ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(32, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 55, column: 0 }, end: { line: 103, column: 11 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(51, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 104, column: 0 }, end: { line: 223, column: 7 } }
            })) != null
                ? stack1
                : '') +
            '    </div> <!-- summary -->\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(62, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 225, column: 0 }, end: { line: 240, column: 7 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(69, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 241, column: 0 }, end: { line: 600, column: 11 } }
            })) != null
                ? stack1
                : '') +
            ' <!-- create -->\n</div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['programMarkedFavorite'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return 'modalLabel';
    },
    '3': function (container, depth0, helpers, partials, data) {
        return 'modalModalLabel';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div class="modal-content" name="modalContent">\n            <div class="modal-header">\n                <h1 class="modal-title" id="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'modalModal') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(3, data, 0),
                data: data,
                loc: { start: { line: 3, column: 44 }, end: { line: 3, column: 110 } }
            })) != null
                ? stack1
                : '') +
            '">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programMarkedFavoriteLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 3, column: 112 }, end: { line: 3, column: 149 } }
                })
            ) +
            '</h1>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'closeButton'), depth0, {
                name: 'closeButton',
                data: data,
                indent: '                ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="modal-body">\n                    ' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programMarkedFavoriteText', {
                name: 'l10n',
                hash: {},
                data: data,
                loc: { start: { line: 7, column: 20 }, end: { line: 7, column: 58 } }
            })) != null
                ? stack1
                : '') +
            '\n            </div>\n            <div class="sr-only">End of dialog</div>\n        </div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['programSummary'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return ' yes';
    },
    '3': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'buttonFavoriteTrue',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 4, column: 89 }, end: { line: 4, column: 118 } } }
            )
        );
    },
    '5': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'buttonFavoriteFalse',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 4, column: 126 }, end: { line: 4, column: 156 } } }
            )
        );
    },
    '7': function (container, depth0, helpers, partials, data) {
        return '8';
    },
    '9': function (container, depth0, helpers, partials, data) {
        return '6';
    },
    '11': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            ' •&nbsp;' +
            container.escapeExpression(
                (lookupProperty(helpers, 'truncate') || (depth0 && lookupProperty(depth0, 'truncate')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    depth0 != null ? lookupProperty(depth0, 'distanceMiles') : depth0,
                    { name: 'truncate', hash: {}, data: data, loc: { start: { line: 11, column: 53 }, end: { line: 11, column: 79 } } }
                )
            ) +
            '&nbsp;miles'
        );
    },
    '13': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '			<p><span class="title">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'serviceForDiagnosisTypeTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 16, column: 26 }, end: { line: 16, column: 65 } }
                })
            ) +
            ':</span></p>\n			' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'serviceForDiagnosisTypeIds') : depth0, property: 'serviceForDiagnosisTypeIds' },
                data: data,
                loc: { start: { line: 17, column: 3 }, end: { line: 17, column: 85 } }
            })) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    '15': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '			<p><span class="title">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'canServeMAWaiversTypeTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 20, column: 26 }, end: { line: 20, column: 63 } }
                })
            ) +
            ':</span></p>\n			' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'canServeMAWaiversTypeIds') : depth0, property: 'canServeMAWaiversTypeIds' },
                data: data,
                loc: { start: { line: 21, column: 3 }, end: { line: 21, column: 81 } }
            })) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    '17': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '            <p class="program-detail-item"><span class="title">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    alias1,
                    'payForGroupLabel',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 24, column: 63 }, end: { line: 24, column: 90 } } }
                )
            ) +
            '</span></p>\n            <ul>\n                ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'canPayForWithHousingSupport') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(18, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 26, column: 16 }, end: { line: 26, column: 110 } }
            })) != null
                ? stack1
                : '') +
            '\n                ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'canPayPrivate') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(20, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 27, column: 16 }, end: { line: 27, column: 82 } }
            })) != null
                ? stack1
                : '') +
            '\n            </ul>\n'
        );
    },
    '18': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '<li>' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    'canPayForWithHousingSupportLabel',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 26, column: 55 }, end: { line: 26, column: 98 } } }
                )
            ) +
            '</li>'
        );
    },
    '20': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '<li>' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    'canPayPrivateLabel',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 27, column: 41 }, end: { line: 27, column: 70 } } }
                )
            ) +
            '</li>'
        );
    },
    '22': function (container, depth0, helpers, partials, data) {
        return '4';
    },
    '24': function (container, depth0, helpers, partials, data) {
        return '3';
    },
    '26': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '				<img alt="" src="' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'urlThumb') || (depth0 != null ? lookupProperty(depth0, 'urlThumb') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'urlThumb',
                          hash: {},
                          data: data,
                          loc: { start: { line: 34, column: 21 }, end: { line: 34, column: 33 } }
                      })
                    : helper)
            ) +
            '" />\n'
        );
    },
    '28': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'if').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'latitudeCache') : depth0,
            {
                name: 'if',
                hash: {},
                fn: container.program(29, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 39, column: 4 }, end: { line: 41, column: 11 } }
            }
        )) != null
            ? stack1
            : '';
    },
    '29': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '				<img alt="" src="' +
            ((stack1 = (lookupProperty(helpers, 'configuration') || (depth0 && lookupProperty(depth0, 'configuration')) || alias2).call(alias1, 'mapBase', {
                name: 'configuration',
                hash: {},
                data: data,
                loc: { start: { line: 40, column: 21 }, end: { line: 40, column: 50 } }
            })) != null
                ? stack1
                : '') +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'latitudeCache') || (depth0 != null ? lookupProperty(depth0, 'latitudeCache') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, {
                          name: 'latitudeCache',
                          hash: {},
                          data: data,
                          loc: { start: { line: 40, column: 50 }, end: { line: 40, column: 67 } }
                      })
                    : helper)
            ) +
            '/' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'longitudeCache') || (depth0 != null ? lookupProperty(depth0, 'longitudeCache') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, {
                          name: 'longitudeCache',
                          hash: {},
                          data: data,
                          loc: { start: { line: 40, column: 68 }, end: { line: 40, column: 86 } }
                      })
                    : helper)
            ) +
            '/map.png" />\n'
        );
    },
    '31': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div class="col-12 col-md-3">\n            <div class="card program-details-contacts mt-4 mt-md-0" name="programDetailsContacts">\n                <div class="card-header">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    alias1,
                    'contactForDetailsBlurb',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 48, column: 41 }, end: { line: 48, column: 74 } } }
                )
            ) +
            '</div>\n                <div class="card-body">\n                    ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'website') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(32, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 50, column: 20 }, end: { line: 50, column: 175 } }
            })) != null
                ? stack1
                : '') +
            '\n                    ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'phone') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(34, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 51, column: 20 }, end: { line: 51, column: 193 } }
            })) != null
                ? stack1
                : '') +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'email') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(36, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 52, column: 20 }, end: { line: 57, column: 27 } }
            })) != null
                ? stack1
                : '') +
            '                </div>\n            </div>\n        </div>\n'
        );
    },
    '32': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<p><a href="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'website') || (depth0 != null ? lookupProperty(depth0, 'website') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'website', hash: {}, data: data, loc: { start: { line: 50, column: 47 }, end: { line: 50, column: 58 } } })
                    : helper)
            ) +
            '" target="_blank" ' +
            ((stack1 = (lookupProperty(helpers, 'analytics') || (depth0 && lookupProperty(depth0, 'analytics')) || alias2).call(alias1, {
                name: 'analytics',
                hash: { action: 'click.website', category: 'places.program' },
                data: data,
                loc: { start: { line: 50, column: 76 }, end: { line: 50, column: 140 } }
            })) != null
                ? stack1
                : '') +
            ' >' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'websiteDisplay') || (depth0 != null ? lookupProperty(depth0, 'websiteDisplay') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, {
                          name: 'websiteDisplay',
                          hash: {},
                          data: data,
                          loc: { start: { line: 50, column: 142 }, end: { line: 50, column: 160 } }
                      })
                    : helper)
            ) +
            '</a></p>'
        );
    },
    '34': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<p>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programCallLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 51, column: 36 }, end: { line: 51, column: 63 } }
                })
            ) +
            ': <a href="' +
            alias3(
                (lookupProperty(helpers, 'telScheme') || (depth0 && lookupProperty(depth0, 'telScheme')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'phone') : depth0,
                    { name: 'telScheme', hash: {}, data: data, loc: { start: { line: 51, column: 74 }, end: { line: 51, column: 93 } } }
                )
            ) +
            '" ' +
            ((stack1 = (lookupProperty(helpers, 'analytics') || (depth0 && lookupProperty(depth0, 'analytics')) || alias2).call(alias1, {
                name: 'analytics',
                hash: { action: 'click.phone', category: 'places.program' },
                data: data,
                loc: { start: { line: 51, column: 95 }, end: { line: 51, column: 157 } }
            })) != null
                ? stack1
                : '') +
            ' >' +
            alias3(
                (lookupProperty(helpers, 'telephone') || (depth0 && lookupProperty(depth0, 'telephone')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'phone') : depth0,
                    { name: 'telephone', hash: {}, data: data, loc: { start: { line: 51, column: 159 }, end: { line: 51, column: 178 } } }
                )
            ) +
            '</a></p>'
        );
    },
    '36': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                        <p class="d-print-none">\n                            <a href="rts_share:" data-label="emailProgramContactLabel" data-body="emailProgramContactBody" data-mode="email" data-url="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'email') || (depth0 != null ? lookupProperty(depth0, 'email') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'email', hash: {}, data: data, loc: { start: { line: 54, column: 151 }, end: { line: 54, column: 160 } } })
                    : helper)
            ) +
            '" data-href="mailto:' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'email') || (depth0 != null ? lookupProperty(depth0, 'email') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'email', hash: {}, data: data, loc: { start: { line: 54, column: 180 }, end: { line: 54, column: 189 } } })
                    : helper)
            ) +
            '" data-modal-modal="true" class="btn btn-primary w-100" ' +
            ((stack1 = (lookupProperty(helpers, 'analytics') || (depth0 && lookupProperty(depth0, 'analytics')) || alias2).call(alias1, {
                name: 'analytics',
                hash: { action: 'click.email', category: 'places.program' },
                data: data,
                loc: { start: { line: 54, column: 245 }, end: { line: 54, column: 307 } }
            })) != null
                ? stack1
                : '') +
            ' >' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonSendEmail', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 54, column: 309 }, end: { line: 54, column: 335 } }
                })
            ) +
            '</a>\n                        </p>\n                        <p class="d-none d-print-inline">' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programEmailLabel', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 56, column: 57 }, end: { line: 56, column: 94 } }
                })
            ) +
            ' ' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'email') || (depth0 != null ? lookupProperty(depth0, 'email') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'email', hash: {}, data: data, loc: { start: { line: 56, column: 95 }, end: { line: 56, column: 104 } } })
                    : helper)
            ) +
            '</p>\n'
        );
    },
    '38': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'buttonDetails',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 64, column: 127 }, end: { line: 64, column: 151 } } }
            )
        );
    },
    '40': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'buttonViewEditDetails',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 64, column: 159 }, end: { line: 64, column: 191 } } }
            )
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="card-header">\n	<div class="program-title">\n		<h1 class="pl-3 ml-3">' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 3, column: 24 }, end: { line: 3, column: 32 } } })
                    : helper)
            ) +
            '</h1>\n		<button class="btn btn-favorite' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'isFavorite') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 4, column: 33 }, end: { line: 4, column: 62 } }
            })) != null
                ? stack1
                : '') +
            '" title="' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'isFavorite') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.program(5, data, 0),
                data: data,
                loc: { start: { line: 4, column: 71 }, end: { line: 4, column: 163 } }
            })) != null
                ? stack1
                : '') +
            '" data-action="favorite"></button>\n	</div>\n	<div class="program-vacancies">' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'vacanciesLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 6, column: 32 }, end: { line: 6, column: 57 } }
                })
            ) +
            ': <span>' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'vacancies') || (depth0 != null ? lookupProperty(depth0, 'vacancies') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'vacancies', hash: {}, data: data, loc: { start: { line: 6, column: 65 }, end: { line: 6, column: 78 } } })
                    : helper)
            ) +
            '</span></div>\n</div>\n<div class="card-body">\n	<div class="row">\n        <div class="col-12 col-lg-' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(7, data, 0),
                inverse: container.program(9, data, 0),
                data: data,
                loc: { start: { line: 10, column: 34 }, end: { line: 10, column: 73 } }
            })) != null
                ? stack1
                : '') +
            ' pl-4">\n			<h5>' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'addressLine'), depth0, {
                name: 'addressLine',
                data: data,
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'distanceMiles') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(11, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 11, column: 24 }, end: { line: 11, column: 140 } }
            })) != null
                ? stack1
                : '') +
            '</h5>\n			<p><span class="title">' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programTypeTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 12, column: 26 }, end: { line: 12, column: 53 } }
                })
            ) +
            '</span>: ' +
            alias4(
                (lookupProperty(helpers, 'enum_l10n') || (depth0 && lookupProperty(depth0, 'enum_l10n')) || alias2).call(alias1, {
                    name: 'enum_l10n',
                    hash: { id: depth0 != null ? lookupProperty(depth0, 'programTypeId') : depth0, property: 'programTypeId' },
                    data: data,
                    loc: { start: { line: 12, column: 62 }, end: { line: 12, column: 117 } }
                })
            ) +
            '</p>\n			<p><span class="title">' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'householdTypeTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 13, column: 26 }, end: { line: 13, column: 55 } }
                })
            ) +
            ':</span></p>\n			' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'householdTypeIds') : depth0, property: 'householdTypeIds' },
                data: data,
                loc: { start: { line: 14, column: 3 }, end: { line: 14, column: 65 } }
            })) != null
                ? stack1
                : '') +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(
                alias1,
                (stack1 = depth0 != null ? lookupProperty(depth0, 'serviceForDiagnosisTypeIds') : depth0) != null ? lookupProperty(stack1, 'length') : stack1,
                {
                    name: 'if',
                    hash: {},
                    fn: container.program(13, data, 0),
                    inverse: container.noop,
                    data: data,
                    loc: { start: { line: 15, column: 2 }, end: { line: 18, column: 9 } }
                }
            )) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(
                alias1,
                (stack1 = depth0 != null ? lookupProperty(depth0, 'canServeMAWaiversTypeIds') : depth0) != null ? lookupProperty(stack1, 'length') : stack1,
                {
                    name: 'if',
                    hash: {},
                    fn: container.program(15, data, 0),
                    inverse: container.noop,
                    data: data,
                    loc: { start: { line: 19, column: 8 }, end: { line: 22, column: 15 } }
                }
            )) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'payForGroup') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(17, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 23, column: 8 }, end: { line: 29, column: 15 } }
            })) != null
                ? stack1
                : '') +
            '		</div>\n		<div class="col-12 col-lg-' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(22, data, 0),
                inverse: container.program(24, data, 0),
                data: data,
                loc: { start: { line: 31, column: 28 }, end: { line: 31, column: 67 } }
            })) != null
                ? stack1
                : '') +
            ' images">\n			<div name="image" class="thumbnail">\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'urlThumbDisabled') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(26, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 33, column: 4 }, end: { line: 35, column: 15 } }
            })) != null
                ? stack1
                : '') +
            '			</div>\n			<div name="mapContent" class="map">\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'mapDisabled') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(28, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 38, column: 4 }, end: { line: 42, column: 15 } }
            })) != null
                ? stack1
                : '') +
            '			</div>\n		</div>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(31, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 45, column: 4 }, end: { line: 61, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '	</div>\n	<div class="bottom-buttons d-print-none">\n		<button class="btn btn-primary stretched-link" type="button" data-action="select" data-id="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 64, column: 93 }, end: { line: 64, column: 99 } } })
                    : helper)
            ) +
            '">' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(38, data, 0),
                inverse: container.program(40, data, 0),
                data: data,
                loc: { start: { line: 64, column: 101 }, end: { line: 64, column: 202 } }
            })) != null
                ? stack1
                : '') +
            '</button>\n	</div>\n</div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['programs'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = lookupProperty(helpers, 'unless').call(
                depth0 != null ? depth0 : container.nullContext || {},
                depth0 != null ? lookupProperty(depth0, 'popout') : depth0,
                {
                    name: 'unless',
                    hash: {},
                    fn: container.program(2, data, 0),
                    inverse: container.noop,
                    data: data,
                    loc: { start: { line: 2, column: 4 }, end: { line: 12, column: 15 } }
                }
            )) != null
                ? stack1
                : '') +
            '<div name="programsHeaderFilter"></div>\n<div name="console"></div>\n<div name="programsMap"></div>\n<div name="programsSidebarFilter"></div>\n<div name="programsSummaries"></div>\n<div name="programDetails"></div>\n'
        );
    },
    '2': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="col-12 m-0 p-0 mb-2">\n    <button class="btn btn-primary btn-wizard w-100" type="button" aria-expanded="false" name="wizard" data-action="wizard" ' +
            ((stack1 = (lookupProperty(helpers, 'analytics') || (depth0 && lookupProperty(depth0, 'analytics')) || alias2).call(alias1, {
                name: 'analytics',
                hash: { action: 'click.wizard', category: 'places.interface' },
                data: data,
                loc: { start: { line: 4, column: 124 }, end: { line: 4, column: 189 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'launchWizardTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 4, column: 190 }, end: { line: 4, column: 218 } }
                })
            ) +
            '</button>\n</div>\n<div class="col-6 m-0 p-0 pr-1 mb-2">\n    <button class="btn btn-primary btn-video w-100" type="button" aria-expanded="false" name="video" data-action="video" ' +
            ((stack1 = (lookupProperty(helpers, 'analytics') || (depth0 && lookupProperty(depth0, 'analytics')) || alias2).call(alias1, {
                name: 'analytics',
                hash: { action: 'click.video', category: 'places.interface' },
                data: data,
                loc: { start: { line: 7, column: 121 }, end: { line: 7, column: 185 } }
            })) != null
                ? stack1
                : '') +
            '><img src="' +
            ((stack1 = (lookupProperty(helpers, 'configuration') || (depth0 && lookupProperty(depth0, 'configuration')) || alias2).call(alias1, 'assetBase', {
                name: 'configuration',
                hash: {},
                data: data,
                loc: { start: { line: 7, column: 196 }, end: { line: 7, column: 227 } }
            })) != null
                ? stack1
                : '') +
            'images/video.svg" alt="" title="" class="img-video">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'helpVideoPrompt', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 7, column: 279 }, end: { line: 7, column: 305 } }
                })
            ) +
            '</button>\n</div>\n<div class="col-6 m-0 p-0 pl-1 mb-2">\n    <button class="btn btn-primary btn-about w-100" type="button" aria-expanded="false" name="about" data-action="about" ' +
            ((stack1 = (lookupProperty(helpers, 'analytics') || (depth0 && lookupProperty(depth0, 'analytics')) || alias2).call(alias1, {
                name: 'analytics',
                hash: { action: 'click.about', category: 'places.interface' },
                data: data,
                loc: { start: { line: 10, column: 121 }, end: { line: 10, column: 185 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'mobile') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.program(5, data, 0),
                data: data,
                loc: { start: { line: 10, column: 186 }, end: { line: 10, column: 270 } }
            })) != null
                ? stack1
                : '') +
            '</button>\n</div>\n'
        );
    },
    '3': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'buttonAbout',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 10, column: 200 }, end: { line: 10, column: 222 } } }
            )
        );
    },
    '5': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'aboutHB101PlacesPrompt',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 10, column: 230 }, end: { line: 10, column: 263 } } }
            )
        );
    },
    '7': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<aside class="col-12 col-md-4 ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(8, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 20, column: 30 }, end: { line: 20, column: 57 } }
            })) != null
                ? stack1
                : '') +
            '">\n    <div name="programsSidebarFilter"></div>\n</aside>\n<main class="col-12 ' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(10, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 23, column: 20 }, end: { line: 23, column: 57 } }
            })) != null
                ? stack1
                : '') +
            '">\n    <div name="programsMap"></div>\n    <div name="console"></div>\n    <div name="programsHeaderFilter"></div>\n    <div name="programsSummaries"></div>\n</main>\n<div name="programDetails"></div>\n'
        );
    },
    '8': function (container, depth0, helpers, partials, data) {
        return 'hidden';
    },
    '10': function (container, depth0, helpers, partials, data) {
        return 'col-md-8';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'if').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'mobile') : depth0,
            {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(7, data, 0),
                data: data,
                loc: { start: { line: 1, column: 0 }, end: { line: 30, column: 7 } }
            }
        )) != null
            ? stack1
            : '';
    },
    useData: true
});
templates['programsHeaderFilter'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return '-auto';
    },
    '3': function (container, depth0, helpers, partials, data) {
        var alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '            <button class="btn btn-primary btn-click-to-print mobile d-inline d-sm-none d-print-none" data-action="print" alt="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonClickToPrint', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 9, column: 127 }, end: { line: 9, column: 156 } }
                })
            ) +
            '", title="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonClickToPrint', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 9, column: 166 }, end: { line: 9, column: 195 } }
                })
            ) +
            '"></button>\n            <button class="btn btn-primary btn-click-to-print d-none d-sm-inline d-print-none" data-action="print">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonClickToPrint', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 10, column: 115 }, end: { line: 10, column: 144 } }
                })
            ) +
            '</button>\n'
        );
    },
    '5': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = container.invokePartial(lookupProperty(partials, 'iconButton'), depth0, {
                name: 'iconButton',
                hash: { tip: 'buttonPopoutPrograms', action: 'popout' },
                data: data,
                indent: '            ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'iconButton'), depth0, {
                name: 'iconButton',
                hash: { tip: 'buttonPrinterFriendly', action: 'popoutPrint' },
                data: data,
                indent: '            ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '            <a name="jumpReports" class="btn btn-primary btn-sm d-print-none btn-csv" href="#reports">Reports</a>\n'
        );
    },
    '7': function (container, depth0, helpers, partials, data) {
        return '    <div name="filtersList"></div>\n';
    },
    '9': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'mobile') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(10, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 24, column: 4 }, end: { line: 37, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '    <form class="programs-header-filter-wrapper row mt-2 mb-0" name="programsHeaderFilter">\n        <div class="col-12 col-md-5">\n            <div class="form-group row">\n                <label for="programsHeaderSort" class="text-nowrap col-auto pt-2">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'sortByLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 41, column: 82 }, end: { line: 41, column: 104 } }
                })
            ) +
            '</label>\n                <select class="form-control custom-select col mr-2" id="programsHeaderSort" name="sortby">\n                    <option></option>\n                    <option selected="true">distance</option>\n                    <option>name</option>\n                </select>\n            </div>\n        </div>\n        <div class="col-12 col-md-7">\n            <div class="form-group row">\n                <label for="programsHeaderKeywords" class="col-auto pt-2">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'findLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 51, column: 74 }, end: { line: 51, column: 94 } }
                })
            ) +
            '</label>\n                <div class="input-group col pl-0 pr-2">\n                    <input id="programsHeaderKeywords" class="form-control search" placeholder="Find within program summary..." name="keywords">\n                    <div name="searchIcon" class="input-group-append">\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'iconButton'), depth0, {
                name: 'iconButton',
                hash: { tip: 'buttonSearch', action: 'search' },
                data: data,
                indent: '                        ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '                    </div>\n                </div>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'iconButton'), depth0, {
                name: 'iconButton',
                hash: { disabled: true, tip: 'buttonClear', action: 'clear' },
                data: data,
                indent: '                ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '            </div>\n        </div>\n    </form>\n'
        );
    },
    '10': function (container, depth0, helpers, partials, data) {
        var alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '    <ul class="nav nav-tabs">\n        <li class="nav-item">\n            <a class="nav-link active" href="#" data-section="filters">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'tabFilters', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 27, column: 71 }, end: { line: 27, column: 92 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a class="nav-link" href="#" data-section="listings">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'tabPrograms', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 30, column: 65 }, end: { line: 30, column: 87 } }
                })
            ) +
            '</a>\n        </li>\n        <li class="nav-item">\n            <a class="nav-link" href="#" data-section="map">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'tabMap', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 33, column: 60 }, end: { line: 33, column: 77 } }
                })
            ) +
            '</a>\n        </li>\n    </ul>\n    <div name="filtersList"></div>\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="card-header" id="results">\n    <div class="row">\n        <div area-live="polite" class="col' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 3, column: 42 }, end: { line: 3, column: 68 } }
            })) != null
                ? stack1
                : '') +
            '">\n            <h1 name="foundCount"></h1>\n        </div>\n        <div class="col' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 6, column: 23 }, end: { line: 6, column: 57 } }
            })) != null
                ? stack1
                : '') +
            ' text-right">\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'iconButton'), depth0, {
                name: 'iconButton',
                hash: { tip: 'buttonShareList', action: 'share' },
                data: data,
                indent: '            ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.program(5, data, 0),
                data: data,
                loc: { start: { line: 8, column: 4 }, end: { line: 15, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '        </div>\n    </div>\n</div>\n<div class="card-body">\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(7, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 20, column: 0 }, end: { line: 22, column: 7 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'popout') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(9, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 23, column: 0 }, end: { line: 62, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '</div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['programsHeaderFilterFoundCount'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'programsLabel',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 1, column: 73 }, end: { line: 1, column: 97 } } }
            )
        );
    },
    '3': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'programLabel',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 1, column: 105 }, end: { line: 1, column: 128 } } }
            )
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'foundLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 21 } }
                })
            ) +
            ': <span name="count">' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'count') || (depth0 != null ? lookupProperty(depth0, 'count') : depth0)) != null ? helper : alias2),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'count', hash: {}, data: data, loc: { start: { line: 1, column: 42 }, end: { line: 1, column: 51 } } })
                    : helper)
            ) +
            '</span> ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'plural') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(3, data, 0),
                data: data,
                loc: { start: { line: 1, column: 59 }, end: { line: 1, column: 135 } }
            })) != null
                ? stack1
                : '') +
            '\n'
        );
    },
    useData: true
});
templates['programsMap'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '<div class="programs-spinner spinner-wrap program-loading d-flex justify-content-center align-items-center hidden">\n    <div class="spinner-border" role="status">\n        <span class="sr-only">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    'loading',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 3, column: 30 }, end: { line: 3, column: 48 } } }
                )
            ) +
            '</span>\n    </div>\n</div>\n<div name="mapContent"></div>\n'
        );
    },
    useData: true
});
templates['programsSidebarFilter'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '    <div class="help-buttons">\n        <div class="form-row">\n            <div class="col-12 col-sm-4 col-md-12">\n                <button class="btn btn-primary btn-wizard w-100 mb-2" type="button" aria-expanded="false" name="wizard" data-action="wizard" ' +
            ((stack1 = (lookupProperty(helpers, 'analytics') || (depth0 && lookupProperty(depth0, 'analytics')) || alias2).call(alias1, {
                name: 'analytics',
                hash: { action: 'click.wizard', category: 'places.interface' },
                data: data,
                loc: { start: { line: 5, column: 141 }, end: { line: 5, column: 206 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'launchWizardTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 5, column: 207 }, end: { line: 5, column: 235 } }
                })
            ) +
            '</button>\n            </div>\n            <div class="col-12 col-sm-4 col-md-6">\n                <button class="btn btn-primary btn-video w-100 mb-2" type="button" aria-expanded="false" name="video" data-action="video" ' +
            ((stack1 = (lookupProperty(helpers, 'analytics') || (depth0 && lookupProperty(depth0, 'analytics')) || alias2).call(alias1, {
                name: 'analytics',
                hash: { action: 'click.video', category: 'places.interface' },
                data: data,
                loc: { start: { line: 8, column: 138 }, end: { line: 8, column: 202 } }
            })) != null
                ? stack1
                : '') +
            '><img alt="Video" title="Video" src="' +
            ((stack1 = (lookupProperty(helpers, 'configuration') || (depth0 && lookupProperty(depth0, 'configuration')) || alias2).call(alias1, 'assetBase', {
                name: 'configuration',
                hash: {},
                data: data,
                loc: { start: { line: 8, column: 239 }, end: { line: 8, column: 270 } }
            })) != null
                ? stack1
                : '') +
            'images/video.svg" alt="" title="" class="img-video">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'helpVideoPrompt', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 8, column: 322 }, end: { line: 8, column: 348 } }
                })
            ) +
            '</button>\n            </div>\n            <div class="col-12 col-sm-4 col-md-6">\n                <button class="btn btn-primary btn-about w-100 mb-2" type="button" aria-expanded="false" name="about" data-action="about" ' +
            ((stack1 = (lookupProperty(helpers, 'analytics') || (depth0 && lookupProperty(depth0, 'analytics')) || alias2).call(alias1, {
                name: 'analytics',
                hash: { action: 'click.about', category: 'places.interface' },
                data: data,
                loc: { start: { line: 11, column: 138 }, end: { line: 11, column: 202 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'mobile') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(2, data, 0),
                inverse: container.program(4, data, 0),
                data: data,
                loc: { start: { line: 11, column: 203 }, end: { line: 11, column: 287 } }
            })) != null
                ? stack1
                : '') +
            '</button>\n            </div>\n        </div>\n    </div>\n'
        );
    },
    '2': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'buttonAbout',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 11, column: 217 }, end: { line: 11, column: 239 } } }
            )
        );
    },
    '4': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'aboutHB101PlacesPrompt',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 11, column: 247 }, end: { line: 11, column: 280 } } }
            )
        );
    },
    '6': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div name="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'key') || (data && lookupProperty(data, 'key'))) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'key', hash: {}, data: data, loc: { start: { line: 133, column: 19 }, end: { line: 133, column: 27 } } })
                    : helper)
            ) +
            'Card" class="card">\n            <div name="cardHeader" class="card-header">\n                <h2>\n                    <button class="btn btn-link stretched-link" data-toggle="collapse" data-target="#' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'key') || (data && lookupProperty(data, 'key'))) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'key', hash: {}, data: data, loc: { start: { line: 136, column: 101 }, end: { line: 136, column: 109 } } })
                    : helper)
            ) +
            'Card" type="button" aria-expanded="true">' +
            alias4(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'title') : depth0,
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 136, column: 150 }, end: { line: 136, column: 164 } } }
                )
            ) +
            ':</button>\n                </h2>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'help') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(7, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 138, column: 12 }, end: { line: 140, column: 19 } }
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="collapse show" id="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'key') || (data && lookupProperty(data, 'key'))) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'key', hash: {}, data: data, loc: { start: { line: 142, column: 43 }, end: { line: 142, column: 51 } } })
                    : helper)
            ) +
            'Card">\n                <div class="card-body">\n                    ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    skipOther: depth0 != null ? lookupProperty(depth0, 'skipOther') : depth0,
                    groupId: 0,
                    values: depth0,
                    property: data && lookupProperty(data, 'key')
                },
                data: data,
                loc: { start: { line: 144, column: 20 }, end: { line: 144, column: 95 } }
            })) != null
                ? stack1
                : '') +
            '\n                </div>\n            </div>\n        </div>\n'
        );
    },
    '7': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '                <button type="button" class="btn btn-secondary info" data-container="body" data-toggle="popover" data-placement="right"><span class="hidden">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    depth0 != null ? lookupProperty(depth0, 'help') : depth0,
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 139, column: 157 }, end: { line: 139, column: 170 } } }
                )
            ) +
            '</span></button>\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'mobile') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 0 }, end: { line: 15, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '    <div id="filters">\n        <div name="filtersCard" class="card filter-card">\n            <div name="cardHeader" class="card-header">\n                <h2 class="w-100">\n                    <button class="btn btn-link stretched-link" data-toggle="collapse" data-target="#filtersCard" type="button" aria-expanded="true">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'filtersTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 20, column: 149 }, end: { line: 20, column: 172 } }
                })
            ) +
            ':</button>\n                </h2>\n                <button type="button" data-action="listings" class="btn btn-secondary btn-sm d-block d-md-none mr-2 mt-2 float-right">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonViewPrograms', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 22, column: 134 }, end: { line: 22, column: 163 } }
                })
            ) +
            '</button>\n            </div>\n            <div class="collapse show" id="filtersCard">\n                <div class="card-body">\n                    <div name="filterSet"></div>\n                </div>\n            </div>\n        </div>\n      <form name="programsSidebarFilter">\n<!-- pseudofilters start -->\n        <div name="keywordsCard" class="card filter-card hidden">\n            <div name="cardHeader" class="card-header">\n                <h2>\n                    <button class="btn btn-link stretched-link" data-toggle="collapse" data-target="#keywordsCard" id="keywordsCardLabel" type="button" aria-expanded="true">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'keywordsTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 35, column: 173 }, end: { line: 35, column: 197 } }
                })
            ) +
            ':</button>\n                </h2>\n            </div>\n            <div class="collapse show" id="keywordsCard">\n                <div class="card-body">\n                    <div class="custom-control pl-0">\n                        <input type="text" class="form-control mt-0" id="keywords" name="keywords" aria-labelledby="keywordsCardLabel" placeholder="Find within program summary…">\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div name="sortbyCard" class="card filter-card hidden">\n            <div name="cardHeader" class="card-header">\n                <h2>\n                    <button class="btn btn-link stretched-link" data-toggle="collapse" data-target="#sortbyCard" id="sortbyCardLabel" type="button" aria-expanded="true">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'sortbyTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 49, column: 169 }, end: { line: 49, column: 191 } }
                })
            ) +
            ':</button>\n                </h2>\n            </div>\n            <div class="collapse show" id="sortbyCard">\n                <div class="card-body">\n                    <div class="custom-control pl-0">\n                        <input type="text" class="form-control mt-0" id="sortby" name="sortby" value="distance" aria-labelledby="sortbyCardLabel" placeholder="Sort by...">\n                    </div>\n                </div>\n            </div>\n        </div>\n<!-- pseudofilters end -->\n        <div name="distanceCard" class="card distance-card">\n            <div name="cardHeader" class="card-header">\n                <h2>\n                    <button class="btn btn-link stretched-link" data-toggle="collapse" data-target="#distanceCard" id="distanceCardLabel" type="button" aria-expanded="true">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'distanceTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 64, column: 173 }, end: { line: 64, column: 197 } }
                })
            ) +
            ':</button>\n                </h2>\n            </div>\n            <div class="collapse show" id="distanceCard">\n                <div class="card-body">\n                    <div class="mt-2">\n                        <input type="text" class="form-control mt-0" name="location"  aria-labelledby="distanceCardLabel"  placeholder="Enter a location...">\n                        <small name="locationComment" class="form-text text-muted truncate ml-1"></small>\n                        <input type="text" class="hidden" name="latitude" value="-1">\n                        <input type="text" class="hidden" name="longitude" value="-1">\n                    </div>\n                    <div class="d-flex justify-content-between">\n                        <div class="d-flex align-items-center">\n                            <select class="form-control custom-select" id="programsSidebarFilterMiles" name="miles">\n                                <option value="12450.5">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'all', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 78, column: 56 }, end: { line: 78, column: 70 } }
                })
            ) +
            '</option>\n                                <option value="10">10</option>\n                                <option value="50">50</option>\n                                <option value="100">100</option>\n                            </select>\n                            <label for="programsSidebarFilterMiles">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'milesLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 83, column: 68 }, end: { line: 83, column: 89 } }
                })
            ) +
            '</label>\n                        </div>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'iconButton'), depth0, {
                name: 'iconButton',
                hash: { tip: 'buttonGeolocate', action: 'geolocate' },
                data: data,
                indent: '                        ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '                    </div>\n                </div>\n            </div>\n        </div>\n        <div name="vacancyFavoritesProgramsCard" class="card">\n            <div name="cardHeader" class="card-header">\n                <h2>\n                    <button class="btn btn-link stretched-link" data-toggle="collapse" data-target="#vacancyFavoritesProgramsCard" type="button" aria-expanded="true">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'showLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 93, column: 166 }, end: { line: 93, column: 186 } }
                })
            ) +
            ':</button>\n                </h2>\n            </div>\n            <div class="collapse show" id="vacancyFavoritesProgramsCard">\n                <div class="card-body">\n                    <div name="vacancy" class="custom-control custom-checkbox">\n                        <input type="checkbox" class="custom-control-input" id="vacancy" name="vacancy" value="true" checked>\n                        <label class="custom-control-label" for="vacancy">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'publicSidebarVacancyAvailable', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 100, column: 74 }, end: { line: 100, column: 114 } }
                })
            ) +
            '</label>\n                    </div>\n                    <div name="isFavorite" class="hidden">\n                        <div class="pretty p-svg p-plain p-toggle">\n                            <input type="checkbox" id="isFavorite" name="isFavorite" value="true">\n                            <div class="state p-off">\n                                <img class="svg" src="' +
            ((stack1 = (lookupProperty(helpers, 'configuration') || (depth0 && lookupProperty(depth0, 'configuration')) || alias2).call(alias1, 'assetBase', {
                name: 'configuration',
                hash: {},
                data: data,
                loc: { start: { line: 106, column: 54 }, end: { line: 106, column: 85 } }
            })) != null
                ? stack1
                : '') +
            'images/favorite-no-sidebar.svg">\n                                <label>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'myFavoritesTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 107, column: 39 }, end: { line: 107, column: 66 } }
                })
            ) +
            '</label>\n                            </div>\n                            <div class="state p-on">\n                                <img class="svg" src="' +
            ((stack1 = (lookupProperty(helpers, 'configuration') || (depth0 && lookupProperty(depth0, 'configuration')) || alias2).call(alias1, 'assetBase', {
                name: 'configuration',
                hash: {},
                data: data,
                loc: { start: { line: 110, column: 54 }, end: { line: 110, column: 85 } }
            })) != null
                ? stack1
                : '') +
            'images/favorite-yes-sidebar.svg">\n                                <label>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'myFavoritesTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 111, column: 39 }, end: { line: 111, column: 66 } }
                })
            ) +
            '</label>\n                            </div>\n                        </div>\n                    </div>\n                    <div name="hasAdminAccess" class="custom-control custom-checkbox hidden">\n                        <input type="checkbox" class="custom-control-input" id="hasAdminAccess" name="hasAdminAccess" value="true">\n                        <label class="custom-control-label" for="hasAdminAccess">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'myProgramsTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 127, column: 81 }, end: { line: 127, column: 107 } }
                })
            ) +
            '</label>\n                    </div>\n                </div>\n            </div>\n        </div>\n' +
            ((stack1 = lookupProperty(helpers, 'each').call(alias1, depth0 != null ? lookupProperty(depth0, 'cards') : depth0, {
                name: 'each',
                hash: {},
                fn: container.program(6, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 132, column: 4 }, end: { line: 148, column: 13 } }
            })) != null
                ? stack1
                : '') +
            '        <input class="hidden" type="text" id="invalidateCache" name="invalidateCache">\n      </form>\n    </div>\n    <div name="wizard"></div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['programsSummaries'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="mt-3">' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: { addable: true, editable: false, name: 'organizations', display: 'programTitle', title: 'programsTitle' },
                data: data,
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '</div>\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = lookupProperty(helpers, 'if').call(
                depth0 != null ? depth0 : container.nullContext || {},
                depth0 != null ? lookupProperty(depth0, 'dashboard') : depth0,
                {
                    name: 'if',
                    hash: {},
                    fn: container.program(1, data, 0),
                    inverse: container.noop,
                    data: data,
                    loc: { start: { line: 1, column: 0 }, end: { line: 3, column: 7 } }
                }
            )) != null
                ? stack1
                : '') + '<div name="programsSummaries"></div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['radio'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="custom-control custom-radio">\n    <input type="radio" class="custom-control-input" id="g' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'groupId') || (depth0 != null ? lookupProperty(depth0, 'groupId') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'groupId', hash: {}, data: data, loc: { start: { line: 3, column: 58 }, end: { line: 3, column: 69 } } })
                    : helper)
            ) +
            '_' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 3, column: 70 }, end: { line: 3, column: 78 } } })
                    : helper)
            ) +
            '_' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 3, column: 79 }, end: { line: 3, column: 85 } } })
                    : helper)
            ) +
            '" name="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 3, column: 93 }, end: { line: 3, column: 101 } } })
                    : helper)
            ) +
            '" data-id="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 3, column: 112 }, end: { line: 3, column: 118 } } })
                    : helper)
            ) +
            '" value="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 3, column: 127 }, end: { line: 3, column: 133 } } })
                    : helper)
            ) +
            '" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'checked') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(2, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 3, column: 135 }, end: { line: 3, column: 164 } }
            })) != null
                ? stack1
                : '') +
            ' ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'disabled') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(4, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 3, column: 165 }, end: { line: 3, column: 196 } }
            })) != null
                ? stack1
                : '') +
            ' >\n    <label class="custom-control-label" for="g' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'groupId') || (depth0 != null ? lookupProperty(depth0, 'groupId') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'groupId', hash: {}, data: data, loc: { start: { line: 4, column: 46 }, end: { line: 4, column: 57 } } })
                    : helper)
            ) +
            '_' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 4, column: 58 }, end: { line: 4, column: 66 } } })
                    : helper)
            ) +
            '_' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 4, column: 67 }, end: { line: 4, column: 73 } } })
                    : helper)
            ) +
            '">' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'label') || (depth0 != null ? lookupProperty(depth0, 'label') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'label', hash: {}, data: data, loc: { start: { line: 4, column: 75 }, end: { line: 4, column: 84 } } })
                    : helper)
            ) +
            '</label>\n</div>\n'
        );
    },
    '2': function (container, depth0, helpers, partials, data) {
        return 'checked';
    },
    '4': function (container, depth0, helpers, partials, data) {
        return 'disabled';
    },
    '6': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<input type="radio" class="hidden" name="' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'name',
                          hash: {},
                          data: data,
                          loc: { start: { line: 8, column: 41 }, end: { line: 8, column: 49 } }
                      })
                    : helper)
            ) +
            '" data-id="-1" value="-1" checked>\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'unless').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'noSelectionSentry') : depth0,
            {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(6, data, 0),
                data: data,
                loc: { start: { line: 1, column: 0 }, end: { line: 9, column: 11 } }
            }
        )) != null
            ? stack1
            : '';
    },
    useData: true
});
templates['radioYesNo'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return 'checked';
    },
    '3': function (container, depth0, helpers, partials, data) {
        return 'disabled';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="custom-control custom-radio">\n  <input type="radio" id="g' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'groupId') || (depth0 != null ? lookupProperty(depth0, 'groupId') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'groupId', hash: {}, data: data, loc: { start: { line: 2, column: 27 }, end: { line: 2, column: 38 } } })
                    : helper)
            ) +
            '_' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'property') || (depth0 != null ? lookupProperty(depth0, 'property') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'property', hash: {}, data: data, loc: { start: { line: 2, column: 39 }, end: { line: 2, column: 51 } } })
                    : helper)
            ) +
            '_yes" name="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'property') || (depth0 != null ? lookupProperty(depth0, 'property') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'property', hash: {}, data: data, loc: { start: { line: 2, column: 63 }, end: { line: 2, column: 75 } } })
                    : helper)
            ) +
            '" value="true" class="custom-control-input" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'defaultYes') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 2, column: 119 }, end: { line: 2, column: 151 } }
            })) != null
                ? stack1
                : '') +
            ' ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'disabled') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 2, column: 152 }, end: { line: 2, column: 183 } }
            })) != null
                ? stack1
                : '') +
            '>\n  <label class="custom-control-label" for="g' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'groupId') || (depth0 != null ? lookupProperty(depth0, 'groupId') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'groupId', hash: {}, data: data, loc: { start: { line: 3, column: 44 }, end: { line: 3, column: 55 } } })
                    : helper)
            ) +
            '_' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'property') || (depth0 != null ? lookupProperty(depth0, 'property') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'property', hash: {}, data: data, loc: { start: { line: 3, column: 56 }, end: { line: 3, column: 68 } } })
                    : helper)
            ) +
            '_yes">Yes</label>\n</div>\n<div class="custom-control custom-radio">\n  <input type="radio" id="g' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'groupId') || (depth0 != null ? lookupProperty(depth0, 'groupId') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'groupId', hash: {}, data: data, loc: { start: { line: 6, column: 27 }, end: { line: 6, column: 38 } } })
                    : helper)
            ) +
            '_' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'property') || (depth0 != null ? lookupProperty(depth0, 'property') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'property', hash: {}, data: data, loc: { start: { line: 6, column: 39 }, end: { line: 6, column: 51 } } })
                    : helper)
            ) +
            '_no" name="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'property') || (depth0 != null ? lookupProperty(depth0, 'property') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'property', hash: {}, data: data, loc: { start: { line: 6, column: 62 }, end: { line: 6, column: 74 } } })
                    : helper)
            ) +
            '" value="false" class="custom-control-input" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'defaultNo') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 6, column: 119 }, end: { line: 6, column: 150 } }
            })) != null
                ? stack1
                : '') +
            ' ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'disabled') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 6, column: 151 }, end: { line: 6, column: 182 } }
            })) != null
                ? stack1
                : '') +
            '>\n  <label class="custom-control-label" for="g' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'groupId') || (depth0 != null ? lookupProperty(depth0, 'groupId') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'groupId', hash: {}, data: data, loc: { start: { line: 7, column: 44 }, end: { line: 7, column: 55 } } })
                    : helper)
            ) +
            '_' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'property') || (depth0 != null ? lookupProperty(depth0, 'property') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'property', hash: {}, data: data, loc: { start: { line: 7, column: 56 }, end: { line: 7, column: 68 } } })
                    : helper)
            ) +
            '_no">No</label>\n</div>\n'
        );
    },
    useData: true
});
templates['reports'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return 'selected';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: { addable: false, editable: false, name: 'reports', display: 'reportTitle', title: 'reportsTitle' },
                data: data,
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '<div class="row mt-4">\n    <div class="col-auto">\n        <select name="reportType" class="custom-select">\n            <option class="disabled" disabled ' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'reportType') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 5, column: 46 }, end: { line: 5, column: 87 } }
            })) != null
                ? stack1
                : '') +
            '>Select a report</option>\n            <option value="organizationsList" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'organizationsList') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 6, column: 46 }, end: { line: 6, column: 86 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'organizationsListReportTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 6, column: 87 }, end: { line: 6, column: 126 } }
                })
            ) +
            '</option>\n            <option value="organizationsEngagement" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'organizationsEngagement') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 7, column: 52 }, end: { line: 7, column: 98 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'organizationsEngagementReportTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 7, column: 99 }, end: { line: 7, column: 144 } }
                })
            ) +
            '</option>\n            <option value="organizationsToVerify" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'organizationsToVerify') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 8, column: 50 }, end: { line: 8, column: 94 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'organizationsToVerifyReportTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 8, column: 95 }, end: { line: 8, column: 138 } }
                })
            ) +
            '</option>\n            <option value="programsList" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'programsList') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 9, column: 41 }, end: { line: 9, column: 76 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programsListReportTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 9, column: 77 }, end: { line: 9, column: 111 } }
                })
            ) +
            '</option>\n            <option value="programsCounty" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'programsCounty') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 10, column: 43 }, end: { line: 10, column: 80 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programsCountyReportTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 10, column: 81 }, end: { line: 10, column: 117 } }
                })
            ) +
            '</option>\n            <option value="programsFiltered" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'programsFiltered') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 11, column: 45 }, end: { line: 11, column: 84 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programsFilteredReportTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 11, column: 85 }, end: { line: 11, column: 123 } }
                })
            ) +
            '</option>\n            <option value="programsToVerify" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'programsToVerify') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 12, column: 45 }, end: { line: 12, column: 84 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'programsToVerifyReportTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 12, column: 85 }, end: { line: 12, column: 123 } }
                })
            ) +
            '</option>\n        </select>\n    </div>\n    <div class="col">\n        <button type="button" data-action="saveCsv" class="btn btn-primary btn-sm float-right mr-3" disabled>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'saveCsvButton', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 16, column: 109 }, end: { line: 16, column: 133 } }
                })
            ) +
            '</button>\n    </div>\n</div>\n<div name="filtersList"></div>\n<div data-type="all" class="row mt-3 mb-0 d-none">\n    <div class="col pb-0">\n        <h3>Columns</h3>\n    </div>\n    <div class="col pt-0 pb-0">\n        <button class="btn btn-link pt-0 pb-0 mt-1 float-right reports-check-none" data-action="checkNone"></button>\n        <button class="btn btn-link pt-0 pb-0 pl-0 mt-1 float-right reports-check-all" data-action="checkAll"></button>\n    </div>\n</div>\n<form name="organizations" class="form-compact needs-validation" role="form" novalidate>\n    <div data-type="organizations" class="row d-none">\n        <div class="form-group col-3">\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_id" name="id" value="Id" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_id">Id</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_name" name="name" value="Organization Name" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_name">Organization Name</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_phone" name="phone" value="Phone" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_phone">Phone</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_address" name="address_derived" value="Address" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_address">Address</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_countyId" name="countyId" value="County" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_countyId">County</label>\n            </div>\n        </div>\n        <div class="form-group col-3">\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_primaryName" name="primaryName_derived" value="Primary Contact Name" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_primaryName">Primary Contact Name</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_primaryPhone" name="primaryPhone" value="Primary Contact Phone" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_primaryPhone">Primary Contact Phone</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_primaryEmail" name="primaryEmail" value="Primary Contact Email" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_primaryEmail">Primary Contact Email</label>\n            </div>\n        </div>\n        <div class="form-group col-3">\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_programs" name="programs" value="Program Count" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_programs">Program Count</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_vacancies" name="vacancies" value="Vacancy Count" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_vacancies">Vacancy Count</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_beds" name="beds" value="Bed Count" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_beds">Bed Count</label>\n            </div>\n        </div>\n        <div class="form-group col-3">\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_modifiedTime" name="modifiedTime" value="Date Last Modified" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_modifiedTime">Date Last Modified</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_daysSinceModified" name="daysSinceModified_derived" value="Days Since Last Modified" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_daysSinceModified">Days Since Last Modified</label>\n            </div>\n        </div>\n    </div>\n</form>\n<form name="programs" class="form-compact needs-validation" role="form" novalidate>\n    <div data-type="programs" class="row d-none">\n        <div data-columns="true" class="form-group col-3">\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="programsReportColumn_id" name="id" value="Id" checked>\n                <label class="custom-control-label" for="programsReportColumn_id">Id</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="organizationsReportColumn_organization" name="organizationId" value="Organization Name" checked>\n                <label class="custom-control-label" for="organizationsReportColumn_organization">Organization Name</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="programsReportColumn_name" name="name" value="Program Name" checked>\n                <label class="custom-control-label" for="programsReportColumn_name">Program Name</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="programsReportColumn_type" name="programTypeId" value="Program Type" checked>\n                <label class="custom-control-label" for="programsReportColumn_type">Program Type</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="programsReportColumn_address" name="address_derived" value="Address" checked>\n                <label class="custom-control-label" for="programsReportColumn_address">Address</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="programsReportColumn_countyId" name="countyId" value="County" checked>\n                <label class="custom-control-label" for="programsReportColumn_countyId">County</label>\n            </div>\n        </div>\n        <div data-columns="true" class="form-group col-3">\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="programsReportColumn_primaryName" name="primaryName_derived" value="Primary Contact Name" checked>\n                <label class="custom-control-label" for="programsReportColumn_primaryName">Primary Contact Name</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="programsReportColumn_primaryPhone" name="primaryPhone" value="Primary Contact Phone" checked>\n                <label class="custom-control-label" for="programsReportColumn_primaryPhone">Primary Contact Phone</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="programsReportColumn_primaryEmail" name="primaryEmail" value="Primary Contact Email" checked>\n                <label class="custom-control-label" for="programsReportColumn_primaryEmail">Primary Contact Email</label>\n            </div>\n        </div>\n        <div data-columns="true" class="form-group col-3">\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="programsReportColumn_units" name="units" value="Unit Count" checked>\n                <label class="custom-control-label" for="programsReportColumn_units">Unit Count</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="programsReportColumn_vacancies" name="vacancies" value="Vacancy Count" checked>\n                <label class="custom-control-label" for="programsReportColumn_vacancies">Vacancy Count</label>\n            </div>\n        </div>\n        <div data-columns="true" class="form-group col-3">\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="programsReportColumn_modifiedTime" name="modifiedTime" value="Date Last Modified" checked>\n                <label class="custom-control-label" for="programsReportColumn_modifiedTime">Date Last Modified</label>\n            </div>\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" class="custom-control-input" id="programsReportColumn_daysSinceModified" name="daysSinceModified_derived" value="Days Since Last Modified" checked>\n                <label class="custom-control-label" for="programsReportColumn_daysSinceModified">Days Since Last Modified</label>\n            </div>\n        </div>\n    </div>\n    <div data-type="programs" class="row d-none mt-2">\n        <div class="col pb-0">\n            <h3>Filters</h3>\n        </div>\n    </div>\n    <div data-type="programs" class="row d-none">\n        <div class="form-group col-3">\n            <div class="custom-control custom-checkbox">\n                <input type="checkbox" data-filter="true" class="custom-control-input" id="totalProgramsPerCounty" name="totalProgramsPerCounty_filter" value="true">\n                <label class="custom-control-label" for="totalProgramsPerCounty">Total Per County</label>\n            </div>\n        </div>\n    </div>\n</form>\n<div data-type="all" class="row mt-3 mb-0 d-none">\n    <div class="col-2 pt-0 pb-0">\n        <button class="btn btn-primary btn-sm" data-action="fetch">Fetch</button>\n    </div>\n    <div class="col-10">\n        <button type="button" data-action="saveCsv" class="btn btn-primary btn-sm float-right mr-3" disabled>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'saveCsvButton', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 175, column: 109 }, end: { line: 175, column: 133 } }
                })
            ) +
            '</button>\n    </div>\n</div>\n<div class="table">\n    <div data-name="table" class="content table-content mt-3">\n    </div>\n</div>\n<div data-name="csv" class="d-none">\n    <pre></pre>\n</div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['reportsTable'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return ' table-hot';
    },
    '3': function (container, depth0, helpers, partials, data) {
        return ' suppress-id';
    },
    '5': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                <th data-column="' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'column') || (depth0 != null ? lookupProperty(depth0, 'column') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'column', hash: {}, data: data, loc: { start: { line: 5, column: 33 }, end: { line: 5, column: 43 } } })
                    : helper)
            ) +
            '" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'sorted') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(6, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 5, column: 45 }, end: { line: 5, column: 89 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'src') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(8, data, 0),
                inverse: container.program(10, data, 0),
                data: data,
                loc: { start: { line: 5, column: 90 }, end: { line: 5, column: 201 } }
            })) != null
                ? stack1
                : '') +
            '</th>\n'
        );
    },
    '6': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            'class="sort ' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'sorted') || (depth0 != null ? lookupProperty(depth0, 'sorted') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'sorted',
                          hash: {},
                          data: data,
                          loc: { start: { line: 5, column: 71 }, end: { line: 5, column: 81 } }
                      })
                    : helper)
            ) +
            '"'
        );
    },
    '8': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<img src="' +
            ((stack1 =
                ((helper = (helper = lookupProperty(helpers, 'src') || (depth0 != null ? lookupProperty(depth0, 'src') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'src', hash: {}, data: data, loc: { start: { line: 5, column: 111 }, end: { line: 5, column: 120 } } })
                    : helper)) != null
                ? stack1
                : '') +
            '" class="column-icon" title="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'alt') || (depth0 != null ? lookupProperty(depth0, 'alt') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'alt', hash: {}, data: data, loc: { start: { line: 5, column: 149 }, end: { line: 5, column: 156 } } })
                    : helper)
            ) +
            '" alt="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'alt') || (depth0 != null ? lookupProperty(depth0, 'alt') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'alt', hash: {}, data: data, loc: { start: { line: 5, column: 163 }, end: { line: 5, column: 170 } } })
                    : helper)
            ) +
            '">'
        );
    },
    '10': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                depth0 != null ? lookupProperty(depth0, 'title') : depth0,
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 5, column: 180 }, end: { line: 5, column: 194 } } }
            )
        );
    },
    '12': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '            <tr data-ids-index=' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'index') || (data && lookupProperty(data, 'index'))) != null ? helper : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'index', hash: {}, data: data, loc: { start: { line: 11, column: 31 }, end: { line: 11, column: 41 } } })
                    : helper)
            ) +
            '>\n' +
            ((stack1 = lookupProperty(helpers, 'each').call(alias1, depth0, {
                name: 'each',
                hash: {},
                fn: container.program(13, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 12, column: 8 }, end: { line: 14, column: 17 } }
            })) != null
                ? stack1
                : '') +
            '            </tr>\n'
        );
    },
    '13': function (container, depth0, helpers, partials, data) {
        var helper,
            alias1 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                <td id="' +
            alias1(
                ((helper =
                    (helper = lookupProperty(helpers, 'index') || (data && lookupProperty(data, 'index'))) != null ? helper : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'index',
                          hash: {},
                          data: data,
                          loc: { start: { line: 13, column: 24 }, end: { line: 13, column: 34 } }
                      })
                    : helper)
            ) +
            '">' +
            alias1(container.lambda(depth0, depth0)) +
            '</td>\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '    <table class="table table-sm table-hover ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'hot') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 45 }, end: { line: 1, column: 73 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'suppressId') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 73 }, end: { line: 1, column: 110 } }
            })) != null
                ? stack1
                : '') +
            '">\n        <thead>\n            <tr>\n' +
            ((stack1 = lookupProperty(helpers, 'each').call(alias1, depth0 != null ? lookupProperty(depth0, 'columns') : depth0, {
                name: 'each',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 4, column: 4 }, end: { line: 6, column: 13 } }
            })) != null
                ? stack1
                : '') +
            '            </tr>\n        </thead>\n        <tbody>\n' +
            ((stack1 = lookupProperty(helpers, 'each').call(alias1, depth0 != null ? lookupProperty(depth0, 'rows') : depth0, {
                name: 'each',
                hash: {},
                fn: container.program(12, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 10, column: 4 }, end: { line: 16, column: 13 } }
            })) != null
                ? stack1
                : '') +
            '        </tbody>\n    </table>\n'
        );
    },
    useData: true
});
templates['sampleForm'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<form class="form-compact">\n    <div class="form-row align-items-center">\n        <div class="col-auto">\n            <label>Available date</label>\n            <input type="text" class="form-control" name="availableDate" placeholder="Available date">\n        </div>\n        <div class="col-auto">\n            <label>Status Type</label>\n            <div class="input-group mb-2">\n                <input type="text" class="form-control" name="statusType">\n            </div>\n        </div>\n        <div class="col-auto">\n            <label>Fill Reason</label>\n            <div class="input-group mb-2">\n                <input type="text" class="form-control" name="fillReason">\n            </div>\n        </div>\n        <div class="col-auto">\n            <div class="form-check mb-2">\n                <input class="form-check-input" type="checkbox" name="yesNo" id="autoSizingCheck">\n                <label class="form-check-label" for="autoSizingCheck">Yes/No</label>\n            </div>\n        </div>\n        <div class="col-auto">\n            <button name="save" class="btn btn-sm btn-link" data-action="save" data-section="image" disabled="disabled">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonSave', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 26, column: 120 }, end: { line: 26, column: 141 } }
                })
            ) +
            '</button>\n            <button name="cancel" class="btn btn-sm btn-link" data-action="cancel" data-section="image">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonCancel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 27, column: 104 }, end: { line: 27, column: 127 } }
                })
            ) +
            '</button>\n        </div>\n        <div class="hidden">\n            <input type="text" name="id" value="' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 30, column: 48 }, end: { line: 30, column: 54 } } })
                    : helper)
            ) +
            '">\n        </div>\n    </div>\n</form>\n'
        );
    },
    useData: true
});
templates['select'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            'id="' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'id',
                          hash: {},
                          data: data,
                          loc: { start: { line: 1, column: 22 }, end: { line: 1, column: 28 } }
                      })
                    : helper)
            ) +
            '"'
        );
    },
    '3': function (container, depth0, helpers, partials, data) {
        return ' disabled="true"';
    },
    '5': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '    <option value="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'value') || (depth0 != null ? lookupProperty(depth0, 'value') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'value', hash: {}, data: data, loc: { start: { line: 3, column: 19 }, end: { line: 3, column: 28 } } })
                    : helper)
            ) +
            '" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'selected') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(6, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 3, column: 30 }, end: { line: 3, column: 61 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'option') || (depth0 != null ? lookupProperty(depth0, 'option') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'option', hash: {}, data: data, loc: { start: { line: 3, column: 62 }, end: { line: 3, column: 72 } } })
                    : helper)
            ) +
            '</option>\n'
        );
    },
    '6': function (container, depth0, helpers, partials, data) {
        return 'selected';
    },
    '8': function (container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '    <input name="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 8, column: 17 }, end: { line: 8, column: 25 } } })
                    : helper)
            ) +
            '" type="text" class="hidden" value="' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'selectedValue') || (depth0 != null ? lookupProperty(depth0, 'selectedValue') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, {
                          name: 'selectedValue',
                          hash: {},
                          data: data,
                          loc: { start: { line: 8, column: 61 }, end: { line: 8, column: 78 } }
                      })
                    : helper)
            ) +
            '" />\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<select ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'id') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 8 }, end: { line: 1, column: 36 } }
            })) != null
                ? stack1
                : '') +
            ' name="' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 1, column: 43 }, end: { line: 1, column: 51 } } })
                    : helper)
            ) +
            '" class="form-control custom-select"' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'disabled') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 87 }, end: { line: 1, column: 126 } }
            })) != null
                ? stack1
                : '') +
            '>\n' +
            ((stack1 = lookupProperty(helpers, 'each').call(alias1, depth0 != null ? lookupProperty(depth0, 'options') : depth0, {
                name: 'each',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 2, column: 4 }, end: { line: 4, column: 13 } }
            })) != null
                ? stack1
                : '') +
            '</select>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'disabled') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(8, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 6, column: 0 }, end: { line: 9, column: 7 } }
            })) != null
                ? stack1
                : '')
        );
    },
    useData: true
});
templates['selectOptions'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<option value="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 2, column: 15 }, end: { line: 2, column: 21 } } })
                    : helper)
            ) +
            '"' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'selected') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(2, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 2, column: 22 }, end: { line: 2, column: 64 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 2, column: 65 }, end: { line: 2, column: 73 } } })
                    : helper)
            ) +
            '</option>\n'
        );
    },
    '2': function (container, depth0, helpers, partials, data) {
        return 'selected="selected"';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'each').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'options') : depth0,
            {
                name: 'each',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 0 }, end: { line: 3, column: 9 } }
            }
        )) != null
            ? stack1
            : '';
    },
    useData: true
});
templates['shareDialog'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        return 'modalLabel';
    },
    '3': function (container, depth0, helpers, partials, data) {
        return 'modalModalLabel';
    },
    '5': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'buttonShareCopyEmail',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 13, column: 384 }, end: { line: 13, column: 415 } } }
            )
        );
    },
    '7': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return container.escapeExpression(
            (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                'buttonShareCopy',
                { name: 'l10n', hash: {}, data: data, loc: { start: { line: 13, column: 423 }, end: { line: 13, column: 449 } } }
            )
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            alias4 = 'function',
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div class="modal-content" name="modalContent">\n            <div class="modal-header">\n                <h1 class="modal-title" id="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'modalModal') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.program(3, data, 0),
                data: data,
                loc: { start: { line: 3, column: 44 }, end: { line: 3, column: 110 } }
            })) != null
                ? stack1
                : '') +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'label') : depth0,
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 3, column: 112 }, end: { line: 3, column: 126 } } }
                )
            ) +
            '</h1>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'closeButton'), depth0, {
                name: 'closeButton',
                hash: { action: 'close' },
                data: data,
                indent: '                ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '            </div>\n            <div class="modal-body">\n                <!-- ' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'body') : depth0,
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 7, column: 21 }, end: { line: 7, column: 34 } } }
                )
            ) +
            ' -->\n                <textarea id="clipboardTarget" class="form-control mt-4" readonly>' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'copy') || (depth0 != null ? lookupProperty(depth0, 'copy') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'copy', hash: {}, data: data, loc: { start: { line: 8, column: 82 }, end: { line: 8, column: 90 } } })
                    : helper)
            ) +
            '</textarea>\n            </div>\n            <div class="modal-footer mt-3 pl-0 pr-0 ml-0 mr-0">\n                <div class="row w-100">\n                    <div class="col-6 pl-0 pr-0 ml-0 mr-0">\n                        <button type="button" class="btn btn-sm btn-primary btn-copy w-100" data-action="copy" id="clipboardButton" data-clipboard-target="#clipboardTarget" data-container="body" data-toggle="popover" data-placement="right" data-content="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'feedbackCopied', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 13, column: 254 }, end: { line: 13, column: 279 } }
                })
            ) +
            '"><img class="btn-img" alt="" title="" src="' +
            ((stack1 = (lookupProperty(helpers, 'configuration') || (depth0 && lookupProperty(depth0, 'configuration')) || alias2).call(alias1, 'assetBase', {
                name: 'configuration',
                hash: {},
                data: data,
                loc: { start: { line: 13, column: 323 }, end: { line: 13, column: 354 } }
            })) != null
                ? stack1
                : '') +
            'images/copy.svg">' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'email') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.program(7, data, 0),
                data: data,
                loc: { start: { line: 13, column: 371 }, end: { line: 13, column: 456 } }
            })) != null
                ? stack1
                : '') +
            '</button>\n                    </div>\n                </div>\n                <div class="row w-100">\n                    <div class="col-6 pl-0 pr-0 ml-0 mr-0">\n                        <!-- <button type="button" class="btn btn-sm btn-primary btn-email w-100" data-action="email"><img class="btn-img" alt="" title="" src="' +
            ((stack1 = (lookupProperty(helpers, 'configuration') || (depth0 && lookupProperty(depth0, 'configuration')) || alias2).call(alias1, 'assetBase', {
                name: 'configuration',
                hash: {},
                data: data,
                loc: { start: { line: 18, column: 160 }, end: { line: 18, column: 191 } }
            })) != null
                ? stack1
                : '') +
            'images/email.svg">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonShareEmail', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 18, column: 209 }, end: { line: 18, column: 236 } }
                })
            ) +
            '</button> -->\n                        <a class="btn btn-sm btn-primary btn-email w-100" target="_top" href="mailto:' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'href') || (depth0 != null ? lookupProperty(depth0, 'href') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'href', hash: {}, data: data, loc: { start: { line: 19, column: 101 }, end: { line: 19, column: 109 } } })
                    : helper)
            ) +
            '"><img class="btn-img" alt="" title="" src="' +
            ((stack1 = (lookupProperty(helpers, 'configuration') || (depth0 && lookupProperty(depth0, 'configuration')) || alias2).call(alias1, 'assetBase', {
                name: 'configuration',
                hash: {},
                data: data,
                loc: { start: { line: 19, column: 153 }, end: { line: 19, column: 184 } }
            })) != null
                ? stack1
                : '') +
            'images/email.svg">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonShareEmail', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 19, column: 202 }, end: { line: 19, column: 229 } }
                })
            ) +
            '</a>\n                    </div>\n                    <div class="col-6 pl-0 pr-0 ml-0 mr-0">\n                        <button type="button" class="btn btn-sm btn-secondary float-right" data-dismiss="modal" data-action="cancel">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonCancel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 22, column: 133 }, end: { line: 22, column: 156 } }
                })
            ) +
            '</button>\n                    </div>\n                </div>\n            </div>\n            <div class="sr-only">End of dialog</div>\n        </div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['table'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '    <h1>' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'title') || (depth0 != null ? lookupProperty(depth0, 'title') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'title',
                          hash: {},
                          data: data,
                          loc: { start: { line: 2, column: 8 }, end: { line: 2, column: 17 } }
                      })
                    : helper)
            ) +
            '</h1>\n'
        );
    },
    '3': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '    <span class="list-message">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    depth0 != null ? lookupProperty(depth0, 'message') : depth0,
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 5, column: 31 }, end: { line: 5, column: 47 } } }
                )
            ) +
            '</span>\n'
        );
    },
    '5': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'if').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'emptyMessage') : depth0,
            {
                name: 'if',
                hash: {},
                fn: container.program(6, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 7, column: 4 }, end: { line: 9, column: 11 } }
            }
        )) != null
            ? stack1
            : '';
    },
    '6': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '    <span class="empty-list-message">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    depth0 != null ? lookupProperty(depth0, 'emptyMessage') : depth0,
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 8, column: 37 }, end: { line: 8, column: 58 } } }
                )
            ) +
            '</span>\n'
        );
    },
    '8': function (container, depth0, helpers, partials, data) {
        return 'class="d-none"';
    },
    '10': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'if').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'icon') : depth0,
            {
                name: 'if',
                hash: {},
                fn: container.program(11, data, 0),
                inverse: container.program(16, data, 0),
                data: data,
                loc: { start: { line: 16, column: 12 }, end: { line: 20, column: 19 } }
            }
        )) != null
            ? stack1
            : '';
    },
    '11': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <th aria-role="button" name="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 17, column: 49 }, end: { line: 17, column: 57 } } })
                    : helper)
            ) +
            '"' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'sort') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(12, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 17, column: 58 }, end: { line: 17, column: 100 } }
            })) != null
                ? stack1
                : '') +
            ' ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'initialSortDescending') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(14, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 17, column: 101 }, end: { line: 17, column: 180 } }
            })) != null
                ? stack1
                : '') +
            '><img src="' +
            ((stack1 =
                ((helper = (helper = lookupProperty(helpers, 'src') || (depth0 != null ? lookupProperty(depth0, 'src') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'src', hash: {}, data: data, loc: { start: { line: 17, column: 191 }, end: { line: 17, column: 200 } } })
                    : helper)) != null
                ? stack1
                : '') +
            '" class="column-icon" title="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'alt') || (depth0 != null ? lookupProperty(depth0, 'alt') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'alt', hash: {}, data: data, loc: { start: { line: 17, column: 229 }, end: { line: 17, column: 236 } } })
                    : helper)
            ) +
            '" alt="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'alt') || (depth0 != null ? lookupProperty(depth0, 'alt') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'alt', hash: {}, data: data, loc: { start: { line: 17, column: 243 }, end: { line: 17, column: 250 } } })
                    : helper)
            ) +
            '"></th>\n'
        );
    },
    '12': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ' class="sort ' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'order') || (depth0 != null ? lookupProperty(depth0, 'order') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'order',
                          hash: {},
                          data: data,
                          loc: { start: { line: 17, column: 83 }, end: { line: 17, column: 92 } }
                      })
                    : helper)
            ) +
            '"'
        );
    },
    '14': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            'data-descending="' +
            container.escapeExpression(
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'initialSortDescending') || (depth0 != null ? lookupProperty(depth0, 'initialSortDescending') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'initialSortDescending',
                          hash: {},
                          data: data,
                          loc: { start: { line: 17, column: 147 }, end: { line: 17, column: 172 } }
                      })
                    : helper)
            ) +
            '"'
        );
    },
    '16': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = 'function',
            alias4 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <th aria-role="button" name="' +
            alias4(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 19, column: 49 }, end: { line: 19, column: 57 } } })
                    : helper)
            ) +
            '"' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'sort') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(12, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 19, column: 58 }, end: { line: 19, column: 100 } }
            })) != null
                ? stack1
                : '') +
            ' ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'initialSortDescending') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(14, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 19, column: 101 }, end: { line: 19, column: 180 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias4(
                ((helper =
                    (helper = lookupProperty(helpers, 'display') || (depth0 != null ? lookupProperty(depth0, 'display') : depth0)) != null ? helper : alias2),
                typeof helper === alias3
                    ? helper.call(alias1, { name: 'display', hash: {}, data: data, loc: { start: { line: 19, column: 181 }, end: { line: 19, column: 192 } } })
                    : helper)
            ) +
            '</th>\n'
        );
    },
    '18': function (container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                <tr data-id="' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 27, column: 29 }, end: { line: 27, column: 35 } } })
                    : helper)
            ) +
            '" ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'context') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(19, data, 0, blockParams, depths),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 27, column: 37 }, end: { line: 27, column: 85 } }
            })) != null
                ? stack1
                : '') +
            ' ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'edit') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(21, data, 0, blockParams, depths),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 27, column: 86 }, end: { line: 27, column: 119 } }
            })) != null
                ? stack1
                : '') +
            '>\n' +
            ((stack1 = lookupProperty(helpers, 'each').call(alias1, depth0 != null ? lookupProperty(depth0, 'values') : depth0, {
                name: 'each',
                hash: {},
                fn: container.program(23, data, 0, blockParams, depths),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 28, column: 12 }, end: { line: 30, column: 21 } }
            })) != null
                ? stack1
                : '') +
            '                </tr>\n'
        );
    },
    '19': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            'data-context="' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'context') || (depth0 != null ? lookupProperty(depth0, 'context') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'context',
                          hash: {},
                          data: data,
                          loc: { start: { line: 27, column: 66 }, end: { line: 27, column: 77 } }
                      })
                    : helper)
            ) +
            '"'
        );
    },
    '21': function (container, depth0, helpers, partials, data) {
        return 'class="hidden"';
    },
    '23': function (container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '                    <td ' +
            ((stack1 = lookupProperty(helpers, 'if').call(
                depth0 != null ? depth0 : container.nullContext || {},
                depths[1] != null ? lookupProperty(depths[1], 'colspan') : depths[1],
                {
                    name: 'if',
                    hash: {},
                    fn: container.program(24, data, 0, blockParams, depths),
                    inverse: container.noop,
                    data: data,
                    loc: { start: { line: 29, column: 24 }, end: { line: 29, column: 71 } }
                }
            )) != null
                ? stack1
                : '') +
            '>' +
            ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : '') +
            '</td>\n'
        );
    },
    '24': function (container, depth0, helpers, partials, data, blockParams, depths) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return 'colspan=' + container.escapeExpression(container.lambda(depths[1] != null ? lookupProperty(depths[1], 'colspan') : depths[1], depth0));
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data, blockParams, depths) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'title') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0, blockParams, depths),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 0 }, end: { line: 3, column: 7 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'message') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0, blockParams, depths),
                inverse: container.program(5, data, 0, blockParams, depths),
                data: data,
                loc: { start: { line: 4, column: 0 }, end: { line: 10, column: 7 } }
            })) != null
                ? stack1
                : '') +
            '    <div class="table-content">\n        <table class="table table-sm table-hover">\n            <thead ' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'emptyMessage') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(8, data, 0, blockParams, depths),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 13, column: 19 }, end: { line: 13, column: 60 } }
            })) != null
                ? stack1
                : '') +
            '>\n                <tr>\n' +
            ((stack1 = lookupProperty(helpers, 'each').call(alias1, depth0 != null ? lookupProperty(depth0, 'columns') : depth0, {
                name: 'each',
                hash: {},
                fn: container.program(10, data, 0, blockParams, depths),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 15, column: 8 }, end: { line: 21, column: 17 } }
            })) != null
                ? stack1
                : '') +
            '                </tr>\n            </thead>\n            <tbody>\n                </tr>\n' +
            ((stack1 = lookupProperty(helpers, 'each').call(alias1, depth0 != null ? lookupProperty(depth0, 'rows') : depth0, {
                name: 'each',
                hash: {},
                fn: container.program(18, data, 0, blockParams, depths),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 26, column: 8 }, end: { line: 32, column: 17 } }
            })) != null
                ? stack1
                : '') +
            '            </tbody>\n        </table>\n    </div>\n'
        );
    },
    useData: true,
    useDepths: true
});
templates['tableEditButton'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '<button data-action="edit" type="button" class="btn btn-edit text btn-sm float-right">' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    'buttonEdit',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 2, column: 86 }, end: { line: 2, column: 107 } } }
                )
            ) +
            '</button>\n'
        );
    },
    '3': function (container, depth0, helpers, partials, data) {
        return '<button data-action="edit" type="button" class="btn btn-edit icon btn-sm float-right">&nbsp;</button>\n';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'text') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 0 }, end: { line: 3, column: 7 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'icon') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 4, column: 0 }, end: { line: 6, column: 7 } }
            })) != null
                ? stack1
                : '')
        );
    },
    useData: true
});
templates['unitsList'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        return '<div name="units"></div>';
    },
    useData: true
});
templates['unitsListItem'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'if').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'vacancies') : depth0,
            {
                name: 'if',
                hash: {},
                fn: container.program(2, data, 0),
                inverse: container.program(4, data, 0),
                data: data,
                loc: { start: { line: 6, column: 4 }, end: { line: 38, column: 11 } }
            }
        )) != null
            ? stack1
            : '';
    },
    '2': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            alias4 = 'function',
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '            <div class="col-12 col-sm-6 col-md-4">\n                <!-- <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitNameTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 8, column: 72 }, end: { line: 8, column: 105 } }
                })
            ) +
            '</span> ' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 8, column: 113 }, end: { line: 8, column: 121 } } })
                    : helper)
            ) +
            '</p> -->\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitDescriptionTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 9, column: 67 }, end: { line: 9, column: 107 } }
                })
            ) +
            '</span> ' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'description') || (depth0 != null ? lookupProperty(depth0, 'description') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'description',
                          hash: {},
                          data: data,
                          loc: { start: { line: 9, column: 115 }, end: { line: 9, column: 130 } }
                      })
                    : helper)
            ) +
            '</p>\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitCategoryTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 10, column: 67 }, end: { line: 10, column: 108 } }
                })
            ) +
            '</span> ' +
            alias3(
                (lookupProperty(helpers, 'enum_l10n') || (depth0 && lookupProperty(depth0, 'enum_l10n')) || alias2).call(alias1, {
                    name: 'enum_l10n',
                    hash: { id: depth0 != null ? lookupProperty(depth0, 'unitCategoryTypeId') : depth0, property: 'unitCategoryTypeId' },
                    data: data,
                    loc: { start: { line: 10, column: 116 }, end: { line: 10, column: 181 } }
                })
            ) +
            '</p>\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitBedroomCountTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 11, column: 67 }, end: { line: 11, column: 108 } }
                })
            ) +
            '</span> ' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'bedroomCount') || (depth0 != null ? lookupProperty(depth0, 'bedroomCount') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'bedroomCount',
                          hash: {},
                          data: data,
                          loc: { start: { line: 11, column: 116 }, end: { line: 11, column: 132 } }
                      })
                    : helper)
            ) +
            '</p>\n            </div>\n            <div class="col-12 col-sm-6 col-md-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitBathroomTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 14, column: 67 }, end: { line: 14, column: 108 } }
                })
            ) +
            '</span> ' +
            alias3(
                (lookupProperty(helpers, 'enum_l10n') || (depth0 && lookupProperty(depth0, 'enum_l10n')) || alias2).call(alias1, {
                    name: 'enum_l10n',
                    hash: { id: depth0 != null ? lookupProperty(depth0, 'bathroomTypeId') : depth0, property: 'bathroomTypeId' },
                    data: data,
                    loc: { start: { line: 14, column: 116 }, end: { line: 14, column: 173 } }
                })
            ) +
            '</p>\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitNumberOfComparableUnitsTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 15, column: 67 }, end: { line: 15, column: 119 } }
                })
            ) +
            '</span> ' +
            alias3(
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'numberOfComparableUnits') || (depth0 != null ? lookupProperty(depth0, 'numberOfComparableUnits') : depth0)) !=
                    null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'numberOfComparableUnits',
                          hash: {},
                          data: data,
                          loc: { start: { line: 15, column: 127 }, end: { line: 15, column: 154 } }
                      })
                    : helper)
            ) +
            '</p>\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitRentDollarsTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 16, column: 67 }, end: { line: 16, column: 107 } }
                })
            ) +
            '</span> $' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'rentDollars') || (depth0 != null ? lookupProperty(depth0, 'rentDollars') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'rentDollars',
                          hash: {},
                          data: data,
                          loc: { start: { line: 16, column: 116 }, end: { line: 16, column: 131 } }
                      })
                    : helper)
            ) +
            '</p>\n            </div>\n<!--\n            <div class="col-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'notesTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 20, column: 67 }, end: { line: 20, column: 97 } }
                })
            ) +
            '</span> ' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'notes') || (depth0 != null ? lookupProperty(depth0, 'notes') : depth0)) != null ? helper : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'notes', hash: {}, data: data, loc: { start: { line: 20, column: 105 }, end: { line: 20, column: 114 } } })
                    : helper)
            ) +
            '</p>\n            </div>\n-->\n            <div class="col-12 col-sm-6 col-md-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'vacanciesTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 24, column: 67 }, end: { line: 24, column: 101 } }
                })
            ) +
            '</span> ' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'vacancies') || (depth0 != null ? lookupProperty(depth0, 'vacancies') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'vacancies',
                          hash: {},
                          data: data,
                          loc: { start: { line: 24, column: 109 }, end: { line: 24, column: 122 } }
                      })
                    : helper)
            ) +
            '</p>\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'accessibilityTypesTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 25, column: 67 }, end: { line: 25, column: 110 } }
                })
            ) +
            '</span> ' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'accessibilityTypeIds') : depth0, property: 'accessibilityTypeIds' },
                data: data,
                loc: { start: { line: 25, column: 118 }, end: { line: 25, column: 188 } }
            })) != null
                ? stack1
                : '') +
            '</p>\n            </div>\n'
        );
    },
    '4': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '            <div class="col-12 col-sm-6 col-md-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitNameTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 29, column: 67 }, end: { line: 29, column: 100 } }
                })
            ) +
            '</span> ' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null ? helper : alias2),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'name', hash: {}, data: data, loc: { start: { line: 29, column: 108 }, end: { line: 29, column: 116 } } })
                    : helper)
            ) +
            '</p>\n            </div>\n            <div class="col-12 col-sm-6 col-md-4">\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitCategoryTypeTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 32, column: 67 }, end: { line: 32, column: 108 } }
                })
            ) +
            '</span> ' +
            alias3(
                (lookupProperty(helpers, 'enum_l10n') || (depth0 && lookupProperty(depth0, 'enum_l10n')) || alias2).call(alias1, {
                    name: 'enum_l10n',
                    hash: { id: depth0 != null ? lookupProperty(depth0, 'unitCategoryTypeId') : depth0, property: 'unitCategoryTypeId' },
                    data: data,
                    loc: { start: { line: 32, column: 116 }, end: { line: 32, column: 181 } }
                })
            ) +
            '</p>\n            </div>\n            <div class="col-12 col-sm-6 col-md-4">\n                <p class="program-detail-item">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitNotAvailable', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 35, column: 47 }, end: { line: 35, column: 74 } }
                })
            ) +
            '</p>\n                <p class="program-detail-item"><span class="title">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'accessibilityTypesTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 36, column: 67 }, end: { line: 36, column: 110 } }
                })
            ) +
            '</span> ' +
            ((stack1 = (lookupProperty(helpers, 'enum_ul') || (depth0 && lookupProperty(depth0, 'enum_ul')) || alias2).call(alias1, {
                name: 'enum_ul',
                hash: { ids: depth0 != null ? lookupProperty(depth0, 'accessibilityTypeIds') : depth0, property: 'accessibilityTypeIds' },
                data: data,
                loc: { start: { line: 36, column: 118 }, end: { line: 36, column: 188 } }
            })) != null
                ? stack1
                : '') +
            '</p>\n            </div>\n'
        );
    },
    '6': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            alias4 = 'function',
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '        <div name="edit" class="edit ' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(7, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 42, column: 37 }, end: { line: 42, column: 72 } }
            })) != null
                ? stack1
                : '') +
            '">\n            <form name="unit" class="form-compact needs-validation" role="form" novalidate>\n                <div class="row">\n                    <div class="form-group col-12 col-md-6">\n                        <label class="title" for="name">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitNameTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 46, column: 56 }, end: { line: 46, column: 89 } }
                })
            ) +
            '</label>\n                        <input name="name" class="form-control" type="text" value="' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(9, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 47, column: 83 }, end: { line: 47, column: 120 } }
            })) != null
                ? stack1
                : '') +
            '" required />\n                        <div class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'requiredInvalidFeedback', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 48, column: 54 }, end: { line: 48, column: 88 } }
                })
            ) +
            '</div>\n                    </div>\n                    <div class="form-group col-12 col-sm-6 col-md-3">\n                        <label class="title" for="rentDollars">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitRentDollarsTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 51, column: 63 }, end: { line: 51, column: 103 } }
                })
            ) +
            '</label>\n                        <input name="rentDollars" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'rentDollars') || (depth0 != null ? lookupProperty(depth0, 'rentDollars') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'rentDollars',
                          hash: {},
                          data: data,
                          loc: { start: { line: 52, column: 90 }, end: { line: 52, column: 105 } }
                      })
                    : helper)
            ) +
            '" />\n                    </div>\n<!--\n                    <div class="form-group col-12 col-sm-6 col-md-3">\n                        <label class="title" for="vacancies">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'vacanciesTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 56, column: 61 }, end: { line: 56, column: 95 } }
                })
            ) +
            '</label>\n                        <input name="vacancies" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'vacancies') || (depth0 != null ? lookupProperty(depth0, 'vacancies') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'vacancies', hash: {}, data: data, loc: { start: { line: 57, column: 88 }, end: { line: 57, column: 101 } } })
                    : helper)
            ) +
            '" />\n                    </div>\n-->\n                </div>\n                <div class="row">\n                    <div class="form-group col-12 col-sm-6 col-md-4">\n                        <label class="title" for="bedroomCount">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitBedroomCountTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 63, column: 64 }, end: { line: 63, column: 105 } }
                })
            ) +
            '</label>\n                        <input name="bedroomCount" class="form-control" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'bedroomCount') || (depth0 != null ? lookupProperty(depth0, 'bedroomCount') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'bedroomCount',
                          hash: {},
                          data: data,
                          loc: { start: { line: 64, column: 91 }, end: { line: 64, column: 107 } }
                      })
                    : helper)
            ) +
            '" />\n                    </div>\n                    <div class="form-group col-12 col-sm-6 col-md-4">\n                        <label class="title" for="numberOfComparableUnits">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'unitNumberOfComparableUnitsTitle', {
                    name: 'l10n',
                    hash: { term: ':' },
                    data: data,
                    loc: { start: { line: 67, column: 75 }, end: { line: 67, column: 127 } }
                })
            ) +
            '</label>\n                        <input name="numberOfComparableUnits" class="form-control" type="number" min="1" required value="' +
            alias3(
                ((helper =
                    (helper =
                        lookupProperty(helpers, 'numberOfComparableUnits') || (depth0 != null ? lookupProperty(depth0, 'numberOfComparableUnits') : depth0)) !=
                    null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, {
                          name: 'numberOfComparableUnits',
                          hash: {},
                          data: data,
                          loc: { start: { line: 68, column: 121 }, end: { line: 68, column: 148 } }
                      })
                    : helper)
            ) +
            '" />\n                        <div class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(
                    alias1,
                    'numberOfComparableUnitsInvalidFeedback',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 69, column: 54 }, end: { line: 69, column: 103 } } }
                )
            ) +
            '</div>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="form-group col-12 col-sm-4">\n                        ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: {
                    selected: depth0 != null ? lookupProperty(depth0, 'unitStatusTypeId') : depth0,
                    property: 'unitStatusTypeId',
                    label: 'unitStatusTypeTitle'
                },
                data: data,
                loc: { start: { line: 74, column: 24 }, end: { line: 74, column: 123 } }
            })) != null
                ? stack1
                : '') +
            '\n                    </div>\n                    <div class="form-group col-12 col-sm-4">\n                        ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: {
                    selected: depth0 != null ? lookupProperty(depth0, 'unitCategoryTypeId') : depth0,
                    property: 'unitCategoryTypeId',
                    label: 'unitCategoryTypeTitle'
                },
                data: data,
                loc: { start: { line: 77, column: 24 }, end: { line: 77, column: 129 } }
            })) != null
                ? stack1
                : '') +
            '\n                    </div>\n                    <div class="form-group col-12 col-sm-4">\n                        ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: {
                    selected: depth0 != null ? lookupProperty(depth0, 'bathroomTypeId') : depth0,
                    property: 'bathroomTypeId',
                    label: 'unitBathroomTypeTitle'
                },
                data: data,
                loc: { start: { line: 80, column: 24 }, end: { line: 80, column: 121 } }
            })) != null
                ? stack1
                : '') +
            '\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="form-group col-12">\n                        ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    disabled: depth0 != null ? lookupProperty(depth0, 'create') : depth0,
                    includeNoSelectionSentry: true,
                    groupId: depth0 != null ? lookupProperty(depth0, 'id') : depth0,
                    values: depth0 != null ? lookupProperty(depth0, 'accessibilityTypeIds') : depth0,
                    property: 'accessibilityTypeIds',
                    label: 'accessibilityTypesTitle'
                },
                data: data,
                loc: { start: { line: 85, column: 24 }, end: { line: 85, column: 194 } }
            })) != null
                ? stack1
                : '') +
            '\n                        <!-- ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: {
                    disabled: depth0 != null ? lookupProperty(depth0, 'create') : depth0,
                    includeNoSelectionSentry: true,
                    groupId: depth0 != null ? lookupProperty(depth0, 'id') : depth0,
                    values: depth0 != null ? lookupProperty(depth0, 'householdTypeIds') : depth0,
                    property: 'householdTypeIds',
                    label: 'householdTypeTitle'
                },
                data: data,
                loc: { start: { line: 86, column: 29 }, end: { line: 86, column: 186 } }
            })) != null
                ? stack1
                : '') +
            ' -->\n                    </div>\n                </div>\n                <div class="hidden">\n                    <input name="programId" type="text" value="' +
            alias3(
                ((helper =
                    (helper = lookupProperty(helpers, 'programId') || (depth0 != null ? lookupProperty(depth0, 'programId') : depth0)) != null
                        ? helper
                        : alias2),
                typeof helper === alias4
                    ? helper.call(alias1, { name: 'programId', hash: {}, data: data, loc: { start: { line: 90, column: 63 }, end: { line: 90, column: 76 } } })
                    : helper)
            ) +
            '" />\n                </div>\n            </form>\n        </div> <!-- /edit -->\n'
        );
    },
    '7': function (container, depth0, helpers, partials, data) {
        return 'hidden';
    },
    '9': function (container, depth0, helpers, partials, data) {
        var helper,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return container.escapeExpression(
            ((helper =
                (helper = lookupProperty(helpers, 'name') || (depth0 != null ? lookupProperty(depth0, 'name') : depth0)) != null
                    ? helper
                    : container.hooks.helperMissing),
            typeof helper === 'function'
                ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                      name: 'name',
                      hash: {},
                      data: data,
                      loc: { start: { line: 47, column: 101 }, end: { line: 47, column: 109 } }
                  })
                : helper)
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div name="unit" class="unit section">\n    <div class="content" data-id="' +
            container.escapeExpression(
                ((helper =
                    (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 2, column: 34 }, end: { line: 2, column: 40 } } })
                    : helper)
            ) +
            '">\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: {
                    deleteable: true,
                    editable: depth0 != null ? lookupProperty(depth0, 'editable') : depth0,
                    name: 'unit',
                    nonTipTitle: depth0 != null ? lookupProperty(depth0, 'name') : depth0
                },
                data: data,
                indent: '        ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '        <div name="display" class="display row">\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 5, column: 0 }, end: { line: 39, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '        </div>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'editable') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(6, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 41, column: 4 }, end: { line: 94, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '    </div>\n    <div name="vacanciesList"></div>\n</div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['unitsSection'] = template({
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: {
                    addable: depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0,
                    editable: false,
                    name: 'units',
                    display: 'unitTypeTitle',
                    title: 'unitsTitle'
                },
                data: data,
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') + '<div name="unitsList"></div>\n'
        );
    },
    usePartial: true,
    useData: true
});
templates['vacanciesList'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="">' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'detailsSectionHeader'), depth0, {
                name: 'detailsSectionHeader',
                hash: {
                    addable: depth0 != null ? lookupProperty(depth0, 'hasAdminAccess') : depth0,
                    editable: false,
                    name: 'vacancy',
                    display: 'vacancyTitle',
                    title: 'vacanciesTitle'
                },
                data: data,
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '</div>\n<div name="table"></div>\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (stack1 = lookupProperty(helpers, 'unless').call(
            depth0 != null ? depth0 : container.nullContext || {},
            depth0 != null ? lookupProperty(depth0, 'empty') : depth0,
            {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 1, column: 0 }, end: { line: 4, column: 11 } }
            }
        )) != null
            ? stack1
            : '';
    },
    usePartial: true,
    useData: true
});
templates['vacancyEdit'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '            <label>Fill Reason</label>\n            <div class="input-group">\n                ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || container.hooks.helperMissing).call(
                depth0 != null ? depth0 : container.nullContext || {},
                {
                    name: 'enum_select',
                    hash: {
                        selected: depth0 != null ? lookupProperty(depth0, 'vacancyFillReasonTypeId') : depth0,
                        compact: true,
                        property: 'vacancyFillReasonTypeId'
                    },
                    data: data,
                    loc: { start: { line: 18, column: 16 }, end: { line: 18, column: 114 } }
                }
            )) != null
                ? stack1
                : '') +
            '\n            </div>\n'
        );
    },
    '3': function (container, depth0, helpers, partials, data) {
        var helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '            <button name="delete" class="btn btn-edit ml-1" data-action="delete" data-section="image" data-id="' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 25, column: 111 }, end: { line: 25, column: 117 } } })
                    : helper)
            ) +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonDelete', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 25, column: 119 }, end: { line: 25, column: 142 } }
                })
            ) +
            '</button>\n'
        );
    },
    '5': function (container, depth0, helpers, partials, data) {
        return 'disabled="disabled"';
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<form class="form-compact">\n    <div class="form-row align-items-center">\n        <div class="col-6 col-sm-3 col-md-2 order-2 order-md-1">\n            <label>Available date</label>\n            <input data-date="true" type="text" class="form-control" required pattern="\\d{4}-\\d{2}-\\d{2}" name="availableDate" placeholder="Available date" value="' +
            alias3(
                (lookupProperty(helpers, 'dateString') || (depth0 && lookupProperty(depth0, 'dateString')) || alias2).call(
                    alias1,
                    depth0 != null ? lookupProperty(depth0, 'availableDate') : depth0,
                    { name: 'dateString', hash: {}, data: data, loc: { start: { line: 5, column: 163 }, end: { line: 5, column: 191 } } }
                )
            ) +
            '">\n            <div class="invalid-feedback">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'dateInvalidFeedback', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 6, column: 42 }, end: { line: 6, column: 72 } }
                })
            ) +
            '</div>\n        </div>\n        <div class="col-6 col-sm-4 col-md-3 order-3 order-md-2">\n            <label>Status</label>\n            <div class="input-group">\n                ' +
            ((stack1 = (lookupProperty(helpers, 'enum_select') || (depth0 && lookupProperty(depth0, 'enum_select')) || alias2).call(alias1, {
                name: 'enum_select',
                hash: { selected: depth0 != null ? lookupProperty(depth0, 'vacancyStatusTypeId') : depth0, compact: true, property: 'vacancyStatusTypeId' },
                data: data,
                loc: { start: { line: 11, column: 16 }, end: { line: 11, column: 106 } }
            })) != null
                ? stack1
                : '') +
            '\n            </div>\n        </div>\n        <div class="col-12 col-sm-5 col-md-3 order-4 order-md-3">\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 15, column: 0 }, end: { line: 20, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '        </div>\n        <div class="col-12 col-md-4 order-1 order-md-4 mt-2 mb-1 text-right">\n            <button name="cancel" class="btn btn-edit" data-action="cancel" data-section="image">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonCancel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 23, column: 97 }, end: { line: 23, column: 120 } }
                })
            ) +
            '</button>\n' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'create') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 24, column: 8 }, end: { line: 26, column: 19 } }
            })) != null
                ? stack1
                : '') +
            '            <button name="save" class="btn btn-edit btn-primary ml-1" data-action="save" data-section="image" ' +
            ((stack1 = lookupProperty(helpers, 'unless').call(alias1, depth0 != null ? lookupProperty(depth0, 'saveEnabled') : depth0, {
                name: 'unless',
                hash: {},
                fn: container.program(5, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 27, column: 110 }, end: { line: 27, column: 163 } }
            })) != null
                ? stack1
                : '') +
            '>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonSave', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 27, column: 164 }, end: { line: 27, column: 185 } }
                })
            ) +
            '</button>\n        </div>\n        <div class="hidden">\n            <input type="text" name="id" value="' +
            alias3(
                ((helper = (helper = lookupProperty(helpers, 'id') || (depth0 != null ? lookupProperty(depth0, 'id') : depth0)) != null ? helper : alias2),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'id', hash: {}, data: data, loc: { start: { line: 30, column: 48 }, end: { line: 30, column: 54 } } })
                    : helper)
            ) +
            '">\n        </div>\n    </div>\n</form>\n'
        );
    },
    useData: true
});
templates['walkscore'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = container.escapeExpression,
            alias2 = container.lambda,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="walkscore">\n    <a target="_blank" href="' +
            alias1(
                ((helper =
                    (helper = lookupProperty(helpers, 'ws_link') || (depth0 != null ? lookupProperty(depth0, 'ws_link') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'ws_link',
                          hash: {},
                          data: data,
                          loc: { start: { line: 7, column: 29 }, end: { line: 7, column: 40 } }
                      })
                    : helper)
            ) +
            '"><h5 class="mb-0">Bike Score<sup>&reg;</sup>: ' +
            alias1(alias2((stack1 = depth0 != null ? lookupProperty(depth0, 'bicycle') : depth0) != null ? lookupProperty(stack1, 'score') : stack1, depth0)) +
            '</h5></a>\n    ' +
            alias1(
                alias2((stack1 = depth0 != null ? lookupProperty(depth0, 'bicycle') : depth0) != null ? lookupProperty(stack1, 'description') : stack1, depth0)
            ) +
            '\n</div>\n'
        );
    },
    '3': function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = container.escapeExpression,
            alias2 = container.lambda,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="walkscore">\n    <a target="_blank" href="' +
            alias1(
                ((helper =
                    (helper = lookupProperty(helpers, 'ws_link') || (depth0 != null ? lookupProperty(depth0, 'ws_link') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
                          name: 'ws_link',
                          hash: {},
                          data: data,
                          loc: { start: { line: 13, column: 29 }, end: { line: 13, column: 40 } }
                      })
                    : helper)
            ) +
            '"><h5 class="mb-0">Transit Score<sup>&reg;</sup>: ' +
            alias1(alias2((stack1 = depth0 != null ? lookupProperty(depth0, 'transit') : depth0) != null ? lookupProperty(stack1, 'score') : stack1, depth0)) +
            '</h5></a>\n    ' +
            alias1(
                alias2((stack1 = depth0 != null ? lookupProperty(depth0, 'transit') : depth0) != null ? lookupProperty(stack1, 'description') : stack1, depth0)
            ) +
            '\n</div>\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            helper,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.escapeExpression,
            alias3 = container.lambda,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="walkscore">\n    <a target="_blank" href="' +
            alias2(
                ((helper =
                    (helper = lookupProperty(helpers, 'ws_link') || (depth0 != null ? lookupProperty(depth0, 'ws_link') : depth0)) != null
                        ? helper
                        : container.hooks.helperMissing),
                typeof helper === 'function'
                    ? helper.call(alias1, { name: 'ws_link', hash: {}, data: data, loc: { start: { line: 2, column: 29 }, end: { line: 2, column: 40 } } })
                    : helper)
            ) +
            '"><h5 class="mb-0">Walk Score<sup>&reg;</sup>: ' +
            alias2(alias3((stack1 = depth0 != null ? lookupProperty(depth0, 'walk') : depth0) != null ? lookupProperty(stack1, 'score') : stack1, depth0)) +
            '</h5></a>\n    ' +
            alias2(
                alias3((stack1 = depth0 != null ? lookupProperty(depth0, 'walk') : depth0) != null ? lookupProperty(stack1, 'description') : stack1, depth0)
            ) +
            '\n</div>\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'bicycle') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 5, column: 0 }, end: { line: 10, column: 7 } }
            })) != null
                ? stack1
                : '') +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'transit') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(3, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 11, column: 0 }, end: { line: 16, column: 7 } }
            })) != null
                ? stack1
                : '')
        );
    },
    useData: true
});
templates['wizard'] = template({
    '1': function (container, depth0, helpers, partials, data) {
        var lookupProperty =
            container.lookupProperty ||
            function (parent, propertyName) {
                if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                    return parent[propertyName];
                }
                return undefined;
            };

        return (
            '        <p>' +
            container.escapeExpression(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || container.hooks.helperMissing).call(
                    depth0 != null ? depth0 : container.nullContext || {},
                    'quickStartLogon',
                    { name: 'l10n', hash: {}, data: data, loc: { start: { line: 113, column: 11 }, end: { line: 113, column: 37 } } }
                )
            ) +
            '</p>\n'
        );
    },
    compiler: [8, '>= 4.3.0'],
    main: function (container, depth0, helpers, partials, data) {
        var stack1,
            alias1 = depth0 != null ? depth0 : container.nullContext || {},
            alias2 = container.hooks.helperMissing,
            alias3 = container.escapeExpression,
            lookupProperty =
                container.lookupProperty ||
                function (parent, propertyName) {
                    if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
                        return parent[propertyName];
                    }
                    return undefined;
                };

        return (
            '<div class="clearfix">\n    <h1 class="float-left" id="modalLabel">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'quickStartTitle', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 2, column: 43 }, end: { line: 2, column: 69 } }
                })
            ) +
            '</h1>\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'closeButton'), depth0, {
                name: 'closeButton',
                hash: { action: 'close' },
                data: data,
                indent: '    ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '</div>\n<div class="content">\n    <div class="results d-none" name="results">\n        <span class="start" name="start">&nbsp;</span>\n        <span class="hidden" name="searching">Searching...</span>\n        <span class="hidden" name="programCount"></span>\n        <div class="filter-list" name="filtersList"></div>\n    </div>\n    <div name="form">\n        <form>\n            <div class="form-group" data-group="true">\n                <div class="quick-start-help-tip">' +
            ((stack1 = (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'hb101PlacesIncludes', {
                name: 'l10n',
                hash: {},
                data: data,
                loc: { start: { line: 15, column: 50 }, end: { line: 15, column: 82 } }
            })) != null
                ? stack1
                : '') +
            '</div>\n                <label for="">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'sharedLivingPrompt', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 16, column: 30 }, end: { line: 16, column: 59 } }
                })
            ) +
            '</label>\n                ' +
            ((stack1 = (lookupProperty(helpers, 'radiosYesNo') || (depth0 && lookupProperty(depth0, 'radiosYesNo')) || alias2).call(alias1, {
                name: 'radiosYesNo',
                hash: { groupId: 0.1, property: 'wantsOurServices' },
                data: data,
                loc: { start: { line: 17, column: 16 }, end: { line: 17, column: 73 } }
            })) != null
                ? stack1
                : '') +
            '\n                <input type="checkbox" class="hidden" name="vacancy" value="true" checked>\n            </div>\n            <div class="form-group hidden" data-group="true">\n                <div class="form-row">\n                    <div class="col">\n                        <label>' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'locationPrompt', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 23, column: 31 }, end: { line: 23, column: 56 } }
                })
            ) +
            '</label>\n                    </div>\n                </div>\n                <div class="form-row">\n                    <div class="col-11">\n                        <input type="text" class="form-control mt-1" name="location" aria-describedby="location" placeholder="Enter a location..." disabled>\n                        <small name="locationComment" class="form-text text-muted truncate ml-1"></small>\n                        <select class="form-control custom-select miles" id="wizardMiles" name="miles">\n                            <option value="12450.5">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'all', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 31, column: 52 }, end: { line: 31, column: 66 } }
                })
            ) +
            '</option>\n                            <option value="10">10</option>\n                            <option value="50">50</option>\n                            <option value="100">100</option>\n                        </select>\n                        <label for="wizardMiles">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'milesLabel', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 36, column: 49 }, end: { line: 36, column: 70 } }
                })
            ) +
            '</label>\n                    </div>\n                    <div class="col-1">\n                        <!-- <img name="geolocate" aria-role="button" alt="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonGeolocate', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 39, column: 75 }, end: { line: 39, column: 101 } }
                })
            ) +
            '" title="' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonGeolocate', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 39, column: 110 }, end: { line: 39, column: 136 } }
                })
            ) +
            '" src="' +
            ((stack1 = (lookupProperty(helpers, 'configuration') || (depth0 && lookupProperty(depth0, 'configuration')) || alias2).call(alias1, 'assetBase', {
                name: 'configuration',
                hash: {},
                data: data,
                loc: { start: { line: 39, column: 143 }, end: { line: 39, column: 174 } }
            })) != null
                ? stack1
                : '') +
            'images/geolocate.svg" class="img-thumbnail float-right"> -->\n' +
            ((stack1 = container.invokePartial(lookupProperty(partials, 'iconButton'), depth0, {
                name: 'iconButton',
                hash: { tip: 'buttonGeolocate', action: 'geolocate' },
                data: data,
                indent: '                        ',
                helpers: helpers,
                partials: partials,
                decorators: container.decorators
            })) != null
                ? stack1
                : '') +
            '                    </div>\n                </div>\n                <input type="text" class="hidden" name="latitude" value="-1">\n                <input type="text" class="hidden" name="longitude" value="-1">\n            </div>\n            <div class="form-group hidden" data-group="true">\n                <label for="">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'householdTypePrompt', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 47, column: 30 }, end: { line: 47, column: 60 } }
                })
            ) +
            '</label>\n                ' +
            ((stack1 = (lookupProperty(helpers, 'enum_radios') || (depth0 && lookupProperty(depth0, 'enum_radios')) || alias2).call(alias1, {
                name: 'enum_radios',
                hash: { disabled: true, skipOther: true, groupId: 0.1, values: depth0, property: 'householdTypeIds' },
                data: data,
                loc: { start: { line: 48, column: 16 }, end: { line: 48, column: 112 } }
            })) != null
                ? stack1
                : '') +
            '\n            </div>\n            <div class="form-group hidden" data-group="true">\n                <label for="">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'serviceForDiagnosisTypePrompt', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 51, column: 30 }, end: { line: 51, column: 70 } }
                })
            ) +
            '</label>\n                ' +
            ((stack1 = (lookupProperty(helpers, 'enum_checkboxes') || (depth0 && lookupProperty(depth0, 'enum_checkboxes')) || alias2).call(alias1, {
                name: 'enum_checkboxes',
                hash: { disabled: true, skipOther: true, groupId: 0.1, values: depth0, property: 'serviceForDiagnosisTypeIds' },
                data: data,
                loc: { start: { line: 52, column: 16 }, end: { line: 52, column: 126 } }
            })) != null
                ? stack1
                : '') +
            '\n            </div>\n            <div class="form-group hidden" data-group="true">\n                <label for="">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'canServeMAWaiversTypePrompt', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 55, column: 30 }, end: { line: 55, column: 68 } }
                })
            ) +
            '</label>\n                <div class="custom-control custom-radio">\n                    <input type="radio" class="custom-control-input" id="g0.1_canServeMAWaiversTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeTBI', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 57, column: 103 }, end: { line: 57, column: 143 } }
                })
            ) +
            '" name="canServeMAWaiversTypeIds" data-id="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeTBI', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 57, column: 186 }, end: { line: 57, column: 226 } }
                })
            ) +
            '" value="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeTBI', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 57, column: 235 }, end: { line: 57, column: 275 } }
                })
            ) +
            '" disabled="disabled">\n                    <label class="custom-control-label" for="g0.1_canServeMAWaiversTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeTBI', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 58, column: 91 }, end: { line: 58, column: 131 } }
                })
            ) +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'canServeMAWaiversTypeTBI', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 58, column: 133 }, end: { line: 58, column: 168 } }
                })
            ) +
            '</label>\n                </div>\n                <div class="custom-control custom-radio">\n                    <input type="radio" class="custom-control-input" id="g0.1_canServeMAWaiversTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeCAC', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 61, column: 103 }, end: { line: 61, column: 143 } }
                })
            ) +
            '" name="canServeMAWaiversTypeIds" data-id="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeCAC', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 61, column: 186 }, end: { line: 61, column: 226 } }
                })
            ) +
            '" value="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeCAC', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 61, column: 235 }, end: { line: 61, column: 275 } }
                })
            ) +
            '" disabled="disabled">\n                    <label class="custom-control-label" for="g0.1_canServeMAWaiversTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeCAC', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 62, column: 91 }, end: { line: 62, column: 131 } }
                })
            ) +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'canServeMAWaiversTypeCAC', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 62, column: 133 }, end: { line: 62, column: 168 } }
                })
            ) +
            '</label>\n                </div>\n                <div class="custom-control custom-radio">\n                    <input type="radio" class="custom-control-input" id="g0.1_canServeMAWaiversTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeCADI', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 65, column: 103 }, end: { line: 65, column: 144 } }
                })
            ) +
            '" name="canServeMAWaiversTypeIds" data-id="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeCADI', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 65, column: 187 }, end: { line: 65, column: 228 } }
                })
            ) +
            '" value="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeCADI', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 65, column: 237 }, end: { line: 65, column: 278 } }
                })
            ) +
            '" disabled="disabled">\n                    <label class="custom-control-label" for="g0.1_canServeMAWaiversTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeCADI', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 66, column: 91 }, end: { line: 66, column: 132 } }
                })
            ) +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'canServeMAWaiversTypeCADI', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 66, column: 134 }, end: { line: 66, column: 170 } }
                })
            ) +
            '</label>\n                </div>\n                <div class="custom-control custom-radio">\n                    <input type="radio" class="custom-control-input" id="g0.1_canServeMAWaiversTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeDD', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 69, column: 103 }, end: { line: 69, column: 142 } }
                })
            ) +
            '" name="canServeMAWaiversTypeIds" data-id="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeDD', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 69, column: 185 }, end: { line: 69, column: 224 } }
                })
            ) +
            '" value="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeDD', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 69, column: 233 }, end: { line: 69, column: 272 } }
                })
            ) +
            '" disabled="disabled">\n                    <label class="custom-control-label" for="g0.1_canServeMAWaiversTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'canServeMAWaiversTypeDD', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 70, column: 91 }, end: { line: 70, column: 130 } }
                })
            ) +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'canServeMAWaiversTypeDD', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 70, column: 132 }, end: { line: 70, column: 166 } }
                })
            ) +
            '</label>\n                </div>\n                <div class="custom-control custom-radio">\n                    <input type="radio" class="custom-control-input" id="g0.1_canServeMAWaiversTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(
                    alias1,
                    'canServeMAWaiversTypeElderly',
                    { name: 'codeValue', hash: {}, data: data, loc: { start: { line: 73, column: 103 }, end: { line: 73, column: 147 } } }
                )
            ) +
            '" name="canServeMAWaiversTypeIds" data-id="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(
                    alias1,
                    'canServeMAWaiversTypeElderly',
                    { name: 'codeValue', hash: {}, data: data, loc: { start: { line: 73, column: 190 }, end: { line: 73, column: 234 } } }
                )
            ) +
            '" value="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(
                    alias1,
                    'canServeMAWaiversTypeElderly',
                    { name: 'codeValue', hash: {}, data: data, loc: { start: { line: 73, column: 243 }, end: { line: 73, column: 287 } } }
                )
            ) +
            '" disabled="disabled">\n                    <label class="custom-control-label" for="g0.1_canServeMAWaiversTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(
                    alias1,
                    'canServeMAWaiversTypeElderly',
                    { name: 'codeValue', hash: {}, data: data, loc: { start: { line: 74, column: 91 }, end: { line: 74, column: 135 } } }
                )
            ) +
            '">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'canServeMAWaiversTypeElderly', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 74, column: 137 }, end: { line: 74, column: 176 } }
                })
            ) +
            '</label>\n                </div>\n                <div class="custom-control custom-radio">\n                    <input type="radio" class="custom-control-input" id="g0.1_canServeMAWaiversType_NO" name="canServeMAWaiversTypeIds" data-id="" value="-1" checked="checked" disabled="disabled">\n                    <label class="custom-control-label" for="g0.1_canServeMAWaiversType_NO">No, none of these</label>\n                </div>\n                <div class="custom-control custom-radio">\n                    <input type="radio" class="custom-control-input" id="g0.1_canServeMAWaiversType_DONT_KNOW" name="canServeMAWaiversTypeIds" data-id="" value="-1" checked="checked" disabled="disabled">\n                    <label class="custom-control-label" for="g0.1_canServeMAWaiversType_DONT_KNOW">I don\'t know</label>\n                </div>\n            </div>\n            <div class="form-group hidden" data-group="true">\n                <label for="">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'petPolicyTypePrompt', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 86, column: 30 }, end: { line: 86, column: 60 } }
                })
            ) +
            '</label>\n                <div class="custom-control custom-radio">\n                    <input type="radio" class="custom-control-input" id="g0.1_petPolicyTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'petPolicyTypeCatsAllowed', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 88, column: 95 }, end: { line: 88, column: 135 } }
                })
            ) +
            '" name="petPolicyTypeIds" data-id="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'petPolicyTypeCatsAllowed', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 88, column: 170 }, end: { line: 88, column: 210 } }
                })
            ) +
            '" value="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'petPolicyTypeCatsAllowed', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 88, column: 219 }, end: { line: 88, column: 259 } }
                })
            ) +
            '" disabled="disabled">\n                    <label class="custom-control-label" for="g0.1_petPolicyTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'petPolicyTypeCatsAllowed', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 89, column: 83 }, end: { line: 89, column: 123 } }
                })
            ) +
            '">Yes, I have a cat</label>\n                </div>\n                <div class="custom-control custom-radio">\n                    <input type="radio" class="custom-control-input" id="g0.1_petPolicyTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'petPolicyTypeDogsAllowed', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 92, column: 95 }, end: { line: 92, column: 135 } }
                })
            ) +
            '" name="petPolicyTypeIds" data-id="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'petPolicyTypeDogsAllowed', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 92, column: 170 }, end: { line: 92, column: 210 } }
                })
            ) +
            '" value="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'petPolicyTypeDogsAllowed', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 92, column: 219 }, end: { line: 92, column: 259 } }
                })
            ) +
            '" disabled="disabled">\n                    <label class="custom-control-label" for="g0.1_petPolicyTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'petPolicyTypeDogsAllowed', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 93, column: 83 }, end: { line: 93, column: 123 } }
                })
            ) +
            '">Yes, I have a dog</label>\n                </div>\n                <div class="custom-control custom-radio">\n                    <input type="radio" class="custom-control-input" id="g0.1_petPolicyTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'petPolicyTypeOther', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 96, column: 95 }, end: { line: 96, column: 129 } }
                })
            ) +
            '" name="petPolicyTypeIds" data-id="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'petPolicyTypeOther', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 96, column: 164 }, end: { line: 96, column: 198 } }
                })
            ) +
            '" value="' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'petPolicyTypeOther', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 96, column: 207 }, end: { line: 96, column: 241 } }
                })
            ) +
            '" disabled="disabled">\n                    <label class="custom-control-label" for="g0.1_petPolicyTypeIds_' +
            alias3(
                (lookupProperty(helpers, 'codeValue') || (depth0 && lookupProperty(depth0, 'codeValue')) || alias2).call(alias1, 'petPolicyTypeOther', {
                    name: 'codeValue',
                    hash: {},
                    data: data,
                    loc: { start: { line: 97, column: 83 }, end: { line: 97, column: 117 } }
                })
            ) +
            '">Yes, I have another pet</label>\n                </div>\n                <div class="custom-control custom-radio">\n                    <input type="radio" class="custom-control-input" id="g0.1_petPolicyType_NO" name="petPolicyTypeIds" data-id="" value="-1" checked="checked" disabled="disabled">\n                    <label class="custom-control-label" for="g0.1_petPolicyType_NO">No, I don\'t have a pet</label>\n                </div>\n            </div>\n        </form>\n        <div>\n            <button type="button" class="btn btn-sm btn-secondary" data-action="previous" disabled="disabled">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonPrevious', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 106, column: 110 }, end: { line: 106, column: 135 } }
                })
            ) +
            '</button>\n            <button type="button" class="btn btn-sm btn-primary" data-action="next" data-tab-position="last">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonNext', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 107, column: 109 }, end: { line: 107, column: 130 } }
                })
            ) +
            '</button>\n        </div>\n    </div>\n    <div class="hidden" name="congratulations">\n        ' +
            ((stack1 = (lookupProperty(helpers, 'l10n_raw') || (depth0 && lookupProperty(depth0, 'l10n_raw')) || alias2).call(
                alias1,
                'congratulationsPlacesText',
                { name: 'l10n_raw', hash: {}, data: data, loc: { start: { line: 111, column: 8 }, end: { line: 111, column: 50 } } }
            )) != null
                ? stack1
                : '') +
            '\n' +
            ((stack1 = lookupProperty(helpers, 'if').call(alias1, depth0 != null ? lookupProperty(depth0, 'isGuest') : depth0, {
                name: 'if',
                hash: {},
                fn: container.program(1, data, 0),
                inverse: container.noop,
                data: data,
                loc: { start: { line: 112, column: 4 }, end: { line: 114, column: 11 } }
            })) != null
                ? stack1
                : '') +
            '        <div>\n            <button type="button" class="btn btn-sm btn-secondary" data-action="changeAnswers">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonChangeAnswers', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 116, column: 95 }, end: { line: 116, column: 125 } }
                })
            ) +
            '</button>\n            <button type="button" class="btn btn-sm btn-primary" data-action="closeWizard" data-tab-position="last">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonViewThePlaces', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 117, column: 116 }, end: { line: 117, column: 146 } }
                })
            ) +
            '</button>\n        </div>\n    </div>\n    <div class="hidden" name="oops">\n        ' +
            ((stack1 = (lookupProperty(helpers, 'l10n_raw') || (depth0 && lookupProperty(depth0, 'l10n_raw')) || alias2).call(alias1, 'oopsPlacesText', {
                name: 'l10n_raw',
                hash: {},
                data: data,
                loc: { start: { line: 121, column: 8 }, end: { line: 121, column: 39 } }
            })) != null
                ? stack1
                : '') +
            '\n        <div>\n            <button type="button" class="btn btn-sm btn-secondary" data-action="changeAnswers">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonChangeAnswers', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 123, column: 95 }, end: { line: 123, column: 125 } }
                })
            ) +
            '</button>\n            <button type="button" class="btn btn-sm btn-primary" data-action="jumpToHb101" data-tab-position="last">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonTakeMeBack', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 124, column: 116 }, end: { line: 124, column: 143 } }
                })
            ) +
            '</button>\n        </div>\n    </div>\n    <div class="hidden" name="sorry">\n        ' +
            ((stack1 = (lookupProperty(helpers, 'l10n_raw') || (depth0 && lookupProperty(depth0, 'l10n_raw')) || alias2).call(alias1, 'sorryNoPlacesText', {
                name: 'l10n_raw',
                hash: {},
                data: data,
                loc: { start: { line: 128, column: 8 }, end: { line: 128, column: 42 } }
            })) != null
                ? stack1
                : '') +
            '\n        <div>\n            <button type="button" class="btn btn-sm btn-secondary" data-action="changeAnswers">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonChangeAnswers', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 130, column: 95 }, end: { line: 130, column: 125 } }
                })
            ) +
            '</button>\n            <button type="button" class="btn btn-sm btn-primary" data-action="closeWizard" data-tab-position="last">' +
            alias3(
                (lookupProperty(helpers, 'l10n') || (depth0 && lookupProperty(depth0, 'l10n')) || alias2).call(alias1, 'buttonViewTheFilters', {
                    name: 'l10n',
                    hash: {},
                    data: data,
                    loc: { start: { line: 131, column: 116 }, end: { line: 131, column: 147 } }
                })
            ) +
            '</button>\n        </div>\n    </div>\n    <div class="sr-only">End of dialog</div>\n</div>\n'
        );
    },
    usePartial: true,
    useData: true
});
